webpackJsonp([3],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Snappy = {

  init: function init() {
    document.addEventListener('DOMContentLoaded', this.onDOMLoaded.bind(this));
    (0, _jquery2.default)(window).on('content:updated', this.renderComponents.bind(this));
  },

  onDOMLoaded: function onDOMLoaded(event) {
    this.renderComponents();
  },

  renderComponents: function renderComponents() {
    var _this = this;

    var _loop = function _loop(key) {
      var elements = document.querySelectorAll('[data-' + _this.Component[key].tagName + ']:not([data-defer-snappy])');
      elements = Array.prototype.slice.call(elements);

      elements.forEach(function (element) {
        var isInited = element.getAttribute('data-' + this.Component[key].tagName + '-inited');

        if (typeof isInited === 'string') {
          return;
        }

        var component = new this.Component[key](element);
        element.component = component;
        element.setAttribute('data-' + this.Component[key].tagName + '-inited', '');
        component.render();
      }.bind(_this));
    };

    for (var key in this.Component) {
      _loop(key);
    }
  },

  Component: {},

  BaseComponent: function BaseComponent(element) {
    _classCallCheck(this, BaseComponent);

    this.element = element;

    if (_jquery2.default) {
      this.$element = (0, _jquery2.default)(element);
      this.$window = (0, _jquery2.default)(window);
      this.$body = (0, _jquery2.default)('body');
    }
  }

};

exports.default = Snappy;

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), __webpack_require__(47)))

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(105);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _modernizr = __webpack_require__(27);

var _modernizr2 = _interopRequireDefault(_modernizr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resized = false,
    resizeTimer = null,
    timeoutTime = 150,
    App = {};

function initResize() {
    setGlobalVars();
    (0, _jquery2.default)(window).on('resize', resizeProcessing);
    (0, _jquery2.default)(window).on('orientationchange', resizeProcessing);

    App.resize = resizeAfterProcessing.bind(this, true);
}

function setGlobalVars() {
    App.isTouch = _modernizr2.default.touchevents;
    App.isWinPhone = !!('ontouchstart' in window || navigator.msMaxTouchPoints) && navigator.userAgent.match(/Windows Phone/i);
    App.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    resizeAfterProcessing(true);
}

function resizeProcessing() {
    if (resizeTimer !== null) {
        clearTimeout(resizeTimer);
    }
    resized = true;
    resizeAfterProcessing();
}

function resizeAfterProcessing(notTrigger) {
    if (resized === true) {
        resized = false;
        resizeTimer = setTimeout(resizeAfterProcessing, timeoutTime);
        return;
    }

    var $window = (0, _jquery2.default)(window),
        width = $window.outerWidth(),
        height = $window.outerHeight();
    if (width == App.width && height == App.height) {
        return;
    }

    _extends(App, {
        width: width,
        height: height,
        orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait",
        isWidest: _modernizr2.default.mq('only screen and (min-width:1500px)'),
        isDesktop: _modernizr2.default.mq('only screen and (min-width:1025px)'),
        isTablet: _modernizr2.default.mq('only screen and (min-width:769px)'),
        isPhoneLandscape: _modernizr2.default.mq('only screen and (min-width:641px)')
    });

    if (typeof notTrigger != 'undefined' && notTrigger === true) {
        return;
    }

    $window.trigger('resize:finished');
}

initResize();

exports.default = App;

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduFeedback = function (_Snappy$BaseComponent) {
    _inherits(EduFeedback, _Snappy$BaseComponent);

    _createClass(EduFeedback, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-feedback';
        }
    }]);

    function EduFeedback(element) {
        _classCallCheck(this, EduFeedback);

        return _possibleConstructorReturn(this, (EduFeedback.__proto__ || Object.getPrototypeOf(EduFeedback)).call(this, element));
    }

    _createClass(EduFeedback, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.$container = this.$element.find('.js-feedback-container');
            this.$items = this.$element.find('.js-feedback-item');
            this.endPoint = this.$element.data('url');
            this.$counts = this.$element.find('.js-feedback-count');
            this.isLoggedIn = this.$element.data('isLoggedIn') === 'True';
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$container.on('change', this.changeHandler.bind(this));
        }
    }, {
        key: 'changeHandler',
        value: function changeHandler(e) {
            if (!this.isLoggedIn) {
                window.location = e.target.getAttribute('data-login-url');
                return;
            }
            var formData = this.$container.serialize();
            var target = e.target;
            this.trackCheckbox(target);
            _jquery2.default.ajax({
                url: this.endPoint,
                type: 'POST',
                data: formData,
                success: this.handleSuccess.bind(this),
                error: this.handleError.bind(this)
            });
        }
    }, {
        key: 'handleSuccess',
        value: function handleSuccess(response) {
            var _this2 = this;

            if (response.success === true) {
                var feedBackObj = response.feedback;
                var keys = Object.keys(feedBackObj);
                keys.forEach(function (key) {
                    var $currentCount = _this2.$counts.filter('[data-name=' + key.toLowerCase() + ']');
                    if ($currentCount.length) {
                        $currentCount.text(feedBackObj[key]);
                    }
                });
            } else {
                this.handleError(response);
            }
        }
    }, {
        key: 'handleError',
        value: function handleError(response) {
            console.log(response);
            alert('Something went wrong');
        }
    }, {
        key: 'trackCheckbox',
        value: function trackCheckbox(target) {
            if (!target.checked) {
                return;
            }

            var category = target.getAttribute('data-gtm-event-category');
            var action = target.getAttribute('data-gtm-event-action');
            var label = target.getAttribute('data-gtm-event-label');
            (0, _jquery2.default)(window).trigger('gtm:send', [category, action, label]);
        }
    }]);

    return EduFeedback;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduSitenavigation = function (_Snappy$BaseComponent) {
    _inherits(EduSitenavigation, _Snappy$BaseComponent);

    _createClass(EduSitenavigation, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-sitenavigation';
        }
    }]);

    function EduSitenavigation(element) {
        _classCallCheck(this, EduSitenavigation);

        return _possibleConstructorReturn(this, (EduSitenavigation.__proto__ || Object.getPrototypeOf(EduSitenavigation)).call(this, element));
    }

    _createClass(EduSitenavigation, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.DesktopDropdownHover();
            this.plusMinusIconClick();
            this.menuScrollTop();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$mobileSearchIcon = this.$element.find('.mobile-search-icon .glyphicon-search');
            this.$mobileSearchSpan = this.$element.find('.mobile-search-icon > span');
            this.$navbarForm = this.$element.find('.navbar-form');
            this.$navbarToggle = this.$element.find('.navbar-toggle');
            this.$collapseNavbarCollapse = this.$element.find('.collapse.navbar-collapse');
            this.$desktopDropdown = this.$element.find('.dropdown');
            this.$dropdownToggle = this.$element.find('.dropdown-toggle');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$mobileSearchIcon.on('click', this.onMobileSearchIconClick.bind(this));
            this.$dropdownToggle.on('blur', this.onPlusMinusIconBlur.bind(this));
            this.$navbarToggle.on('click', this.onNavbarToggleClick.bind(this));
        }
    }, {
        key: 'onMobileSearchIconClick',
        value: function onMobileSearchIconClick() {
            this.$mobileSearchSpan.toggleClass('glyphicon-remove');
            this.$navbarForm.toggleClass('mobile-search');
            this.$navbarToggle.addClass('collapsed');
            this.$collapseNavbarCollapse.removeClass('in');
            if (!(0, _jquery2.default)('.navbar-form').hasClass('mobile-search')) {
                (0, _jquery2.default)('.navbar-form').addClass('search-fixed');
            } else {
                (0, _jquery2.default)('.navbar-form').removeClass('search-fixed');
            }
            (0, _jquery2.default)('.eduhub-layout .fa-navigation').removeClass('is-mobile-active');
        }
    }, {
        key: 'DesktopDropdownHover',
        value: function DesktopDropdownHover() {
            if ((0, _jquery2.default)(window).width() > 991 && (0, _jquery2.default)('html').hasClass('no-touchevents')) {
                (0, _jquery2.default)(".dropdown").mouseenter(function () {
                    (0, _jquery2.default)(this).addClass("open");
                    (0, _jquery2.default)(this).siblings('.dropdown').removeClass('open');
                    (0, _jquery2.default)(this).find('span.glyphicon-plus').addClass('glyphicon-minus');
                    /* if ($('.dropdown:last-child').hasClass('open')) {                    
                         var screenWidth = $(window).width() - $('.container').width();
                         alert('mov1');
                         if ($('.open.dropdown .dropdown-menu').width() > screenWidth) {
                             alert('move');
                             $('.open.dropdown .dropdown-menu').removeClass('dropdown-menu-left');
                             $('.open.dropdown .dropdown-menu').addClass('dropdown-menu-right');
                         }
                     }*/
                }).mouseleave(function () {
                    (0, _jquery2.default)(this).removeClass("open");
                    (0, _jquery2.default)(this).siblings('.dropdown').removeClass('open');
                    (0, _jquery2.default)(this).find('span.glyphicon-plus').removeClass('glyphicon-minus');
                });
            }

            if ((0, _jquery2.default)('html').hasClass('touchevents')) {
                (0, _jquery2.default)(".dropdown").on('click', function () {
                    var dropdownChild = (0, _jquery2.default)(this).children(".dropdown-menu");

                    if (dropdownChild.is(":visible")) {
                        (0, _jquery2.default)(this).removeClass("open");
                        (0, _jquery2.default)(this).siblings('.dropdown').removeClass('open');
                        (0, _jquery2.default)(this).find('span.glyphicon-plus').removeClass('glyphicon-minus');
                    } else {
                        (0, _jquery2.default)(this).addClass("open");
                        (0, _jquery2.default)(this).siblings('.dropdown').removeClass('open');
                        /*if ($('.dropdown:last-child').hasClass('open')) {
                            alert('test');
                            $('.open.dropdown .dropdown-menu').removeClass('dropdown-menu-left');
                            $('.open.dropdown .dropdown-menu').addClass('dropdown-menu-right');
                        }*/
                        (0, _jquery2.default)(this).find('span.glyphicon-plus').addClass('glyphicon-minus');
                    }
                });
            }
        }
    }, {
        key: 'plusMinusIconClick',
        value: function plusMinusIconClick() {
            (0, _jquery2.default)('.dropdown-toggle').on('click', function () {
                (0, _jquery2.default)(this).find('span.glyphicon-plus').toggleClass('glyphicon-minus');
            });
        }
    }, {
        key: 'onPlusMinusIconBlur',
        value: function onPlusMinusIconBlur() {
            (0, _jquery2.default)('.dropdown-toggle > span.glyphicon-plus').removeClass('glyphicon-minus');
        }
    }, {
        key: 'onNavbarToggleClick',
        value: function onNavbarToggleClick() {
            var mobileSearchIcon = (0, _jquery2.default)('.mobile-search-icon > span');
            if (mobileSearchIcon.hasClass('glyphicon-remove')) {
                mobileSearchIcon.removeClass('glyphicon-remove');
                (0, _jquery2.default)('.navbar-form').addClass('mobile-search');
            }

            if ((0, _jquery2.default)('.navbar-toggle').is(':visible')) {
                (0, _jquery2.default)('.dropdown-toggle').removeClass('disabled');
            }
            (0, _jquery2.default)('.eduhub-layout .fa-navigation').toggleClass('is-mobile-active');
        }
    }, {
        key: 'menuScrollTop',
        value: function menuScrollTop() {
            (0, _jquery2.default)(window).on('scroll resize', function () {

                if ((0, _jquery2.default)(window).width() > 991) {

                    if ((0, _jquery2.default)(window).scrollTop() > 30) {
                        (0, _jquery2.default)('.navbar-fixed-top').addClass('fixed-active');
                    } else {
                        (0, _jquery2.default)('.navbar-fixed-top').removeClass('fixed-active');
                    }
                }
            });
            /* $(window).on('resize', function () {
                 if ($('.dropdown:last-child').hasClass('open')) {
                     var screenWidth = $(window).width() - $('.container').width();
                     if ($('.open.dropdown .dropdown-menu').width() > screenWidth) {
                         alert('resize');
                         $('.open.dropdown .dropdown-menu').removeClass('dropdown-menu-left');
                         $('.open.dropdown .dropdown-menu').addClass('dropdown-menu-right');
                     }
                 }
             });*/
        }
    }]);

    return EduSitenavigation;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

var _videoHelpers = __webpack_require__(79);

var _videoHelpers2 = _interopRequireDefault(_videoHelpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ModalVideo = function (_Snappy$BaseComponent) {
    _inherits(ModalVideo, _Snappy$BaseComponent);

    _createClass(ModalVideo, null, [{
        key: 'tagName',
        get: function get() {
            return 'modal-video';
        }
    }]);

    function ModalVideo(element) {
        _classCallCheck(this, ModalVideo);

        return _possibleConstructorReturn(this, (ModalVideo.__proto__ || Object.getPrototypeOf(ModalVideo)).call(this, element));
    }

    _createClass(ModalVideo, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {

            this.$document = (0, _jquery2.default)(document);
            this.title = this.$element.data('modalVideoTitle');
            this.videoUrl = this.$element.data('modalVideoUrl');
            this.templateId = 'video-template';
            this.currentSection = this.$element.data('currentSection');
            var $opener = this.$element.find('.js-modal-video-opener');
            this.$opener = $opener.length ? $opener : this.$element;
            this.$duration = this.$element.find('.js-modal-video-duration');
            this.vimeoMetaEndpoint = 'https://vimeo.com/api/oembed.json';
            this.videoHost = this.videoUrl.indexOf("youtu") > -1 ? 'youtube' : 'vimeo';
            this.formattedDuration = '';
            this.isTracked = false;
            if (this.videoHost === 'youtube') {
                this.prepareYoutube();
            }

            if (this.videoHost === 'vimeo') {
                this.prepareVimeo();
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$opener.on('click', this.openModal.bind(this));
        }
    }, {
        key: 'prepareYoutube',
        value: function prepareYoutube() {
            this.videoId = _videoHelpers2.default.parseYoutubeId(this.videoUrl);
            this.iframeUrl = '//youtube.com/embed/' + this.videoId + '?autoplay=1';
        }
    }, {
        key: 'prepareVimeo',
        value: function prepareVimeo() {
            this.videoId = _videoHelpers2.default.parseVimeoId(this.videoUrl);
            this.iframeUrl = '//player.vimeo.com/video/' + this.videoId + '?autoplay=1';
            if (this.$duration.length) {
                this.getVimeoMetadata();
            }
        }
    }, {
        key: 'getVimeoMetadata',
        value: function getVimeoMetadata() {
            var _this2 = this;

            var request = this.vimeoMetaEndpoint + '?url=' + this.videoUrl;
            _jquery2.default.get(request, function (data) {
                var duration = data.duration;
                _this2.formattedDuration = _videoHelpers2.default.getFomattedDuration(duration);
                _this2.$duration.text(_this2.formattedDuration);
            });
        }
    }, {
        key: 'openModal',
        value: function openModal(e) {
            e.preventDefault();

            var templateSource = (0, _jquery2.default)('#' + this.templateId).html();
            var templateFiunc = _handlebars2.default.compile(templateSource);
            var modalHtml = templateFiunc({
                videoUrl: this.iframeUrl
            });
            var modalContent = (0, _jquery2.default)(modalHtml);

            this.$window.trigger('modal:openModal', {
                title: this.title,
                videoDuration: this.formattedDuration,
                $view: modalContent,
                $prevElement: this.$element
            });

            if (!this.isTracked) {
                this.isTracked = true;
                this.$window.trigger('gtm:send', [this.currentSection, 'View Video', this.title]);
            }
        }
    }]);

    return ModalVideo;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.MouseoverArrow = function (_Snappy$BaseComponent) {
    _inherits(MouseoverArrow, _Snappy$BaseComponent);

    _createClass(MouseoverArrow, null, [{
        key: 'tagName',
        get: function get() {
            return 'mouseover-arrow';
        }
    }]);

    function MouseoverArrow(element) {
        _classCallCheck(this, MouseoverArrow);

        return _possibleConstructorReturn(this, (MouseoverArrow.__proto__ || Object.getPrototypeOf(MouseoverArrow)).call(this, element));
    }

    _createClass(MouseoverArrow, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();

            this.$arrowLeft.addClass('mouseover-arrow mouseover-arrow--left');
            this.$arrowRight.addClass('mouseover-arrow mouseover-arrow--right');
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.$arrowLeft = this.$element.find('.js-arrow-left');
            this.$arrowRight = this.$element.find('.js-arrow-right');
            this.$arrows = this.$arrowLeft.add(this.$arrowRight);

            this.sens = 0.20; //part of container width arrows appears mouseover on
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$element.on('mousemove', (0, _underscore.throttle)(this.mouseMoveHandler.bind(this), 200));

            this.$element.on('mouseleave', this.mouseLeaveHandler.bind(this));

            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));
        }
    }, {
        key: 'mouseMoveHandler',
        value: function mouseMoveHandler(e) {
            var containerWidth = this.width;
            var x = e.clientX;
            if (x < this.containerLeft + this.sensOffset) {
                this.$arrowLeft.addClass('is-active');
                this.$arrowRight.removeClass('is-active');
            } else if (x > this.containerLeft + this.width - this.sensOffset) {
                this.$arrowLeft.removeClass('is-active');
                this.$arrowRight.addClass('is-active');
            } else {
                this.$arrowLeft.removeClass('is-active');
                this.$arrowRight.removeClass('is-active');
            }
        }
    }, {
        key: 'mouseLeaveHandler',
        value: function mouseLeaveHandler(e) {
            var _this2 = this;

            setTimeout(function () {
                _this2.$arrows.removeClass('is-active');
            }, 200);
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.width = this.$element.outerWidth();
            var rect = this.$element[0].getBoundingClientRect();
            this.containerLeft = rect.left;
            this.sensOffset = this.sens * this.width;
        }
    }]);

    return MouseoverArrow;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-appearance-csstransforms3d-customevent-flexbox-flexboxlegacy-smil-touchevents-mq-prefixed-setclasses-shiv !*/
!function(e,t,n){function r(e,t){return typeof e===t}function o(){var e,t,n,o,i,a,s;for(var l in S)if(S.hasOwnProperty(l)){if(e=[],t=S[l],t.name&&(e.push(t.name.toLowerCase()),t.options&&t.options.aliases&&t.options.aliases.length))for(n=0;n<t.options.aliases.length;n++)e.push(t.options.aliases[n].toLowerCase());for(o=r(t.fn,"function")?t.fn():t.fn,i=0;i<e.length;i++)a=e[i],s=a.split("."),1===s.length?Modernizr[s[0]]=o:(!Modernizr[s[0]]||Modernizr[s[0]]instanceof Boolean||(Modernizr[s[0]]=new Boolean(Modernizr[s[0]])),Modernizr[s[0]][s[1]]=o),x.push((o?"":"no-")+s.join("-"))}}function i(e){var t=b.className,n=Modernizr._config.classPrefix||"";if(E&&(t=t.baseVal),Modernizr._config.enableJSClass){var r=new RegExp("(^|\\s)"+n+"no-js(\\s|$)");t=t.replace(r,"$1"+n+"js$2")}Modernizr._config.enableClasses&&(t+=" "+n+e.join(" "+n),E?b.className.baseVal=t:b.className=t)}function a(e,t){return!!~(""+e).indexOf(t)}function s(){return"function"!=typeof t.createElement?t.createElement(arguments[0]):E?t.createElementNS.call(t,"http://www.w3.org/2000/svg",arguments[0]):t.createElement.apply(t,arguments)}function l(){var e=t.body;return e||(e=s(E?"svg":"body"),e.fake=!0),e}function u(e,n,r,o){var i,a,u,c,f="modernizr",d=s("div"),p=l();if(parseInt(r,10))for(;r--;)u=s("div"),u.id=o?o[r]:f+(r+1),d.appendChild(u);return i=s("style"),i.type="text/css",i.id="s"+f,(p.fake?p:d).appendChild(i),p.appendChild(d),i.styleSheet?i.styleSheet.cssText=e:i.appendChild(t.createTextNode(e)),d.id=f,p.fake&&(p.style.background="",p.style.overflow="hidden",c=b.style.overflow,b.style.overflow="hidden",b.appendChild(p)),a=n(d,e),p.fake?(p.parentNode.removeChild(p),b.style.overflow=c,b.offsetHeight):d.parentNode.removeChild(d),!!a}function c(e){return e.replace(/([A-Z])/g,function(e,t){return"-"+t.toLowerCase()}).replace(/^ms-/,"-ms-")}function f(t,n,r){var o;if("getComputedStyle"in e){o=getComputedStyle.call(e,t,n);var i=e.console;if(null!==o)r&&(o=o.getPropertyValue(r));else if(i){var a=i.error?"error":"log";i[a].call(i,"getComputedStyle returning null, its possible modernizr test results are inaccurate")}}else o=!n&&t.currentStyle&&t.currentStyle[r];return o}function d(t,r){var o=t.length;if("CSS"in e&&"supports"in e.CSS){for(;o--;)if(e.CSS.supports(c(t[o]),r))return!0;return!1}if("CSSSupportsRule"in e){for(var i=[];o--;)i.push("("+c(t[o])+":"+r+")");return i=i.join(" or "),u("@supports ("+i+") { #modernizr { position: absolute; } }",function(e){return"absolute"==f(e,null,"position")})}return n}function p(e){return e.replace(/([a-z])-([a-z])/g,function(e,t,n){return t+n.toUpperCase()}).replace(/^-/,"")}function m(e,t,o,i){function l(){c&&(delete z.style,delete z.modElem)}if(i=r(i,"undefined")?!1:i,!r(o,"undefined")){var u=d(e,o);if(!r(u,"undefined"))return u}for(var c,f,m,h,v,g=["modernizr","tspan","samp"];!z.style&&g.length;)c=!0,z.modElem=s(g.shift()),z.style=z.modElem.style;for(m=e.length,f=0;m>f;f++)if(h=e[f],v=z.style[h],a(h,"-")&&(h=p(h)),z.style[h]!==n){if(i||r(o,"undefined"))return l(),"pfx"==t?h:!0;try{z.style[h]=o}catch(y){}if(z.style[h]!=v)return l(),"pfx"==t?h:!0}return l(),!1}function h(e,t){return function(){return e.apply(t,arguments)}}function v(e,t,n){var o;for(var i in e)if(e[i]in t)return n===!1?e[i]:(o=t[e[i]],r(o,"function")?h(o,n||t):o);return!1}function g(e,t,n,o,i){var a=e.charAt(0).toUpperCase()+e.slice(1),s=(e+" "+_.join(a+" ")+a).split(" ");return r(t,"string")||r(t,"undefined")?m(s,t,o,i):(s=(e+" "+N.join(a+" ")+a).split(" "),v(s,t,n))}function y(e,t,r){return g(e,n,n,t,r)}var S=[],C={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,t){var n=this;setTimeout(function(){t(n[e])},0)},addTest:function(e,t,n){S.push({name:e,fn:t,options:n})},addAsyncTest:function(e){S.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=C,Modernizr=new Modernizr;var x=[],b=t.documentElement,E="svg"===b.nodeName.toLowerCase();E||!function(e,t){function n(e,t){var n=e.createElement("p"),r=e.getElementsByTagName("head")[0]||e.documentElement;return n.innerHTML="x<style>"+t+"</style>",r.insertBefore(n.lastChild,r.firstChild)}function r(){var e=S.elements;return"string"==typeof e?e.split(" "):e}function o(e,t){var n=S.elements;"string"!=typeof n&&(n=n.join(" ")),"string"!=typeof e&&(e=e.join(" ")),S.elements=n+" "+e,u(t)}function i(e){var t=y[e[v]];return t||(t={},g++,e[v]=g,y[g]=t),t}function a(e,n,r){if(n||(n=t),f)return n.createElement(e);r||(r=i(n));var o;return o=r.cache[e]?r.cache[e].cloneNode():h.test(e)?(r.cache[e]=r.createElem(e)).cloneNode():r.createElem(e),!o.canHaveChildren||m.test(e)||o.tagUrn?o:r.frag.appendChild(o)}function s(e,n){if(e||(e=t),f)return e.createDocumentFragment();n=n||i(e);for(var o=n.frag.cloneNode(),a=0,s=r(),l=s.length;l>a;a++)o.createElement(s[a]);return o}function l(e,t){t.cache||(t.cache={},t.createElem=e.createElement,t.createFrag=e.createDocumentFragment,t.frag=t.createFrag()),e.createElement=function(n){return S.shivMethods?a(n,e,t):t.createElem(n)},e.createDocumentFragment=Function("h,f","return function(){var n=f.cloneNode(),c=n.createElement;h.shivMethods&&("+r().join().replace(/[\w\-:]+/g,function(e){return t.createElem(e),t.frag.createElement(e),'c("'+e+'")'})+");return n}")(S,t.frag)}function u(e){e||(e=t);var r=i(e);return!S.shivCSS||c||r.hasCSS||(r.hasCSS=!!n(e,"article,aside,dialog,figcaption,figure,footer,header,hgroup,main,nav,section{display:block}mark{background:#FF0;color:#000}template{display:none}")),f||l(e,r),e}var c,f,d="3.7.3",p=e.html5||{},m=/^<|^(?:button|map|select|textarea|object|iframe|option|optgroup)$/i,h=/^(?:a|b|code|div|fieldset|h1|h2|h3|h4|h5|h6|i|label|li|ol|p|q|span|strong|style|table|tbody|td|th|tr|ul)$/i,v="_html5shiv",g=0,y={};!function(){try{var e=t.createElement("a");e.innerHTML="<xyz></xyz>",c="hidden"in e,f=1==e.childNodes.length||function(){t.createElement("a");var e=t.createDocumentFragment();return"undefined"==typeof e.cloneNode||"undefined"==typeof e.createDocumentFragment||"undefined"==typeof e.createElement}()}catch(n){c=!0,f=!0}}();var S={elements:p.elements||"abbr article aside audio bdi canvas data datalist details dialog figcaption figure footer header hgroup main mark meter nav output picture progress section summary template time video",version:d,shivCSS:p.shivCSS!==!1,supportsUnknownElements:f,shivMethods:p.shivMethods!==!1,type:"default",shivDocument:u,createElement:a,createDocumentFragment:s,addElements:o};e.html5=S,u(t),"object"==typeof module&&module.exports&&(module.exports=S)}("undefined"!=typeof e?e:this,t);var w="Moz O ms Webkit",_=C._config.usePrefixes?w.split(" "):[];C._cssomPrefixes=_;var T={elem:s("modernizr")};Modernizr._q.push(function(){delete T.elem});var z={style:T.elem.style};Modernizr._q.unshift(function(){delete z.style});var N=C._config.usePrefixes?w.toLowerCase().split(" "):[];C._domPrefixes=N,C.testAllProps=g;var j=function(t){var r,o=D.length,i=e.CSSRule;if("undefined"==typeof i)return n;if(!t)return!1;if(t=t.replace(/^@/,""),r=t.replace(/-/g,"_").toUpperCase()+"_RULE",r in i)return"@"+t;for(var a=0;o>a;a++){var s=D[a],l=s.toUpperCase()+"_"+r;if(l in i)return"@-"+s.toLowerCase()+"-"+t}return!1};C.atRule=j;var k=(C.prefixed=function(e,t,n){return 0===e.indexOf("@")?j(e):(-1!=e.indexOf("-")&&(e=p(e)),t?g(e,t,n):g(e,"pfx"))},function(){var t=e.matchMedia||e.msMatchMedia;return t?function(e){var n=t(e);return n&&n.matches||!1}:function(t){var n=!1;return u("@media "+t+" { #modernizr { position: absolute; } }",function(t){n="absolute"==(e.getComputedStyle?e.getComputedStyle(t,null):t.currentStyle).position}),n}}());C.mq=k,C.testAllProps=y;var P=C.testStyles=u,F="CSS"in e&&"supports"in e.CSS,M="supportsCSS"in e;Modernizr.addTest("supports",F||M),Modernizr.addTest("csstransforms3d",function(){var e=!!y("perspective","1px",!0),t=Modernizr._config.usePrefixes;if(e&&(!t||"webkitPerspective"in b.style)){var n,r="#modernizr{width:0;height:0}";Modernizr.supports?n="@supports (perspective: 1px)":(n="@media (transform-3d)",t&&(n+=",(-webkit-transform-3d)")),n+="{#modernizr{width:7px;height:18px;margin:0;padding:0;border:0}}",P(r+n,function(t){e=7===t.offsetWidth&&18===t.offsetHeight})}return e}),Modernizr.addTest("flexboxlegacy",y("boxDirection","reverse",!0)),Modernizr.addTest("flexbox",y("flexBasis","1px",!0));var D=C._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];C._prefixes=D,Modernizr.addTest("touchevents",function(){var n;if("ontouchstart"in e||e.DocumentTouch&&t instanceof DocumentTouch)n=!0;else{var r=["@media (",D.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");P(r,function(e){n=9===e.offsetTop})}return n}),Modernizr.addTest("appearance",y("appearance"));var L={}.toString;Modernizr.addTest("smil",function(){return!!t.createElementNS&&/SVGAnimate/.test(L.call(t.createElementNS("http://www.w3.org/2000/svg","animate")))}),Modernizr.addTest("customevent","CustomEvent"in e&&"function"==typeof e.CustomEvent),o(),i(x),delete C.addTest,delete C.addAsyncTest;for(var q=0;q<Modernizr._q.length;q++)Modernizr._q[q]();e.Modernizr=Modernizr}(window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),

/***/ 47:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 484:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _nearBy = __webpack_require__(604);

var _nearBy2 = _interopRequireDefault(_nearBy);

var _gsap = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ApproachPointer = function (_Snappy$BaseComponent) {
    _inherits(ApproachPointer, _Snappy$BaseComponent);

    _createClass(ApproachPointer, null, [{
        key: 'tagName',
        get: function get() {
            return 'approach-pointer';
        }
    }]);

    function ApproachPointer(element) {
        _classCallCheck(this, ApproachPointer);

        var _this = _possibleConstructorReturn(this, (ApproachPointer.__proto__ || Object.getPrototypeOf(ApproachPointer)).call(this, element));

        _this.distanceScaleThreshold = { min: 0, max: 100 };
        _this.scaleIntervalExpand = { from: 1, to: 2.5 };
        _this.nearBy = null;
        return _this;
    }

    _createClass(ApproachPointer, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.approachTarget = this.element.querySelector('.js-approach-pointer-target');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'lineEq',
        value: function lineEq(y2, y1, x2, x1, currentVal) {
            var m = (y2 - y1) / (x2 - x1),
                b = y1 - m * x1;
            return m * currentVal + b;
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.nearBy = new _nearBy2.default(this.element, {

                onProgress: function onProgress(distance) {

                    var expand = _this2.lineEq(_this2.scaleIntervalExpand.from, _this2.scaleIntervalExpand.to, _this2.distanceScaleThreshold.max, _this2.distanceScaleThreshold.min, distance);

                    _gsap.TweenLite.to(_this2.approachTarget, 1.2, {
                        scale: Math.min(Math.max(_this2.scaleIntervalExpand.from, expand), _this2.scaleIntervalExpand.to),
                        ease: Power4.easeOut
                    });
                }

            });
        }
    }]);

    return ApproachPointer;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _cookie = __webpack_require__(613);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.BursaryForm = function (_Snappy$BaseComponent) {
    _inherits(BursaryForm, _Snappy$BaseComponent);

    _createClass(BursaryForm, null, [{
        key: 'tagName',
        get: function get() {
            return 'bursary-form';
        }
    }]);

    function BursaryForm(element) {
        _classCallCheck(this, BursaryForm);

        return _possibleConstructorReturn(this, (BursaryForm.__proto__ || Object.getPrototypeOf(BursaryForm)).call(this, element));
    }

    _createClass(BursaryForm, [{
        key: 'render',
        value: function render() {
            // todo: use logged in flag from backend, cookie solution is temporary
            var isLoggedIn = typeof (0, _cookie.getCookie)('ZimbraSsoCookie') !== 'undefined';

            if (!isLoggedIn) {
                this.$window.trigger('loginPrompt:open');
            }
        }
    }]);

    return BursaryForm;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.CommentsCount = function (_Snappy$BaseComponent) {
    _inherits(CommentsCount, _Snappy$BaseComponent);

    _createClass(CommentsCount, null, [{
        key: 'tagName',
        get: function get() {
            return 'comments-count';
        }
    }]);

    function CommentsCount(element) {
        _classCallCheck(this, CommentsCount);

        return _possibleConstructorReturn(this, (CommentsCount.__proto__ || Object.getPrototypeOf(CommentsCount)).call(this, element));
    }

    _createClass(CommentsCount, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.getComments();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.$wrappers = this.$element.find('.js-comments-count-wrapper');
            this.endPoint = this.$element.data('commentsCountUrl');
        }
    }, {
        key: 'getComments',
        value: function getComments() {
            var _this2 = this;

            var paramArray = [];
            this.$wrappers.each(function (i, item) {
                var contentId = (0, _jquery2.default)(item).data('contentId');
                if (contentId) {
                    paramArray.push('postsIds=' + contentId);
                }
            });
            if (!paramArray.length) {
                return;
            }

            var parameters = paramArray.join('&');
            var qs = this.endPoint + '?' + parameters;
            _jquery2.default.get(qs, function (data) {
                if (data.success) {
                    _this2.renderCount(data.result);
                }
            });
        }
    }, {
        key: 'renderCount',
        value: function renderCount(countArr) {
            var _this3 = this;

            countArr.forEach(function (item) {
                if (item.commentsCount > 0) {
                    var $currentWrapper = _this3.$wrappers.filter('[data-content-id="' + item.contentId + '"]');
                    var $count = $currentWrapper.find('.js-comments-count-el');
                    $currentWrapper.show();
                    $count.text(item.commentsCount);
                }
            });
        }
    }]);

    return CommentsCount;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

var _commentsArranger = __webpack_require__(605);

var _commentsArranger2 = _interopRequireDefault(_commentsArranger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Comments = function (_Snappy$BaseComponent) {
    _inherits(Comments, _Snappy$BaseComponent);

    _createClass(Comments, null, [{
        key: 'tagName',
        get: function get() {
            return 'comments';
        }
    }]);

    function Comments(element) {
        _classCallCheck(this, Comments);

        return _possibleConstructorReturn(this, (Comments.__proto__ || Object.getPrototypeOf(Comments)).call(this, element));
    }

    _createClass(Comments, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.init();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.endpoints = {
                getAll: this.$element.data('getComments'),
                add: this.$element.data('addComment'),
                update: this.$element.data('updateComment'),
                abuseReport: this.$element.data('abuseReport'),
                remove: this.$element.data('removeComment'),
                like: this.$element.data('likeComment'),
                unlike: this.$element.data('unlikeComment'),
                getLikes: this.$element.data('likesList')
            };
            this.postId = this.$element.data('postId');
            this.userId = this.$element.data('uid');
            this.pageSize = this.$element.data('pageSize');
            this.initials = this.$element.data('initials');
            this.commentTemplateFunc = null;
            this.$activeReplyWrapper = null;
            this.ajaxFailMessage = 'Something went wrong. Please try again later.';

            this.$container = this.$element.find('.js-comments-list');
            this.$postForm = this.$element.find('.js-comments-post-form');
            this.$postBtn = this.$element.find('.js-comments-post-btn');
            this.$postText = this.$element.find('.js-comments-post-text');
            this.listTemplateSource = (0, _jquery2.default)('#comment-list-template').html();
            this.commentTemplateSource = (0, _jquery2.default)('#comment-template').html();

            this.reportedText = 'This comment has been reported and is awaiting moderation';
            this.actions = ['Like', 'Reply', 'ReplyPost', 'ReplyCancel', 'Report', 'Edit', 'Remove', 'EditSave', 'EditCancel'];
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$container.on('click', this.generalClick.bind(this));
            this.$container.on('click', '.js-comments-more', this.moreClickHandler.bind(this));
            this.$postForm.on('submit', this.addComment.bind(this));
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            if (typeof window.IntersectionObserver === 'function') {
                this.observer = new IntersectionObserver(this.observerCallback.bind(this), {
                    threshold: 0
                });
                this.observer.observe(this.$container[0]);
            } else {
                setTimeout(function () {
                    _this2.initialShowComments();
                }, 500);
            }
        }
    }, {
        key: 'postRequest',
        value: function postRequest(url, responseHandler, $container) {
            var _this3 = this;

            _jquery2.default.post(url, function (data) {
                if (data.success) {
                    _this3.hideError($container);
                    responseHandler(data);
                } else {
                    _this3.showError($container, data.message);
                }
            }).fail(function (response) {
                _this3.showError($container, _this3.ajaxFailMessage);
            });
        }
    }, {
        key: 'addComment',
        value: function addComment(e) {
            e.preventDefault();
            var text = this.$postText.val().replace(/\n/g, '<br />');
            if (!text.length) {
                return;
            }
            this.$postBtn.attr('disabled');

            var url = this.endpoints.add + '?postId=' + this.postId + '&body=' + text + '&uid=' + this.userId;
            this.postRequest(url, this.addCommentResultHandler.bind(this), this.$postForm);
        }
    }, {
        key: 'addCommentResultHandler',
        value: function addCommentResultHandler(data) {
            this.$postBtn.removeAttr('disabled');
            this.$postText.val('');

            var result = data.result;
            result.authenticated = true;
            var htmlString = this.commentTemplateFunc(result);
            this.$container.prepend(htmlString);
            this.incrementCount();
        }
    }, {
        key: 'generalClick',
        value: function generalClick(e) {
            var $interactiveEl = (0, _jquery2.default)(e.target).closest('button');
            if (!$interactiveEl.length) {
                return;
            }
            var $currentComment = $interactiveEl.closest('.js-comments-item');

            var action = $interactiveEl.data('action');
            if (this.actions.indexOf(action) > -1) {
                this['onClick' + action]($currentComment, $interactiveEl);
            }
        }
    }, {
        key: 'onClickLike',
        value: function onClickLike($currentComment, $interactiveEl) {
            var id = $currentComment.data('id');
            $interactiveEl.attr('disabled');
            var responseHandler = this.likeResultHandler.bind(this, $currentComment, $interactiveEl);
            if ($currentComment.hasClass('is-liked')) {
                var url = this.endpoints.unlike + '?commentId=' + id + '&uid=' + this.userId;
                this.postRequest(url, responseHandler, $currentComment);
            } else {
                var _url = this.endpoints.like + '?commentId=' + id + '&uid=' + this.userId;
                this.postRequest(_url, responseHandler, $currentComment);
            }
        }
    }, {
        key: 'likeResultHandler',
        value: function likeResultHandler($currentComment, $interactiveEl, data) {
            var $likeCount = $interactiveEl.find('.js-comments-like-count');
            var $likeText = $interactiveEl.find('.js-comments-like-text');
            var result = data.result;

            if (result.isLiked) {
                $currentComment.addClass('is-liked');
                $likeText.text('Liked');
            } else {
                $currentComment.removeClass('is-liked');
                $likeText.text('Like');
            }

            if (result.count > 0) {
                $currentComment.addClass('is-likes');
            } else {
                $currentComment.removeClass('is-likes');
            }
            $likeCount.text(result.count);
            $interactiveEl.removeAttr('disabled');
        }
    }, {
        key: 'onClickReply',
        value: function onClickReply($currentComment, $interactiveEl) {

            if (this.$activeReplyWrapper) {
                this.$activeReplyWrapper.remove();
                this.$activeReplyWrapper = null;
            }
            var id = $currentComment.data('id');
            var parentDepth = parseInt($currentComment.data('depth'));
            //const isMaxDepth = (parentDepth >= 2);
            var isMaxDepth = false;
            var $childsContainer = $currentComment.siblings('.js-comments-list');
            var object = {
                isReplying: true,
                depth: isMaxDepth ? 2 : parentDepth + 1,
                isOwnComment: true,
                renderCommentDetails: true,
                parentCommentId: id,
                author: {
                    initials: this.initials
                }
            };
            var htmlString = this.commentTemplateFunc(object);
            var $replyWrapper = (0, _jquery2.default)(htmlString);

            if (!isMaxDepth) {
                $childsContainer.prepend($replyWrapper);
            } else {
                $childsContainer.after($replyWrapper);
            }

            this.$activeReplyWrapper = $replyWrapper;

            var $replyComment = $replyWrapper.find('.js-comments-item');
            var $textArea = $replyWrapper.find('.js-comments-text');
            $textArea.focus();
        }
    }, {
        key: 'onClickReplyPost',
        value: function onClickReplyPost($currentComment, $interactiveEl) {

            var $textArea = $currentComment.find('.js-comments-text');
            var text = $textArea.val().replace(/\n/g, '<br />');
            var parentId = $currentComment.data('parentId');
            if (!text.length) {
                return;
            }

            $interactiveEl.attr('disabled');
            var url = this.endpoints.add + '?postId=' + this.postId + '&parentCommentId=' + parentId + '&body=' + text + '&uid=' + this.userId;
            var responseHandler = this.replyResultHandler.bind(this, $currentComment, $interactiveEl);
            this.postRequest(url, responseHandler, $currentComment);
        }
    }, {
        key: 'replyResultHandler',
        value: function replyResultHandler($currentComment, $interactiveEl, data) {
            var result = data.result;
            result.authenticated = true;
            var depth = $currentComment.data('depth');
            result.depth = depth;
            var htmlString = this.commentTemplateFunc(result);
            $currentComment.parent().replaceWith(htmlString);
            this.$activeReplyWrapper = null;
            this.incrementCount(result.parentCommentId);
        }
    }, {
        key: 'onClickReplyCancel',
        value: function onClickReplyCancel() {
            if (this.$activeReplyWrapper) {
                this.$activeReplyWrapper.remove();
                this.$activeReplyWrapper = null;
            }
        }
    }, {
        key: 'onClickEdit',
        value: function onClickEdit($currentComment, $interactiveEl) {
            $currentComment.addClass('is-editing');
            var $textArea = $currentComment.find('.js-comments-text');
            var $content = $currentComment.find('.js-comments-content');

            var content = $content.text().replace(/  +/g, ' ').replace(/^\s+|\s+$/g, '');
            $textArea.val(content);
            $textArea.focus();
        }
    }, {
        key: 'onClickEditCancel',
        value: function onClickEditCancel($currentComment) {
            $currentComment.removeClass('is-editing');
        }
    }, {
        key: 'onClickEditSave',
        value: function onClickEditSave($currentComment, $interactiveEl) {
            $interactiveEl.attr('disabled');
            var id = $currentComment.data('id');
            var $textArea = $currentComment.find('.js-comments-text');
            var text = $textArea.val().replace(/\n/g, '<br />');

            var url = this.endpoints.update + '?commentId=' + id + '&body=' + text;
            var responseHandler = this.editSaveHandler.bind(this, $currentComment, $interactiveEl);
            this.postRequest(url, responseHandler, $currentComment);
        }
    }, {
        key: 'editSaveHandler',
        value: function editSaveHandler($currentComment, $interactiveEl, data) {
            $interactiveEl.removeAttr('disabled');
            $currentComment.removeClass('is-editing');
            var $content = $currentComment.find('.js-comments-content');
            $content.html(data.result.body);
        }
    }, {
        key: 'onClickReport',
        value: function onClickReport($currentComment, $interactiveEl) {
            var id = $currentComment.data('id');

            var url = this.endpoints.abuseReport + '?commentId=' + id;
            var responseHandler = this.reportResultHandler.bind(this, $currentComment, $interactiveEl);

            this.postRequest(url, responseHandler, $currentComment);
        }
    }, {
        key: 'reportResultHandler',
        value: function reportResultHandler($currentComment, $interactiveEl, data) {
            var $content = $currentComment.find('.js-comments-content');
            $content.text(this.reportedText);
            $currentComment.addClass('is-reported');
            this.removeReplyingChilds($currentComment);
        }
    }, {
        key: 'showError',
        value: function showError($container, message) {
            $container.addClass('is-error');
            var $error = $container.find('.js-comments-error');
            $error.text(message);
        }
    }, {
        key: 'hideError',
        value: function hideError($container) {
            $container.removeClass('is-error');
            var $error = $container.find('.js-comments-error');
            $error.empty();
        }
    }, {
        key: 'onClickRemove',
        value: function onClickRemove($currentComment, $interactiveEl) {
            if (confirm('Are you sure you want to delete this comment?')) {
                var id = $currentComment.data('id');

                var url = this.endpoints.remove + '?commentId=' + id;
                var responseHandler = this.removeResultHandler.bind(this, $currentComment, $interactiveEl);
                this.postRequest(url, responseHandler, $currentComment);
            }
        }
    }, {
        key: 'removeResultHandler',
        value: function removeResultHandler($currentComment, $interactiveEl, data) {
            var $content = $currentComment.find('.js-comments-content');
            $content.text(data.message);
            $currentComment.addClass('is-deleted');
            this.removeReplyingChilds($currentComment);
        }
    }, {
        key: 'observerCallback',
        value: function observerCallback(entries) {
            var _this4 = this;

            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    _this4.observer.unobserve(_this4.$container[0]);
                    _this4.initialShowComments();
                }
            });
        }
    }, {
        key: 'initialShowComments',
        value: function initialShowComments() {
            this.listTemplateFunc = _handlebars2.default.compile(this.listTemplateSource);
            _handlebars2.default.registerPartial("list", this.listTemplateSource);
            _handlebars2.default.registerPartial("comment", this.commentTemplateSource);
            this.commentTemplateFunc = _handlebars2.default.compile(this.commentTemplateSource);
            this.fetchComments({ depth: 0 });
        }
    }, {
        key: 'fetchComments',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
                var startId, depth, data, result, preparedData, idList, idListString, likesData, finalResults;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                startId = params.startId, depth = params.depth;
                                _context.next = 3;
                                return this.getCommentPage(params);

                            case 3:
                                data = _context.sent;
                                result = data.result;

                                this.latestReceivedCommentsCount = result.comments.length;
                                preparedData = _commentsArranger2.default.prepareData(result);


                                preparedData.items = _commentsArranger2.default.setDepth(preparedData.items, depth);

                                idList = _commentsArranger2.default.getIdList(data.result);
                                idListString = idList.map(function (item) {
                                    return 'commentIds=' + item;
                                }).join('&');
                                likesData = null;
                                finalResults = null;

                                if (!idListString) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.next = 15;
                                return this.getLikes(idListString);

                            case 15:
                                likesData = _context.sent;

                            case 16:

                                if (likesData && likesData.success) {
                                    finalResults = _commentsArranger2.default.setLikes(preparedData, likesData.result.likes);
                                } else {
                                    finalResults = preparedData;
                                }

                                this.renderComments(finalResults, startId);
                                this.updateMoreButtons();

                            case 19:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function fetchComments(_x) {
                return _ref.apply(this, arguments);
            }

            return fetchComments;
        }()
    }, {
        key: 'getCommentPage',
        value: function getCommentPage(params) {
            var startId = params.startId,
                parentId = params.parentId,
                depth = params.depth;

            var queryArray = [this.endpoints.getAll, 'uid=' + this.userId, 'depth=' + depth];
            if (startId) {
                queryArray.push('startReplyId=' + startId);
            }
            if (parentId) {
                queryArray.push('parentId=' + parentId);
            }
            var qs = queryArray.join('&');
            return _jquery2.default.get(qs);
        }
    }, {
        key: 'getLikes',
        value: function getLikes(idListString) {
            var qs = this.endpoints.getLikes + '?uid=' + this.userId + '&' + idListString;
            return _jquery2.default.get(qs);
        }
    }, {
        key: 'incrementCount',
        value: function incrementCount(parentCommentId) {
            var $count = this.$element.find('.js-comments-count');
            if (!$count.length) {
                return;
            }
            var count = parseInt($count[0].innerText);
            $count.text(count + 1);

            //increment replies count if there is a parent comment
            if (parentCommentId) {
                var $comment = this.$container.find('.js-comments-item[data-id="' + parentCommentId + '"]');
                var $commentListItem = $comment.closest('.js-comments-list-item');
                var $replyCountContainer = $comment.find('.js-reply-count-container');
                var $replyCount = $replyCountContainer.find('.js-reply-count');
                var newReplyCount = parseInt($replyCount.text()) + 1;
                $replyCount.text(newReplyCount);
                $replyCountContainer.addClass('is-visible');
                var $list = $commentListItem.find('>.js-comments-list');
                $list.data('replyCount', newReplyCount);
            }
        }
    }, {
        key: 'removeReplyingChilds',
        value: function removeReplyingChilds($currentComment) {
            var $reply = $currentComment.parent().find('.js-comments-item.is-replying');
            $reply.parent().remove();
        }
    }, {
        key: 'renderComments',
        value: function renderComments(data, startId) {
            var htmlString = this.listTemplateFunc(data);
            if (!startId) {
                this.$container.append(htmlString);
            } else {
                var $lastComment = this.$container.find('.js-comments-item[data-id="' + startId + '"]').eq(0);
                var $lastListItem = $lastComment.closest('.js-comments-list-item');
                $lastListItem.after(htmlString);
            }

            //$(window).trigger('content:updated');
        }
    }, {
        key: 'moreClickHandler',
        value: function moreClickHandler(e) {
            var $btn = (0, _jquery2.default)(e.target);
            var $list = $btn.closest('.js-comments-list');
            var $sameLevelItems = $list.find('>.js-comments-list-item');
            var $lastItem = $sameLevelItems.last();

            var $lastComment = $lastItem.find('>.js-comments-item');
            var depth = $lastComment.data('depth');
            var startId = $lastComment.data('id');
            var parentId = $lastComment.data('parentId');
            this.fetchComments({ startId: startId, parentId: parentId, depth: depth });
            $btn.remove();
        }
    }, {
        key: 'updateMoreButtons',
        value: function updateMoreButtons() {
            var _this5 = this;

            var $moreButtons = this.$container.find('.js-comments-more');
            $moreButtons.each(function (i, btn) {
                var $moreBtn = (0, _jquery2.default)(btn);
                var $list = $moreBtn.closest('.js-comments-list');
                var replyCount = $list.data('replyCount');
                var listItemsCount = $list.find('>.js-comments-list-item').length;
                if (typeof replyCount === 'number' && listItemsCount >= replyCount) {
                    $moreBtn.remove();
                }

                // first level reply button
                if (typeof replyCount !== 'number' && (listItemsCount % _this5.pageSize || _this5.latestReceivedCommentsCount === 0)) {
                    $moreBtn.remove();
                }
            });
        }
    }]);

    return Comments;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.CopyToClipboard = function (_Snappy$BaseComponent) {
    _inherits(CopyToClipboard, _Snappy$BaseComponent);

    _createClass(CopyToClipboard, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-copy-to-clipboard';
        }
    }]);

    function CopyToClipboard(element) {
        _classCallCheck(this, CopyToClipboard);

        return _possibleConstructorReturn(this, (CopyToClipboard.__proto__ || Object.getPrototypeOf(CopyToClipboard)).call(this, element));
    }

    _createClass(CopyToClipboard, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$btn = this.$element.find('.js-copy-btn');
            this.$string = this.$element.attr('data-string-to-copy');
            this.$input = this.$element.find('.js-copy-input');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$btn.on('click', this.onCopyButtonClick.bind(this));
        }
    }, {
        key: 'onCopyButtonClick',
        value: function onCopyButtonClick() {
            this.$input[0].value = this.$string;
            try {
                this.$input.select();
                document.execCommand('Copy');
                this.$btn.text('Copied to clipboard');
            } catch (err) {
                console.log("Can't copy to clipboard");
                alert(this.$string);
            }
        }
    }]);

    return CopyToClipboard;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduAlert = function (_Snappy$BaseComponent) {
    _inherits(EduAlert, _Snappy$BaseComponent);

    _createClass(EduAlert, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-alert';
        }
    }]);

    function EduAlert(element) {
        _classCallCheck(this, EduAlert);

        return _possibleConstructorReturn(this, (EduAlert.__proto__ || Object.getPrototypeOf(EduAlert)).call(this, element));
    }

    _createClass(EduAlert, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            if (!this.localStorage.eduAlert) {
                this.open();
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('eduAlert:close', this.close.bind(this));

            this.closeBtn.addEventListener('click', this.closeHandle.bind(this));

            this.ctaBtn.addEventListener('click', this.ctaClickHandle.bind(this));
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.localStorage = window.localStorage;
            this.element = this.$element[0];
            this.closeBtn = this.element.querySelector('.js-edu-alert__close');
            this.ctaBtn = this.element.querySelector('.js-edu-alert__cta');
            this.open = this.open.bind(this);
            this.close = this.close.bind(this);
        }
    }, {
        key: 'closeHandle',
        value: function closeHandle() {
            this.$window.trigger('eduAlert:close'); // close all instances
        }
    }, {
        key: 'open',
        value: function open() {
            this.element.classList.remove('is-closed');
            this.localStorage.setItem('eduAlert', 'true');
        }
    }, {
        key: 'close',
        value: function close() {
            this.element.classList.add('is-closed');
        }
    }, {
        key: 'removeFromStorage',
        value: function removeFromStorage() {
            this.localStorage.removeItem('eduAlert');
        }
    }, {
        key: 'ctaClickHandle',
        value: function ctaClickHandle() {
            this.$window.trigger('profileDisclaimer:open');
            this.$window.trigger('eduAlert:close');
        }
    }]);

    return EduAlert;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduArticlesFloatingIcons = function (_Snappy$BaseComponent) {
    _inherits(EduArticlesFloatingIcons, _Snappy$BaseComponent);

    _createClass(EduArticlesFloatingIcons, null, [{
        key: 'tagName',
        get: function get() {

            return 'edu-articles';
        }
    }]);

    function EduArticlesFloatingIcons(element) {
        _classCallCheck(this, EduArticlesFloatingIcons);

        return _possibleConstructorReturn(this, (EduArticlesFloatingIcons.__proto__ || Object.getPrototypeOf(EduArticlesFloatingIcons)).call(this, element));
    }

    _createClass(EduArticlesFloatingIcons, [{
        key: 'render',
        value: function render() {

            this.setVars();

            this.setEventListeners();

            this.onSocialFloatingIcons();
            this.onBackToTop();
        }
    }, {
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'onSocialFloatingIcons',
        value: function onSocialFloatingIcons() {
            _jquery2.default.noConflict();
            (function ($) {
                'use strict';

                // Main function

                $.shareButtons = function (options) {

                    // Define the defaults
                    var defaults = {
                        effect: '', // slide-on-scroll
                        buttons: {
                            'facebook': { class: 'facebook', use: false, icon: 'facebook', link: '', title: 'Follow on Facebook' },
                            'google': { class: 'gplus', use: false, icon: 'google-plus', link: '', title: 'Visit on Google Plus' },
                            'linkedin': { class: 'linkedin', use: false, icon: 'linkedin', link: '', title: 'Visit on LinkedIn' },
                            'twitter': { class: 'twitter', use: false, icon: 'twitter', link: '', title: 'Follow on Twitter' },
                            'pinterest': { class: 'pinterest', use: false, icon: 'pinterest', link: '', title: 'Follow on Pinterest' },
                            'phone': { class: 'phone', use: false, icon: 'phone', link: '', title: 'Call us', type: 'phone' },
                            'email': { class: 'email', use: false, icon: 'envelope', link: '', title: 'Send us an email', type: 'email' }
                        }
                    };

                    // Merge defaults and options
                    var s,
                        settings = options;
                    for (s in defaults.buttons) {
                        if (options.buttons[s]) {
                            settings.buttons[s] = $.extend(defaults.buttons[s], options.buttons[s]);
                        }
                    }

                    // Define the container for the buttons
                    var oContainer = $("#contact-buttons-bar");

                    // Check if the container is already on the page
                    if (oContainer.length === 0) {

                        // Insert the container element
                        $('body').append('<div id="contact-buttons-bar">');

                        // Get the just inserted element
                        oContainer = $("#contact-buttons-bar");

                        // Add class for effect
                        oContainer.addClass(settings.effect);

                        // Add show/hide button
                        var sShowHideBtn = '<button class="contact-button-link show-hide-contact-bar"><span class="fa fa-angle-left"></span></button>';
                        oContainer.append(sShowHideBtn);

                        var i;
                        for (i in settings.buttons) {
                            var bs = settings.buttons[i],
                                sLink = bs.link,
                                active = bs.use;

                            // Check if element is active
                            if (bs.use === true) {

                                // Change the link for phone and email when needed
                                if (bs.type === 'phone') {
                                    sLink = 'tel:' + bs.link;
                                } else if (bs.type === 'email') {
                                    sLink = 'mailto:' + bs.link;
                                }

                                // Insert the links
                                var sIcon = '<span class="fa fa-' + bs.icon + '"></span>',
                                    sButton = '<a href="' + sLink + '"class="contact-button-link cb-ancor ' + bs.class + '" ' + (bs.title ? 'title="' + bs.title + '"' : '') + (bs.extras ? bs.extras : '') + '>' + sIcon + '</a>';
                                oContainer.append(sButton);
                            }
                        }

                        // Make the buttons visible
                        setTimeout(function () {
                            oContainer.animate({ left: 0 });
                        }, 200);

                        // Show/hide buttons
                        $('body').on('click', '.show-hide-contact-bar', function (e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            $('.show-hide-contact-bar').find('.fa').toggleClass('fa-angle-right fa-angle-left');
                            oContainer.find('.cb-ancor').toggleClass('cb-hidden');
                        });
                    }
                };

                // Slide on scroll effect
                $(function () {

                    // Define element to slide
                    var el = $("#contact-buttons-bar.slide-on-scroll");

                    // Load top default
                    el.attr('data-top', el.css('top'));

                    // Listen to scroll
                    $(window).scroll(function () {
                        clearTimeout($.data(this, "scrollCheck"));
                        $.data(this, "scrollCheck", setTimeout(function () {
                            var nTop = $(window).scrollTop() + parseInt(el.attr('data-top'));
                            el.animate({
                                top: nTop
                            }, 100);
                        }, 50));
                    });
                });
            })(jQuery);
        }
    }, {
        key: 'onBackToTop',
        value: function onBackToTop() {
            (0, _jquery2.default)(document).ready(function () {
                (0, _jquery2.default)(window).scroll(function () {
                    if ((0, _jquery2.default)(this).scrollTop() > 50) {
                        (0, _jquery2.default)('#back-to-top').fadeIn();
                    } else {
                        (0, _jquery2.default)('#back-to-top').fadeOut();
                    }
                });
                // scroll body to 0px on click
                (0, _jquery2.default)('#back-to-top').click(function () {
                    (0, _jquery2.default)('#back-to-top').tooltip('hide');
                    (0, _jquery2.default)('body,html').animate({
                        scrollTop: 0
                    }, 800);
                    return false;
                });

                (0, _jquery2.default)('#back-to-top').tooltip('show');
            });
        }
    }]);

    return EduArticlesFloatingIcons;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(49);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.BootroomCarousel = function (_Snappy$BaseComponent) {
    _inherits(BootroomCarousel, _Snappy$BaseComponent);

    _createClass(BootroomCarousel, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-carousel';
        }
    }]);

    function BootroomCarousel(element) {
        _classCallCheck(this, BootroomCarousel);

        return _possibleConstructorReturn(this, (BootroomCarousel.__proto__ || Object.getPrototypeOf(BootroomCarousel)).call(this, element));
    }

    _createClass(BootroomCarousel, [{
        key: 'setVars',
        value: function setVars() {
            this.isOn = true;
            this.$carousel = this.$element.find('.carousel');

            this.options = {
                arrows: this.$element.data('carouselArrows'),
                autoplay: this.$element.data('carouselAutoplay'),
                autoplaySpeed: this.$element.data('carouselAutoplaySpeed'),
                pauseOnHover: this.$element.data('carouselPauseOnHover'),
                dots: this.$element.data('carouselDots'),
                slidesToShow: this.$element.data('carouselSlidesToShow') || 1,
                slidesToScroll: this.$element.data('carouselSlidesToScroll') || 1,
                speed: this.$element.data('carouselSpeed'),
                fade: this.$element.data('carouselFade'),
                appendDots: this.$element.find(this.$element.data('carouselDotsContainer')),
                mobileFirst: this.$element.data('carouselMobileFirst'),
                adaptiveHeight: this.$element.data('carouselAdaptiveHeight'),
                accessibility: this.$element.data('carouselAccessibility') || false,
                touchThreshold: 10,
                variableWidth: this.$element.data('carouselVariableWidth'),
                centerMode: this.$element.data('carouselCenterMode'),
                infinite: this.$element.data('carouselInfinite'),
                draggable: this.$element.data('carouselDraggable'),
                zIndex: 1,
                //here are not slick options
                arrowsTheme: this.$element.data('carouselArrowsTheme'),
                dynamicArrowsColor: this.$element.data('carouselDynamicArrowsColor'),
                mobileOn: this.$element.data('mobileOn') !== undefined ? this.$element.data('mobileOn') : true,
                tabletOn: this.$element.data('tabletOn') !== undefined ? this.$element.data('tabletOn') : true,
                desktopOn: this.$element.data('desktopOn') !== undefined ? this.$element.data('desktopOn') : true
            };

            if (this.$element.data('carouselResponsive')) {
                if (this.$element.data('carouselResponsiveUnslick') !== undefined) {
                    this.options.responsive = [{
                        breakpoint: parseInt(this.$element.data('carouselResponsiveBreakpoint'), 10),
                        settings: 'unslick'
                    }];
                } else {
                    this.options.responsive = this.getResponsiveBreakpointConfig(this.$element.data('carouselResponsiveBreakpoint'), this.$element.data('carouselResponsiveSlidesToShow'), this.$element.data('carouselResponsiveSlidesToScroll'));
                }
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var _this2 = this;

            (0, _jquery2.default)(window).on('resize:finished', this.onResize.bind(this));

            if (this.options.dynamicArrowsColor) {
                this.$carousel.on('afterChange', this.setArrowsColor.bind(this));
            }
            this.$carousel.on('afterChange', function () {
                _this2.setSlideComponents();
            });

            //this.$carousel.on('swipe', this.swipeHandler.bind(this));
        }
    }, {
        key: 'setSlideComponents',
        value: function setSlideComponents() {
            var titleElement = this.$element.find('.title-slide-' + this.$carousel.slick('slickCurrentSlide'));
            var buttonsElement = this.$element.find('.buttons-slide-' + this.$carousel.slick('slickCurrentSlide'));
            this.$element.find('.title-slide').css('display', 'none');
            titleElement.css('display', 'block');
            this.$element.find('.buttons-slide').css('display', 'none');
            buttonsElement.css('display', 'block');
            //this.$element.find('.search-holder label').css('color', titleElement.find('.special-word').css('color'))
        }
    }, {
        key: 'getResponsiveBreakpointConfig',
        value: function getResponsiveBreakpointConfig(breakpoints, slidesToShow, slidesToScroll) {
            var responsiveBreakpoints = [];

            breakpoints = breakpoints.toString().split(',');

            slidesToShow = slidesToShow ? slidesToShow = slidesToShow.toString().split(',') : [];
            slidesToScroll = slidesToScroll ? slidesToScroll.toString().split(',') : [];

            _jquery2.default.each(breakpoints, function (i, breakpoint) {
                responsiveBreakpoints.push({
                    breakpoint: parseInt(breakpoint, 10),
                    settings: {
                        slidesToShow: parseFloat(slidesToShow[i], 10) || 1,
                        slidesToScroll: parseFloat(slidesToScroll[i], 10) || 1
                    }
                });
            });

            return responsiveBreakpoints;
        }
    }, {
        key: 'initCarousel',
        value: function initCarousel() {
            this.setArrowsTheme();

            if (this.$element.data('carouselDeferInit')) {
                return false;
            }

            if (this.$carousel.hasClass('slick-initialized') && !this.isOn) {
                this.$carousel.slick('unslick');
            }

            if (!this.$carousel.hasClass('slick-initialized') && this.isOn) {
                this.$carousel.slick(this.options);
            }

            this.setArrowsColor();

            this.setSlideComponents();
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
        }
    }, {
        key: 'setArrowsTheme',
        value: function setArrowsTheme() {
            if (!this.options.arrowsTheme) {
                return;
            }
            switch (this.options.arrowsTheme) {
                case 'cfa':
                    this.options.prevArrow = '<button\n                class="slick-prev"\n                type="button"\n                title="Previous Slide"\n                aria-label="Previous Slide"\n                data-gtm-on = "click"\n                data-gtm-category="' + Carousel.currentSection + '"\n                data-gtm-action="Carousel Arrow"\n                data-gtm-label = "Previous Slide">\n                        <svg role="img" aria-label="Description of your SVG image" class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-left"></use>\n                        </svg>\n                    </button>';
                    this.options.nextArrow = '<button\n                class="slick-next"\n                type="button"\n                title="Next Slide"\n                aria-label="Next Slide"\n                data-gtm-on = "click"\n                data-gtm-category="' + Carousel.currentSection + '"\n                data-gtm-action="Carousel Arrow"\n                data-gtm-label = "Next Slide">\n                        <svg role="img" aria-label="Description of your SVG image" class="icon icon-arrow" width="12" height="20" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-right"></use>\n                        </svg>\n                    </button>';
                    break;

                case 'edu':
                    this.options.prevArrow = '<button\n                class="slick-prev js-arrow-left"\n                title="Previous Slide test"\n                aria-label="Previous Slide "\n                data-gtm-on = "click"\n                data-gtm-event-category="' + Carousel.currentSection + '"\n                data-gtm-event-action="Carousel Arrow"\n                data-gtm-event-label = "Previous Slide"\n                tabindex="-1">\n                        <svg role="img" aria-label="Description of your SVG image" class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-left-thin"></use>\n                        </svg>\n                    </button>';
                    this.options.nextArrow = '<button\n                class="slick-next js-arrow-right"\n                title="Next Slide test"\n                aria-label="Next Slide"\n                data-gtm-on = "click"\n                data-gtm-event-category="' + Carousel.currentSection + '"\n                data-gtm-event-action="Carousel Arrow"\n                data-gtm-event-label = "Next Slide"\n                tabindex="-1">\n                        <svg role="img" aria-label="Description of your SVG image" class="icon icon-arrow" width="16" height="28" aria-hidden="true" focusable="false">\n                            <use xlink:href="#icon-chevron-right-thin"></use>\n                        </svg>\n                    </button>';
                    break;
            }
        }
    }, {
        key: 'setArrowsColor',
        value: function setArrowsColor() {
            if (!this.options.dynamicArrowsColor) {
                return;
            }

            var $activeSlide = this.$carousel.find('.slick-active');
            var activeArrowColor = $activeSlide.data('arrowColor');
            this.$element.removeClass('white-arrows blue-arrows');

            switch (activeArrowColor) {
                case 'white':
                case 'opposite-blue':
                    this.$element.addClass('white-arrows');
                    break;
                case 'blue':
                case 'opposite-white':
                    this.$element.addClass('blue-arrows');
                    break;
            }
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            var isMobileOn = !_resize2.default.isTablet && this.options.mobileOn,
                isTabletOn = _resize2.default.isTablet && !_resize2.default.isDesktop && this.options.tabletOn,
                isDesktopOn = _resize2.default.isDesktop && this.options.desktopOn;
            this.isOn = isMobileOn || isTabletOn || isDesktopOn;

            this.initCarousel();
        }
    }, {
        key: 'swipeHandler',
        value: function swipeHandler(e, slick, direction) {
            (0, _jquery2.default)(window).trigger('gtm:send', [Carousel.currentSection, 'Carousel', 'Swipe ' + direction]);
        }
    }], [{
        key: 'currentSection',
        get: function get() {
            var mainNode = document.querySelector('#main-content');
            if (mainNode) {
                return mainNode.hasAttribute('data-current-section') ? mainNode.getAttribute('data-current-section') : '';
            }
            return '';
        }
    }]);

    return BootroomCarousel;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(function () {
    (0, _jquery2.default)(window).resize(function () {
        (0, _jquery2.default)('div.strip-carousel .carousel').slick('resize');
    });

    // remove aria-live from slick-list
    setTimeout(function () {
        var slickList = [].concat(_toConsumableArray(document.querySelectorAll('.slick-list')));
        slickList.forEach(function (x) {
            x.removeAttribute('aria-live');
        });
    }, 500);
});

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduCourseLoader = function (_Snappy$BaseComponent) {
    _inherits(EduCourseLoader, _Snappy$BaseComponent);

    _createClass(EduCourseLoader, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-course-loader';
        }
    }]);

    function EduCourseLoader(element) {
        _classCallCheck(this, EduCourseLoader);

        var _this = _possibleConstructorReturn(this, (EduCourseLoader.__proto__ || Object.getPrototypeOf(EduCourseLoader)).call(this, element));

        _this.element = element;
        _this.containerForTable = document.getElementById('availability');
        _this.pageID = _this.element.dataset.pageId;
        _this.firstPartUrl = window.location.host + '/educationhub/eduhubcourses/courseavailability?countyFAId=';

        _this.addListeners = _this.addListeners.bind(_this);
        _this.render = _this.render.bind(_this);
        _this.get = _this.get.bind(_this);
        _this.setOnLoad = _this.setOnLoad.bind(_this);
        _this.replaceTable = _this.replaceTable.bind(_this);
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    _createClass(EduCourseLoader, [{
        key: 'render',
        value: function render() {
            this.addListeners();

            if (this.element.value) {
                this.getAvailability();
            }
        }
    }, {
        key: 'addListeners',
        value: function addListeners() {
            this.element.addEventListener('change', this.onChange);
        }
    }, {
        key: 'getAvailability',
        value: function getAvailability() {
            this.containerForTable.style.minHeight = 200 + 'px';
            var value = this.element.value;
            var selectedText = this.element.options[this.element.selectedIndex].innerText;
            if (value.length > 0 && this.pageID) {
                this.containerForTable.classList.add('cfa-preloader--active');
                this.get(value);
                (0, _jquery2.default)(window).trigger('gtm:send', [this.$element.data('gtm-category'), this.$element.data('gtm-action'), selectedText + ' > ' + this.$element.data('title')]);
            }
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            this.getAvailability();
        }
    }, {
        key: 'get',
        value: function get(value) {
            this.url = (0, _jquery2.default)(location).attr('protocol') + '//' + this.firstPartUrl + value + '&pageId=' + this.pageID;

            this.request = new XMLHttpRequest();
            this.request.onloadend = this.setOnLoad;
            this.request.open('GET', this.url);
            this.request.send();
        }
    }, {
        key: 'setOnLoad',
        value: function setOnLoad() {
            if (this.request.readyState === 4 && this.request.status === 200) {
                this.replaceTable(this.request.response);
            } else {
                console.log('Error on ' + this.url + '  \nHTTP status:\n readyState = ' + this.request.readyState + '\n status = ' + this.request.status);
            }
        }
    }, {
        key: 'replaceTable',
        value: function replaceTable(response) {
            this.containerForTable.classList.remove('cfa-preloader--active');
            this.containerForTable.innerHTML = response;
            this.containerForTable.removeAttribute('style');
            (0, _jquery2.default)(window).trigger('content:updated');
        }
    }]);

    return EduCourseLoader;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduCourseOverview = function (_Snappy$BaseComponent) {
    _inherits(EduCourseOverview, _Snappy$BaseComponent);

    _createClass(EduCourseOverview, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-course-overview';
        }
    }]);

    function EduCourseOverview(element) {
        _classCallCheck(this, EduCourseOverview);

        return _possibleConstructorReturn(this, (EduCourseOverview.__proto__ || Object.getPrototypeOf(EduCourseOverview)).call(this, element));
    }

    _createClass(EduCourseOverview, [{
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onSidebarFloating();
            this.onCourseAvailablity();
            this.onCustomScrollbar();
        }
    }, {
        key: 'onCustomScrollbar',
        value: function onCustomScrollbar() {
            if ((0, _jquery2.default)(window).width() < 960) {
                (0, _jquery2.default)("body .course-page__overview-sidebar").removeClass('mCustomScrollbar');
            }
        }
    }, {
        key: 'onSidebarFloating',
        value: function onSidebarFloating() {
            (0, _jquery2.default)(function () {
                var offset = (0, _jquery2.default)("#sidebar").offset();
                var topPadding = 100;
                //var fixedBottom = $("footer");
                (0, _jquery2.default)(window).scroll(function () {
                    (0, _jquery2.default)("#sidebar").show();
                    if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() > (0, _jquery2.default)(document).height() - ((0, _jquery2.default)('.course-page__interested-section .fa-carousel.fa-carousel--edu-style').height() + (0, _jquery2.default)('footer').height())) {
                        (0, _jquery2.default)("#sidebar").hide();
                    }
                    if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() > (0, _jquery2.default)(document).height() - ((0, _jquery2.default)('.fa-footer').height() + 300)) {
                        (0, _jquery2.default)("#sidebar").hide();
                    }
                    if ((0, _jquery2.default)(window).scrollTop() > offset.top) {
                        (0, _jquery2.default)("#sidebar").stop().animate({
                            marginTop: (0, _jquery2.default)(window).scrollTop() - offset.top + topPadding
                        });
                    } else {
                        (0, _jquery2.default)("#sidebar").stop().animate({
                            marginTop: 0
                        });
                    };
                });
            });
        }
    }, {
        key: 'onCourseAvailablity',
        value: function onCourseAvailablity() {
            var courseAvail = (0, _jquery2.default)('.course-part').length;
            (0, _jquery2.default)('.course-part').hide();
            (0, _jquery2.default)('.course-part.static-course').show();
            (0, _jquery2.default)('.course-part:nth-child(2)').show();
            (0, _jquery2.default)('.course-part:nth-child(3)').show();
            (0, _jquery2.default)('#show-more-two').hide();
            (0, _jquery2.default)('#show-more').on('click', function () {
                if (courseAvail > 2) {
                    (0, _jquery2.default)('.course-part').show();
                    (0, _jquery2.default)('#show-more').hide();
                    (0, _jquery2.default)('#show-more-two').show();
                }
            });
            (0, _jquery2.default)('#show-more-two').on('click', function () {
                if (courseAvail > 2) {
                    (0, _jquery2.default)('.course-part').hide();
                    (0, _jquery2.default)('.course-part:nth-child(2)').show();
                    (0, _jquery2.default)('.course-part:nth-child(3)').show();
                    (0, _jquery2.default)('#show-more-two').hide();
                    (0, _jquery2.default)('#show-more').show();
                }
            });
        }
    }]);

    return EduCourseOverview;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduDisclaimer = function (_Snappy$BaseComponent) {
    _inherits(EduDisclaimer, _Snappy$BaseComponent);

    _createClass(EduDisclaimer, null, [{
        key: "tagName",
        get: function get() {
            return 'edu-disclaimer';
        }
    }]);

    function EduDisclaimer(element) {
        _classCallCheck(this, EduDisclaimer);

        return _possibleConstructorReturn(this, (EduDisclaimer.__proto__ || Object.getPrototypeOf(EduDisclaimer)).call(this, element));
    }

    _createClass(EduDisclaimer, [{
        key: "render",
        value: function render() {
            this.$content = null;
            this.setEventListeners();
        }
    }, {
        key: "setEventListeners",
        value: function setEventListeners() {
            this.$window.on('profileDisclaimer:open', this.open.bind(this));
        }
    }, {
        key: "open",
        value: function open() {
            if (!this.$content) {
                this.prepareContent();
            }

            this.$window.trigger('modal:openModal', {
                $view: this.$content,
                $prevElement: (0, _jquery2.default)(document)
            });
        }
    }, {
        key: "prepareContent",
        value: function prepareContent() {
            var templateSource = (0, _jquery2.default)('#edu-disclaimer-template').html();
            var templateFiunc = _handlebars2.default.compile(templateSource);
            var htmlString = templateFiunc({});
            this.$content = (0, _jquery2.default)(htmlString);
        }
    }]);

    return EduDisclaimer;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

var _queryString = __webpack_require__(57);

var _queryString2 = _interopRequireDefault(_queryString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduFilters = function (_Snappy$BaseComponent) {
    _inherits(EduFilters, _Snappy$BaseComponent);

    _createClass(EduFilters, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-filters';
        }
    }]);

    function EduFilters(element) {
        _classCallCheck(this, EduFilters);

        return _possibleConstructorReturn(this, (EduFilters.__proto__ || Object.getPrototypeOf(EduFilters)).call(this, element));
    }

    _createClass(EduFilters, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            if (this.$sortSelect.length) {
                this.initMobileSorting();
            }
            this.setChosenFiltersByQS();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.$filters = this.$element.find('.js-filter');
            this.$sortInputs = this.$element.find('.js-filter-control[name=sortby]');
            this.$sortSelect = this.$element.find('.js-mobile-sort');
            this.$primaryFilters = this.$element.find('.js-filter-primary .js-filter');
            this.$openers = this.$element.find('.js-filter-opener');
            this.$overlayToggler = this.$element.find('.js-overlay-toggle');
            this.$dropdowns = this.$element.find('.js-filter-dropdown');
            this.$closeBtns = this.$element.find('.js-filter-close');
            this.$clearBtns = this.$element.find('.js-filter-clear');
            this.$clearAll = this.$element.find('.js-filter-clear-all');
            this.$mobileclearAll = this.$element.find('.js-mobile-clear-all');
            this.$applyAll = this.$element.find('.js-filters-apply-all');
            this.lastQS = '';
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));

            this.$openers.on('click', this.toggleFilter.bind(this));
            this.$overlayToggler.on('click', this.toggleOverlay.bind(this));
            this.$closeBtns.on('click', this.closeHandler.bind(this));
            this.$clearBtns.on('click', this.clearBtnHandler.bind(this));
            this.$mobileclearAll.on('click', this.clearAllFilters.bind(this));
            this.$clearAll.on('click', this.clearAllFilters.bind(this));
            this.$filters.on('change', this.changeHandler.bind(this));
            this.$sortSelect.on('change', this.mobileSortHandler.bind(this));
            this.$applyAll.on('click', this.applyAllClickHandler.bind(this));

            this.setListenersByScreen();
        }
    }, {
        key: 'setChosenFiltersByQS',
        value: function setChosenFiltersByQS() {
            this.lastQS = window.location.search.slice(1);
            var qsParsed = _queryString2.default.parse(this.lastQS);
            var names = Object.keys(qsParsed);

            var inputsToCheck = [];
            var wrapper = this.$element[0];
            names.forEach(function (name) {
                qsParsed[name] = window.decodeURIComponent(qsParsed[name]).split(',');
                qsParsed[name].forEach(function (val) {
                    var input = wrapper.querySelector('.js-filter-control[name=\'' + name + '\'][value=\'' + val + '\']');
                    if (input !== null) {
                        inputsToCheck.push(input);
                    }
                });
            });

            for (var i = 0; i < inputsToCheck.length; i++) {
                inputsToCheck[i].checked = true;
            }

            this.updateAllFilters();
            if (this.lastQS) {
                this.$window.trigger('contentLoader:setQueryString', [this.lastQS]);
            }
        }
    }, {
        key: 'initMobileSorting',
        value: function initMobileSorting() {
            var optionsString = '';
            this.$sortInputs.each(function (i, item) {
                optionsString += '<option value="' + item.value + '">' + item.getAttribute('data-label') + '</option>';
            });

            this.$sortSelect[0].innerHTML = optionsString;
        }
    }, {
        key: 'setListenersByScreen',
        value: function setListenersByScreen() {
            if (_resize2.default.isDesktop) {
                this.$document.on('click', this.onDocumentClick.bind(this));
            }
        }
    }, {
        key: 'closeHandler',
        value: function closeHandler(e) {
            this.toggleFilter(e);
            this.applyFilters();
        }
    }, {
        key: 'toggleFilter',
        value: function toggleFilter(e) {
            if (!_resize2.default.isDesktop) {
                return;
            }

            this.$currentFilter = (0, _jquery2.default)(e.target).closest('.js-filter');
            this.$currentOpener = (0, _jquery2.default)(e.target).closest('.js-filter-opener');
            this[this.$currentFilter.hasClass('is-opened') ? 'close' : 'open']();
        }
    }, {
        key: 'toggleOverlay',
        value: function toggleOverlay() {
            this[this.$element.hasClass('is-overlay-opened') ? 'closeOverlay' : 'openOverlay']();
        }
    }, {
        key: 'openOverlay',
        value: function openOverlay() {
            this.$element.addClass('is-overlay-opened');
        }
    }, {
        key: 'closeOverlay',
        value: function closeOverlay() {
            this.$element.removeClass('is-overlay-opened');
        }
    }, {
        key: 'open',
        value: function open() {
            this.closeAll();
            this.$currentFilter.addClass('is-opened');
            this.$currentOpener.attr('aria-expanded', 'true');
        }
    }, {
        key: 'close',
        value: function close() {
            this.$currentFilter.removeClass('is-opened');
            this.$currentOpener.attr('aria-expanded', 'false');
        }
    }, {
        key: 'clearBtnHandler',
        value: function clearBtnHandler(e) {
            var $filter = (0, _jquery2.default)(e.target).closest('.js-filter');
            this.clearFilter($filter);
        }
    }, {
        key: 'clearAllFilters',
        value: function clearAllFilters() {
            var _this2 = this;

            this.$filters.each(function (i, el) {
                _this2.clearFilter((0, _jquery2.default)(el));
            });
            this.applyFilters();
        }
    }, {
        key: 'clearFilter',
        value: function clearFilter($filter) {
            var $inputs = $filter.find('.js-filter-control');
            $inputs.prop('checked', false);
            EduFilters.updateFilter($filter);
        }
    }, {
        key: 'closeAll',
        value: function closeAll() {
            this.$filters.removeClass('is-opened');
            this.$openers.attr('aria-expanded', 'false');
        }
    }, {
        key: 'closeFilter',
        value: function closeFilter($filter) {
            $filter.removeClass('is-opened');
            var $opener = $filter.find('.js-filter-opener');
            $opener.attr('aria-expanded', 'false');
        }
    }, {
        key: 'applyFilters',
        value: function applyFilters() {
            var qs = this.getQueryString();
            if (this.lastQS !== qs) {

                this.$window.trigger('contentLoader:loadByQueryString', [qs]);
                this.lastQS = qs;
                this.trackFilter();
            }
        }
    }, {
        key: 'applyAllClickHandler',
        value: function applyAllClickHandler() {
            this.applyFilters();
            this.closeOverlay();
        }
    }, {
        key: 'changeHandler',
        value: function changeHandler(e) {
            var $filter = (0, _jquery2.default)(e.delegateTarget);
            EduFilters.updateFilter($filter);
            this.updateClearAllbtn();
            if ($filter[0].hasAttribute('data-filter-auto-apply')) {
                this.applyFilters();
                this.closeFilter($filter);
            }
        }
    }, {
        key: 'mobileSortHandler',
        value: function mobileSortHandler() {
            var sortVal = this.$sortSelect.val();
            this.$sortInputs.each(function (i, item) {
                item.checked = item.value === sortVal;
            });
            this.applyFilters();
        }
    }, {
        key: 'onDocumentClick',
        value: function onDocumentClick(e) {
            if (!(0, _jquery2.default)(e.target).closest('.js-filter, .js-filter-clear-all').length) {
                if (this.$filters.filter('.is-opened').length) {
                    this.closeAll();
                    this.applyFilters();
                }
            }
        }
    }, {
        key: 'getQueryString',
        value: function getQueryString() {
            var qsByName = {};
            var $checkedControls = this.$element.find('.js-filter-control:checked');
            $checkedControls.each(function (i, el) {
                if (!qsByName[el.name]) {
                    qsByName[el.name] = [];
                }
                qsByName[el.name].push(el.value);
            });

            var names = Object.keys(qsByName);
            names.forEach(function (name) {
                qsByName[name] = qsByName[name].join(',');
            });

            return _queryString2.default.stringify(qsByName);
        }
    }, {
        key: 'getTrackingFilterString',
        value: function getTrackingFilterString() {
            var arr = [];
            var $checkedControls = this.$element.find('.js-filter-control:checked');
            $checkedControls.each(function (i, el) {
                arr.push(el.name + ': ' + el.getAttribute('data-label'));
            });

            return arr.join(' > ');
        }
    }, {
        key: 'trackFilter',
        value: function trackFilter() {
            var trackingData = this.getTrackingFilterString();
            if (trackingData) {
                (0, _jquery2.default)(window).trigger('gtm:send', ['Filter', trackingData, document.title]);
            }
        }
    }, {
        key: 'updateClearAllbtn',
        value: function updateClearAllbtn() {}
    }, {
        key: 'onResize',
        value: function onResize() {}
    }, {
        key: 'updateAllFilters',
        value: function updateAllFilters() {
            this.$filters.each(function (i, filter) {
                EduFilters.updateFilter((0, _jquery2.default)(filter));
            });
        }
    }], [{
        key: 'getCheckedCount',
        value: function getCheckedCount($filter) {
            var $checkedControls = $filter.find('.js-filter-control:checked');
            return $checkedControls.length;
        }
    }, {
        key: 'updateFilter',
        value: function updateFilter($filter) {
            var checkedCount = EduFilters.getCheckedCount($filter);
            if (checkedCount > 0) {
                if ($filter.closest('.js-filter-primary').length) {
                    $filter.addClass('is-dirty');
                }

                var $count = $filter.find('.js-filter-checked-count');
                if ($count.length) {
                    $count.html(checkedCount);
                }
            } else {
                $filter.removeClass('is-dirty');
            }

            var $chosenLabel = $filter.find('.js-filter-chosen');
            if ($chosenLabel.length) {
                if (checkedCount > 0) {
                    var $checkedControl = $filter.find('.js-filter-control:checked');
                    var checkedLabel = $checkedControl.data('label');
                    $chosenLabel.text(': ' + checkedLabel);
                } else {
                    $chosenLabel.empty();
                }
            }
        }
    }]);

    return EduFilters;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _timers = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduFindlearning = function (_Snappy$BaseComponent) {
    _inherits(EduFindlearning, _Snappy$BaseComponent);

    _createClass(EduFindlearning, null, [{
        key: 'tagName',
        get: function get() {

            return 'edu-find-learning';
        }
    }]);

    function EduFindlearning(element) {
        _classCallCheck(this, EduFindlearning);

        return _possibleConstructorReturn(this, (EduFindlearning.__proto__ || Object.getPrototypeOf(EduFindlearning)).call(this, element));
    }

    _createClass(EduFindlearning, [{
        key: 'render',
        value: function render() {

            this.setVars();

            this.setEventListeners();

            this.onButtonSearch();
            this.onDdlDiscipline();
            this.onShowNextMonthResult();
            this.onDatePickerField();
            this.onClearAllField();
            this.onMoreDetailsClick();
            // this.onPostCodeField();
            //this.onddlCountyField();
            this.onddlRangeField();
            this.onPopupWindow();
        }
    }, {
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'onPopupWindow',
        value: function onPopupWindow() {

            (0, _jquery2.default)(document).ready(function () {
                if (window.location.href.indexOf("isUserQualified=false") > -1) {
                    (0, _jquery2.default)('#memberModal').modal('show');
                }
            });
        }
    }, {
        key: 'onButtonSearch',
        value: function onButtonSearch() {
            // alert("onButtonSearch");
            // var snappyObject = this;
            (0, _jquery2.default)(document).on('click', "#btnSearch", function (evt) {
                // this.onDatePickerField();


                var discipline = (0, _jquery2.default)("#ddlDiscipline").val();
                var level = (0, _jquery2.default)("#ddlLevel").val();
                var selectedMonth = (0, _jquery2.default)("#ddlDate").val();
                //var county = $("#ddlCounty").val().toLowerCase();
                var PostCodeLat = (0, _jquery2.default)("#Lat").val();
                var PostCodeLng = (0, _jquery2.default)("#Lng").val();
                var PostCode = (0, _jquery2.default)("#PostCode").val();
                var range = (0, _jquery2.default)("#ddlRange").val();
                //if (county != "") {
                //    PostCodeLat = ""; PostCodeLng = ""; PostCode = ""; range = "";
                //}

                _jquery2.default.ajax({
                    url: "/api/sitecore/EduHubFindLearning/GetAvailableCourses?discipline=" + discipline + "&level=" + level + "&startMonth=" + selectedMonth + "&postcode=" + PostCode + "&postCodeLat=" + PostCodeLat + "&postCodeLon=" + PostCodeLng + "&radius=" + range,
                    type: "GET",
                    dataType: 'html',

                    success: function success(data) {
                        (0, _jquery2.default)("#availability").html(data);

                        // snappyObject.onDatePickerField();
                    },
                    error: function error() {

                        console.log("Error on Get Available Courses Ajax Call");
                    }
                });
                evt.stopImmediatePropagation();
            });
        }
    }, {
        key: 'onShowNextMonthResult',
        value: function onShowNextMonthResult() {

            (0, _jquery2.default)(document).on('click', "#showNextMonthResult", function (evt) {
                // alert("please fix being tough");
                var discipline = (0, _jquery2.default)("#ddlDiscipline").val();
                var level = (0, _jquery2.default)("#ddlLevel").val();
                var selectedMonth = (0, _jquery2.default)("#hidNextMonthYear").val();
                //var county = $("#ddlCounty").val().toLowerCase();
                var PostCodeLat = (0, _jquery2.default)("#Lat").val();
                var PostCodeLng = (0, _jquery2.default)("#Lng").val();
                var PostCode = (0, _jquery2.default)("#PostCode").val();
                var range = (0, _jquery2.default)("#ddlRange").val();
                //if (county != "") {
                //    PostCodeLat = ""; PostCodeLng = ""; PostCode = ""; range = "";
                //}
                _jquery2.default.ajax({
                    url: "/api/sitecore/EduHubFindLearning/GetAvailableCourses?discipline=" + discipline + "&level=" + level + "&startMonth=" + selectedMonth + "&postcode=" + PostCode + "&postCodeLat=" + PostCodeLat + "&postCodeLon=" + PostCodeLng + "&radius=" + range,
                    type: "GET",
                    dataType: 'html',

                    success: function success(data) {
                        (0, _jquery2.default)("#availability").html(data);
                    },
                    error: function error() {
                        console.log("Error on Get Available Courses Ajax Call");
                    }
                });

                evt.stopImmediatePropagation();
            });
        }
    }, {
        key: 'onDdlDiscipline',
        value: function onDdlDiscipline() {

            (0, _jquery2.default)(document).on('change', "#ddlDiscipline", function (evt) {
                var discipline = (0, _jquery2.default)("#ddlDiscipline").val();
                //alert(discipline);
                _jquery2.default.ajax({
                    url: "/api/sitecore/EduHubFindLearning/GetAvailableLevels?discipline=" + discipline,
                    type: "GET",
                    dataType: 'json',

                    success: function success(data) {
                        var obj = JSON.parse(data);
                        if (obj != null) {
                            (0, _jquery2.default)('#ddlLevel').empty();
                            var buildHtml = '';
                            for (var i in obj) {
                                buildHtml += '<option value="' + obj[i] + '">' + i + '</option>';
                            }
                            (0, _jquery2.default)('#ddlLevel').html(buildHtml);
                        }
                    },
                    error: function error() {
                        console.log("Error on Get Available Levels Ajax Call");
                    }
                });
                evt.stopImmediatePropagation();
            });
        }
    }, {
        key: 'onDatePickerField',
        value: function onDatePickerField() {
            _jquery2.default.noConflict();
            var datePickerTimer = setInterval(function () {
                //alert("set---interval");
                // alert(typeof (jQuery('#datepicker').datepicker));
                if (typeof (0, _jquery2.default)('#datepicker').datepicker != 'undefined') {
                    clearInterval(datePickerTimer);
                    //alert("if class----");


                    var user_busy_days = [];
                    (0, _jquery2.default)(".course-part.calendarValue").each(function () {

                        user_busy_days.push((0, _jquery2.default)(this).attr('data-startdate'));
                    });
                    // ale
                    var tempDate = user_busy_days[0].split('-');
                    var defaultValue = new Date(tempDate[0], parseInt(tempDate[1]) - 1, tempDate[2]);

                    (0, _jquery2.default)('#datepicker').datepicker({

                        todayHighlight: true,
                        todayBtn: true,
                        autoclose: true,
                        weekStart: 1,
                        startDate: defaultValue,

                        beforeShowDay: function beforeShowDay(date) {

                            calender_date = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

                            var search_index = _jquery2.default.inArray(calender_date, user_busy_days);
                            //alert(calender_date);
                            //  console.log(calender_date +'/'+ user_busy_days);
                            if (search_index > -1) {
                                return { classes: 'highlight' };
                            }
                        }
                    });
                };
            }, 1000);
        }
    }, {
        key: 'onClearAllField',
        value: function onClearAllField() {
            (0, _jquery2.default)(".clear-all a").on('click', function (e) {
                e.preventDefault();
                (0, _jquery2.default)("#st").val("");
                // $("#st").val("");
                //$('#ddlCounty').prop("disabled", false);
                (0, _jquery2.default)('#ddlRange').prop("disabled", true);
                (0, _jquery2.default)('select').each(function () {

                    (0, _jquery2.default)(this).find('option').first().attr("selected", "selected");

                    (0, _jquery2.default)('#st').prop("disabled", false);
                });

                (0, _jquery2.default)('select option').prop('selected', function () {
                    //alert('select----value');
                    return this.defaultSelected;
                    (0, _jquery2.default)('#st').prop("disabled", false);
                });
            });
        }
    }, {
        key: 'onMoreDetailsClick',
        value: function onMoreDetailsClick() {

            (0, _jquery2.default)(document).on('click', ".book-course .more-details  a", function () {

                if ((0, _jquery2.default)(this).attr('aria-expanded') === "true") {

                    (0, _jquery2.default)(this).closest(".book-course").addClass("book_bg_color");
                } else {

                    (0, _jquery2.default)(this).closest(".book-course").removeClass("book_bg_color");
                }
            });
            (0, _jquery2.default)(document).on('click', ".book-course .more-details  a", function () {

                (0, _jquery2.default)(this).closest(".book-course").find(".expanded-value").css('display', 'none');

                if ((0, _jquery2.default)(window).width() > 992) {

                    if ((0, _jquery2.default)(this).attr('aria-expanded') === "true") {

                        (0, _jquery2.default)(this).closest(".book-course").find(".expanded-value").css('display', 'block');
                        (0, _jquery2.default)(this).closest(".book-course").find(".left-value-part").css('display', 'none');
                    } else {

                        (0, _jquery2.default)(this).closest(".book-course").find(".expanded-value").css('display', 'none');
                        (0, _jquery2.default)(this).closest(".book-course").find(".left-value-part").css('display', 'block');
                    }
                }
            });
        }

        //onPostCodeField() {

        //    $(document).on('change', "#ddlCounty", function () {

        //        if ($(this).val() !== '') {
        //            $('#st').prop("disabled", true);

        //        } else {
        //            $('#st').prop("disabled", false);
        //        }
        //    });

        //}
        //onddlCountyField() {

        //    $(document).on('keypress  change', "#st", function () {

        //        if ($(this).val() !== '') {
        //            $('#ddlCounty').prop("disabled", true);

        //        } else {
        //            $('#ddlCounty').prop("disabled", false);
        //        }
        //    });
        //    $(document).on('keypress change', "#Lat", function () {

        //        if ($(this).val() !== '') {
        //            $('#ddlCounty').prop("disabled", true);

        //        } else {
        //            $('#ddlCounty').prop("disabled", false);
        //        }
        //    });
        //    $(document).on('keypress  change', "#Lng", function () {

        //        if ($(this).val() !== '') {
        //            $('#ddlCounty').prop("disabled", true);

        //        } else {
        //            $('#ddlCounty').prop("disabled", false);
        //        }
        //    });
        //    $(document).on('keypress  change', "#sd", function () {

        //        if ($(this).val() !== '') {
        //            $('#ddlCounty').prop("disabled", true);

        //        } else {
        //            $('#ddlCounty').prop("disabled", false);
        //        }
        //    });
        //    $(document).on('keypress  change', "#PostCode", function () {

        //        if ($(this).val() !== '') {
        //            $('#ddlCounty').prop("disabled", true);

        //        } else {
        //            $('#ddlCounty').prop("disabled", false);
        //        }
        //    });
        //}

    }, {
        key: 'onddlRangeField',
        value: function onddlRangeField() {
            (0, _jquery2.default)('#ddlRange').prop("disabled", true);
            (0, _jquery2.default)(document).on('keypress  change', "#st", function () {

                if ((0, _jquery2.default)(this).val() !== '') {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", false);
                } else {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", true);
                }
            });
            (0, _jquery2.default)(document).on('keypress  change', "#Lan", function () {

                if ((0, _jquery2.default)(this).val() !== '') {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", false);
                } else {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", true);
                }
            });
            (0, _jquery2.default)(document).on('keypress  change', "#Lng", function () {

                if ((0, _jquery2.default)(this).val() !== '') {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", false);
                } else {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", true);
                }
            });
            (0, _jquery2.default)(document).on('keypress  change', "#sd", function () {

                if ((0, _jquery2.default)(this).val() !== '') {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", false);
                } else {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", true);
                }
            });
            (0, _jquery2.default)(document).on('keypress  change', "#PostCode", function () {

                if ((0, _jquery2.default)(this).val() !== '') {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", false);
                } else {
                    (0, _jquery2.default)('#ddlRange').prop("disabled", true);
                }
            });
        }
    }]);

    return EduFindlearning;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduIntroTour = function (_Snappy$BaseComponent) {
    _inherits(EduFeedback, _Snappy$BaseComponent);

    _createClass(EduFeedback, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-intro-tour';
        }
    }]);

    function EduFeedback(element) {
        _classCallCheck(this, EduFeedback);

        var _this = _possibleConstructorReturn(this, (EduFeedback.__proto__ || Object.getPrototypeOf(EduFeedback)).call(this, element));

        _this.animated = false;
        return _this;
    }

    _createClass(EduFeedback, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setCookie();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.introTourVisibilityKey = 'edu_intro_tour_visible';
            this.animated = this.element.dataset.animated === "true" ? true : false;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            if (this.animated) {
                window.addEventListener('DOMContentLoaded', this.onLoad.bind(this));
            }
        }
    }, {
        key: 'onLoad',
        value: function onLoad() {
            this.element.classList.add('is-loaded');
        }
    }, {
        key: 'setCookie',
        value: function setCookie() {
            if (this.getCookie(this.introTourVisibilityKey)) return;

            var expiresDate = new Date(new Date().getTime() + 31556926 * 1000);

            document.cookie = this.introTourVisibilityKey + '=true; path=/; expires=' + expiresDate.toUTCString();
        }
    }, {
        key: 'getCookie',
        value: function getCookie(name) {
            var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        }
    }]);

    return EduFeedback;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduLogout = function (_Snappy$BaseComponent) {
    _inherits(EduLogout, _Snappy$BaseComponent);

    _createClass(EduLogout, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-logout';
        }
    }]);

    function EduLogout(element) {
        _classCallCheck(this, EduLogout);

        return _possibleConstructorReturn(this, (EduLogout.__proto__ || Object.getPrototypeOf(EduLogout)).call(this, element));
    }

    _createClass(EduLogout, [{
        key: 'setVars',
        value: function setVars() {
            this.button = (0, _jquery2.default)(this.$element);
            this.url = this.button.data('logoutUrl');
            this.openWindow = this.button.data('openWindow');
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            if (this.openWindow) {
                this.openWindow();
            } else {
                this.openIframe();
                e.stopPropagation();
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.button.on('click', this.handleClick.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'openIframe',
        value: function openIframe() {
            (0, _jquery2.default)('body').append('<iframe id=\'logout-hiddenProcess\' src=\'' + this.url + '\' style=\'display:none\'></iframe>');
            (0, _jquery2.default)('body').append('<div id=\'logout-message\' style=\'z-index: 10; position:absolute; height: 100vh; width: 100vw\'>\n                <div style=\'position:absolute; top:50%; left:50%; transform: translate(-50%,-50%); padding: 40px; background-color:#011e41; color:white; width: 100%; max-width: 500px; text-align: center\'>\n                    Logging Out\n                </div></div>');
            //$('#logout-hiddenProcess').load(this.url, () => { alert("page loaded") })
            (0, _jquery2.default)('#logout-hiddenProcess').on('load', function () {
                window.location.reload();
            });
        }
    }, {
        key: 'openWindow',
        value: function openWindow() {
            var logoutWindow = window.open(this.url, 'logoutWindow', 'width=1, height=1,toolbar=no,status=no');

            logoutWindow.addEventListener('load', function () {
                logoutWindow.close();
                window.location.reload();
            }, false);

            //logoutWindow.addEventListener('DOMContentLoaded', () => {
            //console.log("a");
            //}, false);
        }
    }]);

    return EduLogout;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduPostLoginDrd = function (_Snappy$BaseComponent) {
    _inherits(EduPostLoginDrd, _Snappy$BaseComponent);

    _createClass(EduPostLoginDrd, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-post-login-drd';
        }
    }]);

    function EduPostLoginDrd(element) {
        _classCallCheck(this, EduPostLoginDrd);

        return _possibleConstructorReturn(this, (EduPostLoginDrd.__proto__ || Object.getPrototypeOf(EduPostLoginDrd)).call(this, element));
    }

    _createClass(EduPostLoginDrd, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.isOpened = false;
            this.$opener = this.$element.find('.js-edu-post-login-drd-opener');
            this.$disclaimerTrigger = this.$element.find('.js-edu-post-login-drd-disclaimer');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$opener.on('click', this.toggle.bind(this));
            this.$body.on('click', this.bodyClickHandle.bind(this));
            this.$disclaimerTrigger.on('click', this.disclaimerClickHandle.bind(this));
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            this[this.isOpened ? 'close' : 'open']();
        }
    }, {
        key: 'open',
        value: function open() {
            this.$element.addClass('is-opened');
            this.isOpened = true;
        }
    }, {
        key: 'close',
        value: function close() {
            this.$element.removeClass('is-opened');
            this.isOpened = false;
        }
    }, {
        key: 'bodyClickHandle',
        value: function bodyClickHandle(e) {
            var $target = $(e.target);
            if (this.isOpened && !$target.closest('[data-edu-post-login-drd]').length) {
                this.close();
            }
        }
    }, {
        key: 'disclaimerClickHandle',
        value: function disclaimerClickHandle(e) {
            e.preventDefault();
            this.close();
            this.$window.trigger('profileDisclaimer:open');
        }
    }]);

    return EduPostLoginDrd;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduPrivacyToggler = function (_Snappy$BaseComponent) {
    _inherits(EduPrivacyToggler, _Snappy$BaseComponent);

    _createClass(EduPrivacyToggler, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-privacy-toggler';
        }
    }]);

    function EduPrivacyToggler(element) {
        _classCallCheck(this, EduPrivacyToggler);

        return _possibleConstructorReturn(this, (EduPrivacyToggler.__proto__ || Object.getPrototypeOf(EduPrivacyToggler)).call(this, element));
    }

    _createClass(EduPrivacyToggler, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.applyContent();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$switcher = this.$element.find('.js-switcher');
            this.$endpointUrl = this.$element.attr('data-endpoint-url');
            this.$togglerContentPlaceholder = this.$element.find('[data-toggler-content-placeholder]');
            this.$currentPrivacy = this.$element.attr('data-current-privacy');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$switcher.on('change', this.onSwitcherChange.bind(this));
        }
    }, {
        key: 'onSwitcherChange',
        value: function onSwitcherChange() {
            var _this2 = this;

            this.$currentPrivacy = this.$currentPrivacy === 'private' ? 'public' : 'private';

            if ('requestIdleCallback' in window) {
                requestIdleCallback(function () {
                    return _this2.changePrivacyType(_this2.$currentPrivacy);
                }, {
                    timeout: 1500
                });
            } else {
                this.changePrivacyType(this.$currentPrivacy);
            }
        }
    }, {
        key: 'changePrivacyType',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(currentPrivacy) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _jquery2.default.ajax({
                                    context: this,
                                    type: 'POST',
                                    url: this.$endpointUrl,
                                    data: { profileType: currentPrivacy },
                                    success: this.onSuccess,
                                    error: this.onError
                                });

                            case 3:
                                _context.next = 9;
                                break;

                            case 5:
                                _context.prev = 5;
                                _context.t0 = _context['catch'](0);

                                this.onError.bind(this);
                                console.error(_context.t0);

                            case 9:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 5]]);
            }));

            function changePrivacyType(_x) {
                return _ref.apply(this, arguments);
            }

            return changePrivacyType;
        }()
    }, {
        key: 'applyContent',
        value: function applyContent() {
            var $templateSource = (0, _jquery2.default)('#toggler-' + this.$currentPrivacy + '-template').html();
            var $resultHtml = _handlebars2.default.compile($templateSource);
            this.$togglerContentPlaceholder.html($resultHtml);
            this.$element.attr('data-current-privacy', this.$currentPrivacy);

            (0, _jquery2.default)(window).trigger('content:updated');
            (0, _jquery2.default)(window).trigger('gtm:send', ['My Profile', 'Make My Profile ' + this.$currentPrivacy]);
        }
    }, {
        key: 'onSuccess',
        value: function onSuccess() {
            this.applyContent();
        }
    }, {
        key: 'onError',
        value: function onError() {
            var _this3 = this;

            setTimeout(function () {
                _this3.$switcher.prop('checked', _this3.$switcher.is(':checked') ? false : true);
            }, 1000);
        }
    }]);

    return EduPrivacyToggler;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduToggleNavbar = function (_Snappy$BaseComponent) {
    _inherits(EduToggleNavbar, _Snappy$BaseComponent);

    _createClass(EduToggleNavbar, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-toggle-navbar';
        }
    }]);

    function EduToggleNavbar(element) {
        _classCallCheck(this, EduToggleNavbar);

        return _possibleConstructorReturn(this, (EduToggleNavbar.__proto__ || Object.getPrototypeOf(EduToggleNavbar)).call(this, element));
    }

    _createClass(EduToggleNavbar, [{
        key: 'setVars',
        value: function setVars() {
            this.buttons = (0, _jquery2.default)(this.$element.find('.filter-button-wrap'));
            this.buttonsInside = (0, _jquery2.default)(this.$element.find('.filter-button'));
            this.inputs = (0, _jquery2.default)(this.$element.find('.filter-button-wrap input'));
            this.inputsCheckbox = (0, _jquery2.default)(this.$element.find('.filter-button-wrap input[type=checkbox]'));
            this.filterButton = this.$element.find('.show-hide-filters');
            this.activeButton = '';
            this.activeDropdown = '';
            this.clearAllButton = (0, _jquery2.default)(this.$element.find('.clear-all-button'));
            this.floatingFiltersButton = (0, _jquery2.default)(this.$element.find('.floating-filter-holder'));
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var windowSize = 0;
            this.activeButton = (0, _jquery2.default)(e.currentTarget);

            if (!this.activeButton.hasClass('disabled')) {
                windowSize = (0, _jquery2.default)(window).innerWidth();

                var boxSize = this.activeButton.find('ul').outerWidth() + this.activeButton.offset().left;

                if (this.activeButton.hasClass('active')) {
                    this.activeButton.find('ul').css({ left: 0 });
                    this.activeButton.find("ul").hide();
                    this.activeButton.removeClass('active');
                } else {
                    this.buttons.removeClass('active');
                    this.buttons.find('ul').hide();
                    if (parseInt(boxSize) > windowSize) {
                        this.activeButton.find('ul').css({ left: -(boxSize - windowSize + 15) });
                    }
                    this.activeButton.find("ul").show();

                    this.activeButton.addClass('active');
                }
            }
            e.stopPropagation();
        }
    }, {
        key: 'handleInputClick',
        value: function handleInputClick() {

            var activeInputLength = this.activeButton.find('input:checked').length;
            var originalInputName = this.activeButton.find('.filter-button').data("name");

            if (this.activeButton.hasClass('by-date')) {
                if (activeInputLength > 0) {
                    this.activeButton.find('.filter-button').text(this.activeButton.find('input:checked').parent().text());
                }
            } else {
                if (activeInputLength >= 1) {
                    this.activeButton.find('.filter-button').text(originalInputName + ' (' + activeInputLength.toString() + ')');
                    this.activeButton.addClass('populated');
                } else if (activeInputLength < 1) {
                    this.activeButton.removeClass('populated');
                    this.activeButton.find('.filter-button').text(originalInputName);
                }
            }
            if (this.inputsCheckbox.filter(':checked').length > 0) {
                this.clearAllButton.addClass('active');
            } else {
                if (this.$element.find('.keyword-filter input:visible').val().length < 1) {
                    this.clearAllButton.removeClass('active');
                }
            }
        }
    }, {
        key: 'handleOutsideClick',
        value: function handleOutsideClick() {
            if (this.activeButton.length > 0) {
                this.activeButton.find('ul').css({ left: 0 });
                this.activeButton.find("ul").hide();
                this.activeButton.removeClass('active');
            }
        }
    }, {
        key: 'handleClearAllClick',
        value: function handleClearAllClick() {

            if (this.inputsCheckbox.length >= 1) {
                this.inputsCheckbox.prop("checked", false);
                this.buttons.map(function (i, button) {
                    if (!(0, _jquery2.default)(button).hasClass('by-date')) {
                        var originalInputName = (0, _jquery2.default)(button).find('.filter-button').data("name");
                        (0, _jquery2.default)(button).find('.filter-button').text(originalInputName);
                        (0, _jquery2.default)(button).removeClass('active');
                        (0, _jquery2.default)(button).removeClass('populated');
                    }
                });
                this.clearAllButton.removeClass('active');
            }
        }
    }, {
        key: 'showHideFIlters',
        value: function showHideFIlters() {
            if (!this.filterButton.hasClass('open')) {
                this.$element.css({
                    top: 70
                });
                this.filterButton.addClass('open');
            } else {
                this.$element.css({
                    top: -(this.$element.height() - (70 + 40))
                });
                this.filterButton.removeClass('open');
            }
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var _this2 = this;

            this.buttons.on('click', this.handleClick.bind(this));
            this.inputs.on('click', this.handleInputClick.bind(this));
            this.buttons.find('li').keypress(function (e) {
                if ((e.keyCode ? e.keyCode : e.which) == 13) {
                    (0, _jquery2.default)(this).find('input').trigger('click');
                }
            });
            this.buttons.keypress(function (e) {
                if ((e.keyCode ? e.keyCode : e.which) == 13) {
                    (0, _jquery2.default)(this).trigger('click');
                }
            });
            this.$element.find('.site-search__button').focus(function () {
                (0, _jquery2.default)(this).blur();
            });

            this.clearAllButton.on('click', this.handleClearAllClick.bind(this));
            (0, _jquery2.default)(document).on('click', this.handleOutsideClick.bind(this));
            this.filterButton.on('click', this.showHideFIlters.bind(this));

            this.floatingFiltersButton.find('span').on('click', this.goToAnchor.bind(this));

            (0, _jquery2.default)(window).on('resize', function () {
                _this2.buttons.removeClass('active');
                _this2.buttons.find('ul').hide();
                if ((0, _jquery2.default)(window).width() > 768) {
                    _this2.floatingFiltersButton.hide();
                }
            });
        }
    }, {
        key: 'init',
        value: function init() {
            var _this3 = this;

            var searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has('recommended')) {
                if (localStorage.getItem('filtersMap')) {
                    var test = new Map(JSON.parse(localStorage.getItem('filtersMap')));
                    test.forEach(function (value, key) {
                        _this3.buttons.map(function (i, button) {
                            if (value.length > 0 && (0, _jquery2.default)(button).attr('id') == key) {
                                value.split(',').map(function (v) {
                                    (0, _jquery2.default)(button).find('input[value=\'' + v + '\']').attr('checked', true);
                                });
                            }
                        });
                    });
                }
            }

            this.buttons.map(function (i, button) {
                var activeInputLength = (0, _jquery2.default)(button).find('input:checked').length;
                var originalInputName = (0, _jquery2.default)(button).find('.filter-button').data("name");

                if (!(0, _jquery2.default)(button).hasClass('by-date')) {
                    if (activeInputLength >= 1) {
                        (0, _jquery2.default)(button).find('.filter-button').text(originalInputName + ' (' + activeInputLength.toString() + ')');
                        (0, _jquery2.default)(button).addClass('populated');
                    } else if (activeInputLength < 1) {
                        (0, _jquery2.default)(button).removeClass('populated');
                        (0, _jquery2.default)(button).find('.filter-button').text(originalInputName);
                    }
                }
            });

            (0, _jquery2.default)(window).on('scroll.showFilterButton', function () {
                if ((0, _jquery2.default)(window).width() <= 768) {
                    if ((0, _jquery2.default)(window).scrollTop() > _this3.$element.offset().top) {
                        _this3.floatingFiltersButton.fadeIn();
                    } else {
                        _this3.floatingFiltersButton.fadeOut();
                    }
                }
            });
        }
    }, {
        key: 'goToAnchor',
        value: function goToAnchor() {
            var anchor = (0, _jquery2.default)(this.$element.find('.bootroom-filters-anchor'));
            (0, _jquery2.default)('html, body').animate({ scrollTop: anchor.offset().top - 100 }, 500);
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.init();
            this.setEventListeners();
        }
    }]);

    return EduToggleNavbar;
}(_snappy2.default.BaseComponent);

_snappy2.default.Component.BootroomFilters = function (_Snappy$BaseComponent2) {
    _inherits(BootroomFilters, _Snappy$BaseComponent2);

    _createClass(BootroomFilters, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-filters';
        }
    }]);

    function BootroomFilters(element) {
        _classCallCheck(this, BootroomFilters);

        return _possibleConstructorReturn(this, (BootroomFilters.__proto__ || Object.getPrototypeOf(BootroomFilters)).call(this, element));
    }

    _createClass(BootroomFilters, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.init();
            this.setEventListeners();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var _this5 = this;

            this.buttons.on('click', this.handleClick.bind(this));
            this.inputs.on('click', this.handleInputClick.bind(this));
            this.clearAllButton.on('click', this.handleClearAllClick.bind(this));
            window.addEventListener("DOMContentLoaded", this.handleFeaturedCall(this));

            (0, _jquery2.default)(window).on('resize', function () {
                _this5.handleKeywordInput();
            });

            window.onbeforeunload = function () {
                window.scrollTo(0, 0);
            };
        }
    }, {
        key: 'init',
        value: function init() {
            var _this6 = this;

            var filtersMap = new Map();
            this.buttons.map(function (i, button) {
                filtersMap.set(button.id, "");
            });
            this.filtersInfo = filtersMap;
            var searchParams = new URLSearchParams(window.location.search);
            if (searchParams.has('recommended')) {
                if (localStorage.getItem('filtersMap')) {
                    var localFiltersMap = new Map(JSON.parse(localStorage.getItem('filtersMap')));
                    localFiltersMap.forEach(function (value, key) {
                        if (value.length > 0) {
                            if (_this6.urlFilters.length > 0) {
                                _this6.urlFilters += '&';
                            }
                            _this6.urlFilters += key + '=' + value;
                        }

                        _this6.filtersInfo.set(key, value);
                    });
                }
            }

            this.resultsContainer.append(this.createPage(this.pageNumber));
            this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']').append('<div class=\'loading\'></div>');

            this.handleKeywordInput();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.buttons = (0, _jquery2.default)(this.$element.find('.filter-button-wrap'));
            this.inputs = (0, _jquery2.default)(this.$element.find('.filter-button-wrap input'));
            this.keywordInput = (0, _jquery2.default)(this.$element.find('.keyword-filter input'));
            this.resultsContainer = (0, _jquery2.default)(this.$element.find('.bootroom-filters__results'));

            this.clearAllButton = (0, _jquery2.default)(this.$element.find('.clear-all-button'));

            this.keyword = '';
            this.activeButton = '';
            this.filtersInfo = {};
            this.urlFilters = '';
            this.jsonUrl = (0, _jquery2.default)(this.$element).data('jsonUrl');

            this.filteredData = [];
            this.featuredData = [];
            this.excludedValuesById = '';

            this.pageNumber = 1;
            this.totalPages = 1;
            this.cardsPerPage = parseInt((0, _jquery2.default)(this.$element).data('cardsPerPage'));

            this.loading = false;
            this.loadingMore = false;
            this.stillLoading = false;

            this.totalLoadedResults = 0;

            this.exceededCards = 0;

            this.rest = 0;
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            this.activeButton = (0, _jquery2.default)(e.currentTarget);
        }
    }, {
        key: 'handleInputClick',
        value: function handleInputClick(e) {
            var _this7 = this;

            (0, _jquery2.default)(window).off('.loadMore');
            this.resultsContainer.empty();
            this.goToAnchor();
            this.urlFilters = '';
            this.loadingMore = false;
            this.pageNumber = 1;
            var test = [];
            this.activeButton.find('input:checked').map(function (i, input) {
                test.push((0, _jquery2.default)(input).attr('value'));
            });

            this.filtersInfo.set(this.activeButton.attr('id'), test.toString());

            this.filtersInfo.forEach(function (value, key) {

                if (value.length > 0) {
                    if (_this7.urlFilters.length > 0) {
                        _this7.urlFilters += '&';
                    }
                    _this7.urlFilters += key + '=' + value;
                }
            });

            if (this.loading == true) {
                this.stillLoading = true;
            } else {
                this.stillLoading = false;
            }
            //localStorage.setItem('filtersMap', JSON.stringify(Array.from(this.filtersInfo)));
            this.handleFeaturedCall();
        }
    }, {
        key: 'handleAfterCall',
        value: function handleAfterCall() {
            var _this8 = this;

            this.resultsContainer.empty();
            var nextPage = [];
            var page = [];
            var resultsLength = this.filteredData.length + this.exceededCards;
            //console.log("test", resultsLength)
            //console.log('rest', this.rest)
            this.totalLoadedResults = resultsLength;
            this.rest = resultsLength % 3;

            this.resultsContainer.append(this.createPage(this.pageNumber));
            page = this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']');

            if (this.rest > 0) {
                this.resultsContainer.append(this.createPage(this.pageNumber + 1));
                nextPage = this.resultsContainer.find('.results-page[data-page-number=' + (this.pageNumber + 1) + ']');
            }
            if (this.filteredData.length > 0) {
                this.filteredData.forEach(function (data, i) {
                    if (i < 1) {
                        if (_this8.featuredData.length > 0) {
                            _this8.featuredData.forEach(function (dataFeatured, j) {
                                if (j <= 1) {
                                    if (_this8.featuredData.length > 1) {
                                        page.find('.content').append(_this8.createCardMedium(dataFeatured));
                                    } else {
                                        page.find('.content').append(_this8.createCardLarge(dataFeatured));
                                    }
                                }
                            });
                        }
                    }
                    if (i === 6) {
                        if (_this8.featuredData.length > 2) {
                            _this8.featuredData.forEach(function (dataFeatured, j) {
                                if (j === 2) {
                                    page.find('.content').append(_this8.createCardLarge(dataFeatured));
                                }
                            });
                        }
                    }

                    if (_this8.rest > 0) {

                        if (_this8.totalPages != _this8.pageNumber) {
                            if (i < _this8.filteredData.length - _this8.rest) {
                                page.find('.content').append(_this8.createCardSmall(data));
                            } else {
                                nextPage.find('.content').append(_this8.createCardSmall(data));
                            }
                        } else {
                            page.find('.content').append(_this8.createCardSmall(data));
                        }
                    } else {
                        page.find('.content').append(_this8.createCardSmall(data));
                    }
                });
            } else {
                if (this.featuredData.length > 0) {
                    this.featuredData.forEach(function (dataFeatured, j) {
                        if (j <= 1) {
                            if (_this8.featuredData.length > 1) {
                                page.find('.content').append(_this8.createCardMedium(dataFeatured));
                            } else {
                                page.find('.content').append(_this8.createCardLarge(dataFeatured));
                            }
                        }
                        if (j === 2) {
                            page.find('.content').append(_this8.createCardLarge(dataFeatured));
                        }
                    });
                }
            }

            if (this.featuredData.length > 2) {
                this.waitForElement((0, _jquery2.default)('.bootroom-card-f.card__m'), this.equalizeFeatureHeight);
                this.equalizeLargeFeaturedHeight();
            }
            if (this.featuredData.length == 1) {
                this.equalizeLargeFeaturedHeight();
            }
            if (this.featuredData.length == 2) {
                this.waitForElement((0, _jquery2.default)('.bootroom-card-f.card__m'), this.equalizeFeatureHeight);
            }

            (0, _jquery2.default)(page).find('.content').fadeIn(1000, function () {
                if (_this8.totalPages != _this8.pageNumber) {
                    (0, _jquery2.default)(window).on('scroll.loadMore', _this8.handleScroll.bind(_this8));
                }
                _this8.$element.find('.loading').fadeOut('slow', function () {
                    _this8.$element.find('.loading').remove();
                });
            });
        }
    }, {
        key: 'handleFeaturedCall',
        value: function handleFeaturedCall() {
            this.excludedValuesById = '';
            this.loading = true;
            if (this.resultsContainer.is(':empty')) {
                this.resultsContainer.append(this.createPage(this.pageNumber));
                var page = this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']');
                page.append('<div class=\'loading\'></div>');
            }
            _jquery2.default.ajax({
                context: this,
                type: "GET",
                dataType: "json",
                url: this.jsonUrl + '?' + (this.urlFilters ? this.urlFilters + '&' : '') + 'isFeatured=true&resultPerPage=3&page=1' + this.keyword,
                data: {
                    //page: this.i,
                    //url: window.location.pathname.toString()
                },
                //beforeSend: function (xhr) {
                //    if (this.stillLoading == true) {
                //        console.log('abort - featured,', xhr)
                //        xhr.abort();
                //        this.stillLoading = false;
                //        return;
                //    }
                //},
                success: function success(result, textStatus, request) {
                    var _this9 = this;

                    this.featuredData = result.eduResoucesArticles;

                    switch (this.featuredData.length) {
                        case 1:
                            this.exceededCards = 2;
                            break;
                        case 2:
                            this.exceededCards = 3;
                            break;
                        case 3:
                            this.exceededCards = 5;
                            break;
                        case 0:
                            this.exceededCards = 0;
                            break;
                        default:
                            this.exceededCards = 0;
                    }
                    if (this.featuredData.length > 0) {
                        this.excludedValuesById = "&removeByID=";
                        this.featuredData.forEach(function (dataFeatured, i) {
                            if (i > 0 && i <= _this9.featuredData.length - 1) {
                                _this9.excludedValuesById += ',';
                            }
                            _this9.excludedValuesById += dataFeatured.id;
                        });
                    }
                    this.handleCall();
                },
                error: function error() {}
            });
        }
    }, {
        key: 'handleCall',
        value: function handleCall() {
            (0, _jquery2.default)(window).off('.loadMore');
            this.totalPages = 1;
            _jquery2.default.ajax({
                context: this,
                type: "GET",
                dataType: "json",
                url: this.jsonUrl + '?' + (this.urlFilters.length ? this.urlFilters + '&' : '') + 'page=' + this.pageNumber + '&resultPerPage=' + this.cardsPerPage + this.excludedValuesById + this.keyword,
                data: {
                    //page: this.i,
                    //url: window.location.pathname.toString()
                },
                //beforeSend: function (xhr) {
                //    if (this.stillLoading == true) {
                //        console.log('abort')
                //        xhr.abort();
                //        this.stillLoading = false;
                //        this.loading = false;
                //    }
                //},
                success: function success(result, textStatus, request) {
                    this.filteredData = result.eduResoucesArticles;
                    if (result.totalPages > 1) {
                        this.totalPages = result.totalPages;
                    }
                    if (this.loadingMore == true) {
                        this.loading = false;
                        if (this.filteredData.length > 0) {
                            this.handleLoadingMore(); //load more results
                        } else {
                            this.showingHiddenResults(); //showing last results that were be hidden to not mess up the UI
                        }
                    } else {
                        if (this.filteredData.length > 0 || this.featuredData.length > 0) {
                            this.handleAfterCall();
                        } else {
                            this.resultsContainer.html('<div class="no-results">No results</div>');
                        }
                    }
                    this.loading = false;
                },
                error: function error() {}
            });
        }
    }, {
        key: 'handleLoadingMore',
        value: function handleLoadingMore() {
            var _this10 = this;

            var page = [];

            var nextPage = [];
            this.totalLoadedResults += this.filteredData.length;
            this.rest = this.totalLoadedResults % 3;

            if (this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']').length < 1) {
                this.resultsContainer.append(this.createPage(this.pageNumber));
            }
            page = this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']');

            if (this.rest > 0) {
                if (this.totalPages != this.pageNumber) {
                    if (this.resultsContainer.find('.results-page[data-page-number=' + (this.pageNumber + 1) + ']').length < 1) {
                        this.resultsContainer.append(this.createPage(this.pageNumber + 1));
                    }
                }

                nextPage = this.resultsContainer.find('.results-page[data-page-number=' + (this.pageNumber + 1) + ']');
            }

            if (this.rest >= 1) {
                if (this.totalPages != this.pageNumber) {
                    this.filteredData.forEach(function (data, i) {
                        if (i < _this10.filteredData.length - _this10.rest) {
                            page.find('.content').append(_this10.createCardSmall(data));
                        } else {
                            nextPage.find('.content').append(_this10.createCardSmall(data));
                        }
                    });
                } else {
                    this.filteredData.forEach(function (data, i) {
                        page.find('.content').append(_this10.createCardSmall(data));
                    });
                }
            } else {
                this.filteredData.forEach(function (data, i) {
                    page.find('.content').append(_this10.createCardSmall(data));
                });
            }

            (0, _jquery2.default)(page).find('.content').fadeIn(1000, function () {
                if (_this10.totalPages != _this10.pageNumber) {
                    (0, _jquery2.default)(window).on('scroll.loadMore', _this10.handleScroll.bind(_this10));
                }
                _this10.$element.find('.loading').fadeOut('slow', function () {
                    _this10.$element.find('.loading').remove();
                });
            });
        }
    }, {
        key: 'createPage',
        value: function createPage(pageNumber) {
            return '<div class="results-page"\n                 style="position: relative; min-height:70px"\n                 data-page-number=' + pageNumber + '>\n                   <div class="content" style="display:none"></div>\n                 </div>';
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            var element = this.$element;
            var page = [];

            if (window.innerHeight + window.scrollY >= parseInt(element.offset().top) + parseInt(element.height()) && this.loading == false) {

                this.loadingMore = true;
                this.pageNumber = this.pageNumber + 1;
                this.loading = true;

                if (this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']').length >= 1) {
                    page = this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']');
                    page.append('<div class=\'loading\'></div>');
                } else {
                    this.resultsContainer.append(this.createPage(this.pageNumber));
                    page = this.resultsContainer.find('.results-page[data-page-number=' + this.pageNumber + ']');
                    page.append('<div class=\'loading\'></div>');
                }
                this.handleCall();
            }
        }
    }, {
        key: 'showingHiddenResults',
        value: function showingHiddenResults() {
            var _this11 = this;

            if (this.$element.find('.results-page[data-page-number=' + this.pageNumber + ']').length > 0) {
                this.$element.find('.results-page[data-page-number=' + this.pageNumber + '] .content').fadeIn('slow');
                this.$element.find('.loading').fadeOut('slow', function () {
                    _this11.$element.find('.loading').remove();
                });
                this.loadFinished = true;
            }
        }
    }, {
        key: 'goToAnchor',
        value: function goToAnchor() {
            var anchor = (0, _jquery2.default)(this.$element.find('.bootroom-filters-anchor'));
            if ((0, _jquery2.default)(window).scrollTop() > this.resultsContainer.offset().top + 20) {
                (0, _jquery2.default)('html, body').animate({ scrollTop: anchor.offset().top - 100 }, 500);
            }
        }
    }, {
        key: 'handleKeywordInput',
        value: function handleKeywordInput() {
            var _this12 = this;

            var activeKeyword = (0, _jquery2.default)(this.$element.find('.keyword-filter input:visible'));

            activeKeyword.keyup(function (e) {
                if (activeKeyword.val().length > 0) {
                    _this12.clearAllButton.addClass('active');
                } else {
                    if (_this12.url == '') {
                        _this12.clearAllButton.removeClass('active');
                    }
                }

                if (e.which == 13) {
                    _this12.keywordInput.val(activeKeyword.val());
                    if (activeKeyword.val().length > 0) {
                        _this12.keyword = '&keyword=' + activeKeyword.val();
                    } else {
                        _this12.keyword = '';
                    }
                    _this12.resultsContainer.empty();
                    _this12.loadingMore = false;
                    _this12.handleFeaturedCall();
                }
            });
            activeKeyword.parent().find('button').click(function () {
                _this12.keywordInput.val(activeKeyword.val());
                if (activeKeyword.length > 0) {
                    _this12.keyword = '&keyword=' + activeKeyword.val();
                } else {
                    _this12.keyword = '';
                }
                //e.stopPropagation();
                _this12.resultsContainer.empty();
                _this12.handleFeaturedCall();
            });
        }
    }, {
        key: 'handleClearAllClick',
        value: function handleClearAllClick() {
            var _this13 = this;

            (0, _jquery2.default)(window).off('.loadMore');
            this.resultsContainer.empty();
            this.urlFilters = '';
            this.keyword = '';
            this.keywordInput.val('');
            this.buttons.map(function (i, button) {
                if (!(0, _jquery2.default)(button).hasClass('by-date')) {
                    _this13.filtersInfo.set((0, _jquery2.default)(button).attr('id'), "");
                }
            });

            if (this.loading == true) {
                this.stillLoading = true;
            } else {
                this.stillLoading = false;
            }

            this.handleFeaturedCall();
            this.goToAnchor();
        }
    }, {
        key: 'equalizeFeatureHeight',
        value: function equalizeFeatureHeight() {
            var maxHeight = 0;
            var elements = (0, _jquery2.default)('.bootroom-card-f.card__m');

            elements.each(function (i, element) {
                if ((0, _jquery2.default)(element).height() > maxHeight) maxHeight = (0, _jquery2.default)(element).height();
            });

            elements.find('.bootroom-card-f__image').height(maxHeight);
        }
    }, {
        key: 'equalizeLargeFeaturedHeight',
        value: function equalizeLargeFeaturedHeight() {
            var element = (0, _jquery2.default)('.bootroom-card-f.card__l');
            var nexElement = element.next('.bootroom-card');

            if (nexElement.length > 0) {
                this.waitForElement(nexElement, function () {
                    if (nexElement.height() > element.height()) {
                        element.find('.bootroom-card-f__image').height(nexElement.height());
                    }
                });
            }
        }
    }, {
        key: 'waitForElement',
        value: function waitForElement(selector, callback) {
            var _this14 = this;

            if (selector.is(":visible")) {
                callback();
            } else {
                setTimeout(function () {
                    _this14.waitForElement(selector, callback);
                }, 100);
            }
        }
    }, {
        key: 'createCardSmall',
        value: function createCardSmall(data) {
            var dataContent = '\n            <div class="bootroom-card card-responsive col-xs-12 col-sm-4 col-md-4">\n                <a href="' + (data.CTA ? '' + data.CTA : '') + '">\n                    <div class="bootroom-card__image lazyload"\n                        ' + (data.picture ? 'data-bg="' + data.picture + '"' : '') + '\n                        >\n                        ' + (data.isVideo ? '<div class="play-button">\n                                <span style="border-right-color: #E1261C"></span>\n                            </div>' : '') + '\n                    </div>\n                    <div class="card-content">\n                        ' + (data.title ? '<h4>\n                                ' + data.title + '\n                            </h4>' : '') + '\n                        ' + (data.interviewee || data.interviewTitle ? '<h4>\n                                ' + (data.interviewee ? '<span>' + data.interviewee + '</span>' : '') + '\n                                ' + (data.interviewTitle ? '' + data.interviewTitle : '') + '\n                            </h4>' : '') + '\n                        ' + (data.text ? '<p>' + data.text + '</p>' : '') + '\n                        ' + (data.duration ? '<div class="duration">' + data.duration + ' \u2022</div>' : '') + '\n                        ' + (data.datetime ? '<div class="date">' + data.datetime + '</div>' : '') + '\n                        ' + (data.disciplines && !data.disciplines.empty || data.ageGroups && !data.ageGroups.empty || data.tags && !data.tags.empty ? '<div class="tags">\n                                ' + (data.disciplines ? data.disciplines.map(function (discipline) {
                return '<span>' + discipline + '</span>';
            }).join('') : '') + ' \n                                ' + (data.ageGroups ? data.ageGroups.map(function (ageGroup) {
                return '<span>' + ageGroup + '</span>';
            }).join('') : '') + ' \n                                ' + (data.tags ? data.tags.map(function (tag) {
                return '<span>' + tag + '</span>';
            }).join('') : '') + '\n                            </div>' : '') + '\n                    </div>\n                </a>\n            </div>\n        ';
            return dataContent;
        }
    }, {
        key: 'createCardMedium',
        value: function createCardMedium(data) {
            var dataContent = '\n            <div class="bootroom-card-f card__m col-xs-12 col-sm-6 col-md-6">\n                <a href="' + (data.CTA ? '' + data.CTA : '') + '">\n                    <div class="main-tag">Featured</div>\n                    <div class="bootroom-card-f__image lazyload"\n                        ' + (data.picture ? 'data-bg="' + data.picture + '"' : '') + '\n                    >\n                        <div class="card-content">\n                            <div class="content-size-control">\n                                ' + (data.isVideo ? '<div class="play-button">\n                                        <span style="border-right-color: #E1261C"></span>\n                                    </div>' : '') + '\n                                ' + (data.title ? '<h4>\n                                        ' + data.title + '\n                                    </h4>' : '') + '\n                                ' + (data.interviewee ? '<h4>\n                                        <span>' + data.interviewee + '</span>\n                                        ' + (data.interviewTitle ? '' + data.interviewTitle : '') + '\n                                    </h4>' : '') + '\n                                ' + (data.text ? '<p>' + data.text + '</p>' : '') + '\n                                ' + (data.duration ? '<div class="duration">' + data.duration + ' \u2022</div>' : '') + '\n                                ' + (data.datetime ? '<div class="date">' + data.datetime + '</div>' : '') + '\n                                ' + (data.disciplines && !data.disciplines.empty || data.ageGroups && !data.ageGroups.empty || data.tags && !data.tags.empty ? '<div class="tags">\n                                        ' + (data.disciplines ? data.disciplines.map(function (discipline) {
                return '<span>' + discipline + '</span>';
            }).join('') : '') + ' \n                                        ' + (data.ageGroups ? data.ageGroups.map(function (ageGroup) {
                return '<span>' + ageGroup + '</span>';
            }).join('') : '') + ' \n                                        ' + (data.tags ? data.tags.map(function (tag) {
                return '<span>' + tag + '</span>';
            }).join('') : '') + '\n                                    </div>' : '') + '\n                            </div>\n                        </div>\n                    </div>\n                </a>\n            </div>\n        ';
            return dataContent;
        }
    }, {
        key: 'createCardLarge',
        value: function createCardLarge(data) {
            var dataContent = '\n            <div class="bootroom-card-f card__l col-xs-12 col-sm-8 col-md-8">\n                <a href="' + (data.CTA ? '' + data.CTA : '') + '">\n                    <div class="main-tag">Featured</div>\n                    <div class="bootroom-card-f__image lazyload"\n                        ' + (data.picture ? 'data-bg="' + data.picture + '"' : '') + '\n                    >\n\n                        <div class="card-content">\n                            <div class="content-size-control">\n                                ' + (data.isVideo ? '<div class="play-button">\n                                        <span style="border-right-color: #E1261C"></span>\n                                    </div>' : '') + '\n                                ' + (data.title ? '<h4>\n                                        ' + data.title + '\n                                    </h4>' : '') + '\n                                ' + (data.interviewee ? '<h4>\n                                        <span>' + data.interviewee + '</span>\n                                        ' + (data.interviewTitle ? '' + data.interviewTitle : '') + '\n                                    </h4>' : '') + '\n                                ' + (data.text ? '<p>' + data.text + '</p>' : '') + '\n                                ' + (data.duration ? '<div class="duration">' + data.duration + ' \u2022</div>' : '') + '\n                                ' + (data.datetime ? '<div class="date">' + data.datetime + '</div>' : '') + '\n                                ' + (data.disciplines && !data.disciplines.empty || data.ageGroups && !data.ageGroups.empty || data.tags && !data.tags.empty ? '<div class="tags">\n                                        ' + (data.disciplines ? data.disciplines.map(function (discipline) {
                return '<span>' + discipline + '</span>';
            }).join('') : '') + ' \n                                        ' + (data.ageGroups ? data.ageGroups.map(function (ageGroup) {
                return '<span>' + ageGroup + '</span>';
            }).join('') : '') + ' \n                                        ' + (data.tags ? data.tags.map(function (tag) {
                return '<span>' + tag + '</span>';
            }).join('') : '') + '\n                                    </div>' : '') + '\n                            </div>\n                        </div>\n                    </div>\n                </a>\n            </div>\n        ';
            return dataContent;
        }
    }]);

    return BootroomFilters;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduSectionUpdater = function (_Snappy$BaseComponent) {
    _inherits(EduSectionUpdater, _Snappy$BaseComponent);

    _createClass(EduSectionUpdater, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-section-updater';
        }
    }]);

    function EduSectionUpdater(element) {
        _classCallCheck(this, EduSectionUpdater);

        return _possibleConstructorReturn(this, (EduSectionUpdater.__proto__ || Object.getPrototypeOf(EduSectionUpdater)).call(this, element));
    }

    _createClass(EduSectionUpdater, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.sectionName = this.$element.data('section-updater-value');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('content:updated', this.updateAttributes.bind(this));
        }
    }, {
        key: 'updateAttributes',
        value: function updateAttributes() {
            var $items = this.$element.find('.js-section-updater-item');
            if ($items.length) {
                $items.attr('data-gtm-event-category', this.sectionName);
            }
        }
    }]);

    return EduSectionUpdater;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduSendFilters = function (_Snappy$BaseComponent) {
    _inherits(EduSendFilters, _Snappy$BaseComponent);

    _createClass(EduSendFilters, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-send-filters';
        }
    }]);

    function EduSendFilters(element) {
        _classCallCheck(this, EduSendFilters);

        return _possibleConstructorReturn(this, (EduSendFilters.__proto__ || Object.getPrototypeOf(EduSendFilters)).call(this, element));
    }

    _createClass(EduSendFilters, [{
        key: 'setVars',
        value: function setVars() {
            this.button = (0, _jquery2.default)(this.$element);
            this.filters = new Map();
            this.itemName = this.button.data('itemName');
        }
    }, {
        key: 'handleClick',
        value: function handleClick(e) {
            var _this2 = this;

            console.log(Array.from(e.currentTarget.attributes));
            var allAttributes = Array.from(e.currentTarget.attributes);
            allAttributes.map(function (attrs) {
                if (attrs.name.includes('filter-')) {
                    console.log(attrs.name + " - " + attrs.value);
                    _this2.filters.set(attrs.name.replace('filter-', ''), attrs.value);
                }
            });
            localStorage.setItem(this.itemName, JSON.stringify(Array.from(this.filters)));
            console.log(localStorage.getItem(this.itemName));
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.button.on('click', this.handleClick.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }]);

    return EduSendFilters;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduSticky = function (_Snappy$BaseComponent) {
    _inherits(EduSticky, _Snappy$BaseComponent);

    _createClass(EduSticky, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-sticky';
        }
    }]);

    function EduSticky(element) {
        _classCallCheck(this, EduSticky);

        return _possibleConstructorReturn(this, (EduSticky.__proto__ || Object.getPrototypeOf(EduSticky)).call(this, element));
    }

    _createClass(EduSticky, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
            this.updateStickyPosition();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.$topSticky = this.$element.find('.js-sticky-top');
            this.$bottomStickyContainer = this.$element.find('.js-sticky-bottom-container');
            this.$bottomSticky = this.$element.find('.js-sticky-bottom');
            this.fixedNavHeight = _resize2.default.isDesktop ? 70 : 65;
            this.isTopFixed = false;
            this.isBottomFixed = false;
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));

            this.$document.on('scroll', this.onScroll.bind(this));
        }
    }, {
        key: 'updateStickyPosition',
        value: function updateStickyPosition(isResised) {

            this.updateTopStickyPosition(isResised);

            if (this.$bottomSticky.length) {
                this.updateBottomStickyPosition(isResised);
            }
        }
    }, {
        key: 'updateTopStickyPosition',
        value: function updateTopStickyPosition(isResised) {
            var topOffset1 = this.$element[0].getBoundingClientRect().top;
            if (topOffset1 <= this.fixedNavHeight && (!this.isTopFixed || isResised)) {
                this.$topSticky.css({ top: this.fixedNavHeight + 'px' });
                this.$topSticky.addClass('is-fixed');
                this.$element.css({ paddingTop: this.topPanelHeight + 'px' });
                this.isTopFixed = true;
            } else if (topOffset1 > this.fixedNavHeight && (this.isTopFixed || isResised)) {
                this.$topSticky.css({ top: '' });
                this.$topSticky.removeClass('is-fixed');
                this.$element.css({ paddingTop: '' });
                this.isTopFixed = false;
            }
        }
    }, {
        key: 'updateBottomStickyPosition',
        value: function updateBottomStickyPosition(isResised) {
            var topOffset2 = this.$bottomStickyContainer[0].getBoundingClientRect().top;

            if (topOffset2 < this.fixedNavHeight + this.topPanelHeight && (!this.isBottomFixed || isResised)) {
                this.$bottomSticky.css({ top: this.topPanelHeight + this.fixedNavHeight + 'px' });
                this.$bottomSticky.addClass('is-fixed');
                this.$bottomStickyContainer.css({ paddingTop: this.botPanelHeight + 'px' });
                this.isBottomFixed = true;
            } else if (topOffset2 >= this.fixedNavHeight + this.topPanelHeight && (this.isBottomFixed || isResised)) {
                this.$bottomSticky.css({ top: '' });
                this.$bottomSticky.removeClass('is-fixed');
                this.$bottomStickyContainer.css({ paddingTop: '' });
                this.isBottomFixed = false;
            }
        }
    }, {
        key: 'updateStickyDimensions',
        value: function updateStickyDimensions() {
            this.topPanelHeight = this.$topSticky.outerHeight();
            if (this.$bottomSticky.length) {
                this.botPanelHeight = this.$bottomSticky.outerHeight();
            }
        }
    }, {
        key: 'onScroll',
        value: function onScroll() {
            this.updateStickyPosition();
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.fixedNavHeight = _resize2.default.isDesktop ? 70 : 70;
            this.updateStickyDimensions();
            this.updateStickyPosition(true);
        }
    }]);

    return EduSticky;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.BootroomTabs = function (_Snappy$BaseComponent) {
    _inherits(BootroomTabs, _Snappy$BaseComponent);

    _createClass(BootroomTabs, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-tabs';
        }
    }]);

    function BootroomTabs(element) {
        _classCallCheck(this, BootroomTabs);

        var _this = _possibleConstructorReturn(this, (BootroomTabs.__proto__ || Object.getPrototypeOf(BootroomTabs)).call(this, element));

        _this.lastLeft = 0;
        _this.searchData = [];
        return _this;
    }

    _createClass(BootroomTabs, [{
        key: 'setVars',
        value: function setVars() {
            this.rowsPerPage = (0, _jquery2.default)(this.$element).data('rowsPerPage');
            this.requestUrl = (0, _jquery2.default)(this.$element).data('requestUrl');
            this.tabs = (0, _jquery2.default)(this.$element.find('.individual-tab-title'));
            this.contents = (0, _jquery2.default)(this.$element.find('.individual-tab-content'));
            this.activeElement = (0, _jquery2.default)(this.$element.find('.individual-tab-title.active'));
            this.activeContent = this.$element.find('.individual-tab-content.active');
            this.indicator = this.$element.find('.highlight');
            this.tabsWrap = this.$element.find('.tabs-bar');
            this.tabsContainer = this.$element.find('.tabs-holder');
            this.indicatorColor = this.activeElement.data('tabColor');
            this.anchor = (0, _jquery2.default)(this.$element.find('.bootroom-tabs-anchor'));
            this.tabsContent = (0, _jquery2.default)(this.$element.find('.bootroom-tabs-content'));
        }
    }, {
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.tabs.map(function (i, tab) {
                if (!(0, _jquery2.default)(tab).hasClass('disabled')) {
                    (0, _jquery2.default)(tab).find('span').text(' (' + _this2.searchData.filter(function (data) {
                        return (0, _jquery2.default)(tab).data('type').replace(/\s/g, '').split(",").includes(data.type);
                    }).length + ')');
                }
                if (!(0, _jquery2.default)(tab).hasClass("active")) {
                    (0, _jquery2.default)(tab).find('h3').width((0, _jquery2.default)(tab).find('h3').width() + (0, _jquery2.default)(tab).find('h3').width() / 15);
                } else {
                    (0, _jquery2.default)(tab).find('h3').width((0, _jquery2.default)(tab).find('h3').width());
                }
            });

            this.contents.map(function (i, content) {
                if (_this2.searchData.filter(function (data) {
                    return (0, _jquery2.default)(content).data('type').replace(/\s/g, '').split(",").includes(data.type);
                }).length > 0) {
                    _this2.searchData.filter(function (data) {
                        return (0, _jquery2.default)(content).data('type').replace(/\s/g, '').split(",").includes(data.type);
                    }).map(function (data, i) {
                        if (i < _this2.rowsPerPage) (0, _jquery2.default)(content).find('.tab-content-data').append(_this2.createCard(data));
                    });
                    if (_this2.searchData.filter(function (data) {
                        return (0, _jquery2.default)(content).data('type').replace(/\s/g, '').split(",").includes(data.type);
                    }).length > _this2.rowsPerPage) {
                        (0, _jquery2.default)(content).append(_this2.createPagination(_this2.searchData.filter(function (data) {
                            return (0, _jquery2.default)(content).data('type').replace(/\s/g, '').split(",").includes(data.type);
                        }).length));
                    }
                } else {
                    (0, _jquery2.default)(content).find('.tab-content-data').append('<div data-name="No Results">No results</div>');
                }
            });

            this.$element.find('.next-button').on('click', this.handleClickNextPage.bind(this));
            this.$element.find('.previous-button').on('click', this.handleClickPreviousPage.bind(this));
            this.activeContent.find('.pagination-button').on('click', this.handleClickPagination.bind(this));
            this.indicator.css("background-color", this.indicatorColor);
            this.activeContent.fadeIn();
            this.attachIndicator();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var _this3 = this;

            this.$element.find('.individual-tab-title').on('click', this.handleClickTab.bind(this));
            window.addEventListener("resize", this.attachIndicator.bind(this));
            window.addEventListener("DOMContentLoaded", function () {
                _this3.tabScroll();
                _this3.handleCall(_this3);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'handleClickTab',
        value: function handleClickTab(e) {
            this.activeElement = (0, _jquery2.default)(e.currentTarget);

            if (!(0, _jquery2.default)(e.currentTarget).hasClass('disabled') && !(0, _jquery2.default)(e.currentTarget).hasClass('active')) {
                this.$element.find('.individual-tab-content').removeClass('active');
                this.$element.find('.individual-tab-content').hide();
                this.$element.find('.individual-tab-title').removeClass('active');

                (0, _jquery2.default)(e.currentTarget).addClass('active');

                if ((0, _jquery2.default)(window).scrollTop() > this.tabsContent.offset().top + 20) {
                    window.scrollTo({ top: this.anchor.offset().top - 40, behavior: 'smooth' });
                }

                (0, _jquery2.default)('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').addClass('active');
                (0, _jquery2.default)('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').fadeIn();

                this.activeContent = (0, _jquery2.default)('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]');
                this.$element.find('.pagination-button').off();
                this.activeContent.find('.pagination-button').on('click', this.handleClickPagination.bind(this));

                this.attachIndicator();

                this.tabScroll();
            }
        }
    }, {
        key: 'handleClickPagination',
        value: function handleClickPagination(e) {
            var previousNumber = parseInt(this.activeContent.find('.pagination-button.active').attr('data-page-number'));
            var numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
            var activeNumber = 0;
            var incrementPosition = 0;
            this.activeContent.find('.pagination-button').removeClass('active');

            activeNumber = parseInt((0, _jquery2.default)(e.currentTarget).attr('data-page-number'));

            if (numberOfPages >= 5) {
                if (activeNumber <= 0 || activeNumber >= numberOfPages) {
                    incrementPosition = 0;
                }
                if (activeNumber > 1 && activeNumber < numberOfPages - 1) {
                    incrementPosition = Math.abs((0, _jquery2.default)(e.currentTarget).data('incNumber'));
                }
                if (previousNumber <= activeNumber) {

                    if (activeNumber === numberOfPages - 1) {
                        if (this.activeContent.find('.pagination-button[data-page-number="' + numberOfPages + '"]').length > 0) {
                            incrementPosition = 0;
                        } else {
                            incrementPosition = 1;
                        }
                    }
                    this.activeContent.find(".pagination-button").map(function (i, button) {
                        if (activeNumber > 1) {
                            (0, _jquery2.default)(button).attr('data-page-number', parseInt((0, _jquery2.default)(button).attr('data-page-number')) + incrementPosition);
                            (0, _jquery2.default)(button).text(parseInt((0, _jquery2.default)(button).text()) + incrementPosition);
                        }
                        if (parseInt((0, _jquery2.default)(button).attr('data-page-number')) === activeNumber) {
                            (0, _jquery2.default)(button).addClass('active');
                        }
                    });
                } else if (previousNumber > activeNumber) {

                    if (activeNumber === 1) {
                        if (this.activeContent.find('.pagination-button[data-page-number="0"]').length > 0) {
                            incrementPosition = 0;
                        } else {
                            incrementPosition = 1;
                        }
                    }
                    this.activeContent.find(".pagination-button").map(function (i, button) {
                        if (activeNumber < numberOfPages - 2) {
                            (0, _jquery2.default)(button).attr('data-page-number', parseInt((0, _jquery2.default)(button).attr('data-page-number')) - incrementPosition);
                            (0, _jquery2.default)(button).text(parseInt((0, _jquery2.default)(button).text()) - incrementPosition);
                        }
                        if (parseInt((0, _jquery2.default)(button).attr('data-page-number')) === activeNumber) {
                            (0, _jquery2.default)(button).addClass('active');
                        }
                    });
                }
            } else {
                (0, _jquery2.default)(e.currentTarget).addClass('active');
            }

            this.handleDataPagination(activeNumber);
            e.stopPropagation();
        }
    }, {
        key: 'handleClickNextPage',
        value: function handleClickNextPage() {
            var numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
            var pageNumber = parseInt((0, _jquery2.default)(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));

            (0, _jquery2.default)(this.activeContent.find('.pagination-button')).removeClass('active');
            if (numberOfPages >= 5) {

                if (pageNumber > 1 && pageNumber < numberOfPages - 2) {
                    this.activeContent.find(".pagination-button").map(function (i, button) {
                        (0, _jquery2.default)(button).attr('data-page-number', parseInt((0, _jquery2.default)(button).attr('data-page-number')) + 1);
                        (0, _jquery2.default)(button).text(parseInt((0, _jquery2.default)(button).text()) + 1);
                    });
                    (0, _jquery2.default)(this.activeContent.find('.pagination-button[data-page-number="' + (parseInt(pageNumber) + 1) + '"]')).addClass('active');
                }
            }

            (0, _jquery2.default)(this.activeContent.find('.pagination-button[data-page-number="' + (parseInt(pageNumber) + 1) + '"]')).addClass('active');
            pageNumber = parseInt((0, _jquery2.default)(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));

            this.handleDataPagination(pageNumber);
        }
    }, {
        key: 'handleClickPreviousPage',
        value: function handleClickPreviousPage() {
            var numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
            var pageNumber = parseInt((0, _jquery2.default)(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));
            (0, _jquery2.default)(this.activeContent.find('.pagination-button')).removeClass('active');
            if (numberOfPages >= 5) {

                if (pageNumber > 2 && pageNumber < numberOfPages - 2) {
                    this.activeContent.find(".pagination-button").map(function (i, button) {
                        (0, _jquery2.default)(button).attr('data-page-number', parseInt((0, _jquery2.default)(button).attr('data-page-number')) - 1);
                        (0, _jquery2.default)(button).text(parseInt((0, _jquery2.default)(button).text()) - 1);
                    });
                }
            }

            (0, _jquery2.default)(this.activeContent.find('.pagination-button[data-page-number="' + (parseInt(pageNumber) - 1) + '"]')).addClass('active');

            pageNumber = parseInt((0, _jquery2.default)(this.activeContent.find('.pagination-button.active')).attr('data-page-number'));

            this.handleDataPagination(pageNumber);
        }
    }, {
        key: 'handleDataPagination',
        value: function handleDataPagination(pageNumber) {
            var _this4 = this;

            var number = pageNumber * this.rowsPerPage;
            var numberOfPages = parseInt(this.activeContent.find('.tab-pagination-buttons').data('totalPages')) - 1;
            (0, _jquery2.default)(this.activeContent).find('.tab-content-data').empty();
            this.searchData.filter(function (data) {
                return (0, _jquery2.default)(_this4.activeContent).data('type').replace(/\s/g, '').split(",").includes(data.type);
            }).map(function (data, i) {
                if (i >= number && i < number + _this4.rowsPerPage) (0, _jquery2.default)(_this4.activeContent).find('.tab-content-data').append(_this4.createCard(data));
            });

            if ((0, _jquery2.default)(window).scrollTop() > this.tabsContent.offset().top + 20) {
                window.scrollTo({ top: this.anchor.offset().top - 40, behavior: 'smooth' });
            }

            if (pageNumber > 0) {
                this.activeContent.find(".previous-button").show();
            } else {
                this.activeContent.find(".previous-button").hide();
            }
            if (pageNumber === numberOfPages) {
                this.activeContent.find(".next-button").hide();
            } else {
                this.activeContent.find(".next-button").show();
            }
        }
    }, {
        key: 'handleCall',
        value: function handleCall() {
            _jquery2.default.ajax({
                context: this,
                type: "POST",
                dataType: "json",
                url: this.requestUrl,
                data: {
                    page: this.i,
                    url: window.location.pathname.toString()
                },
                success: function success(result) {
                    this.searchData = result;
                    this.init();
                },
                error: function error() {}
            });
        }
    }, {
        key: 'createCard',
        value: function createCard(data) {
            var dataContent = '\n            <div class="bootroom-card-long ' + (data.picture ? '' : 'no-image') + '">\n                <a href="' + data.url + '" target=\'_blank\'>\n                    ' + (data.picture ? '<div class="bootroom-card-long__image" style="background-image:url(' + data.picture + ')">\n                        ' + (data.video ? '<div class="play-button">\n                                <span style="border-right-color: #E1261C"></span>\n                             </div>' : '') + '\n                         </div>' : '') + '\n\n                    <div class="card-content">\n                        ' + (data.mainTag ? '<div class="main-tag tag-' + data.mainTag.replace(/\s+/g, '').toLowerCase() + '">' + data.mainTag + '</div>' : '') + '\n                        <h4>\n                            ' + data.title + '\n                        </h4>\n                        ' + (data.text ? '<p>' + data.text + '</p>' : '') + '\n                        ' + (data.datetime ? '<div class="datetime">' + data.datetime + '</div>' : '') + '\n                        ' + (data.duration ? '<div class="duration">' + data.duration + '</div>' : '') + '\n                        ' + (!data.tags.empty ? '<div class="tags">' + data.tags.map(function (tag) {
                return '<span>' + tag + '</span>';
            }).join('') + '</div>' : '') + '\n                    </div>\n                </a>\n            </div>\n            <hr/>\n        ';
            return dataContent;
        }
    }, {
        key: 'createPagination',
        value: function createPagination(contentLength) {
            var numberOfPages = Math.ceil(contentLength / this.rowsPerPage);
            var numberOfButtons = 0;
            var buttonElement = [];
            if (numberOfPages <= 4) {
                numberOfButtons = numberOfPages;
            } else {
                numberOfButtons = 5;
            }
            for (var i = 0; i < numberOfButtons; i++) {
                buttonElement.push('<span role="button" data-page-number="' + i + '" data-inc-number=' + (i + -2) + ' class="pagination-button ' + (i === 0 ? 'active' : '') + '" >' + (i + 1) + '</span >');
            }
            var paginationElement = '\n            <div data-total-pages="' + numberOfPages + '" class="tab-pagination-buttons">\n                <span role="button" class="glyphicon glyphicon-menu-left previous-button" style="display:none"></span>\n                ' + buttonElement.join(' ') + '\n                <span role="button" class="glyphicon glyphicon-menu-right next-button"></span>\n            </div>\n        ';
            return paginationElement;
        }
    }, {
        key: 'tabScroll',
        value: function tabScroll() {
            var activeElement = this.activeElement;
            this.tabsWrap.each(function () {
                var monthSelected = (0, _jquery2.default)(this).find(activeElement);
                (0, _jquery2.default)(this).animate({ scrollLeft: (0, _jquery2.default)(this).scrollLeft() + monthSelected.offset().left - ((0, _jquery2.default)(this).width() - 40) / 2 + monthSelected.width() / 2 }, 500);
            });
        }
    }, {
        key: 'attachIndicator',
        value: function attachIndicator() {
            var _this5 = this;

            var pos = this.activeElement.position();
            var left = pos.left + this.tabsContainer.offset().left;
            var moveRight = this.lastLeft > pos.left;
            this.lastLeft = pos.left;
            var right = this.tabsContainer.outerWidth() - pos.left - this.activeElement.outerWidth();

            if (!moveRight) {
                this.indicator.css('right', right);
                this.indicator.addClass('first-right');
                setTimeout(function () {
                    _this5.indicator.css('left', pos.left);
                    _this5.indicator.removeClass('first-right');
                    _this5.indicator.addClass('left');
                    _this5.indicator.css('background-color', _this5.activeElement.data('tabColor'));
                    if (_this5.indicator.hasClass('right')) _this5.indicator.removeClass('right');
                }, 120);
            } else {
                left = pos.left;

                this.indicator.css('left', pos.left);
                this.indicator.addClass('first-left');
                this.indicator.css('background-color', this.activeElement.data('tabColor'));

                setTimeout(function () {
                    _this5.indicator.addClass('right');
                    _this5.indicator.removeClass('first-left');
                    if (_this5.indicator.hasClass('left')) _this5.indicator.removeClass('left');
                    _this5.indicator.css('right', right);
                }, 120);
            };
        }
    }]);

    return BootroomTabs;
}(_snappy2.default.BaseComponent);

_snappy2.default.Component.BootroomTabsHighlight = function (_Snappy$BaseComponent2) {
    _inherits(BootroomTabsHighlight, _Snappy$BaseComponent2);

    _createClass(BootroomTabsHighlight, null, [{
        key: 'tagName',
        get: function get() {
            return 'bootroom-tabs-highlight';
        }
    }]);

    function BootroomTabsHighlight(element) {
        _classCallCheck(this, BootroomTabsHighlight);

        var _this6 = _possibleConstructorReturn(this, (BootroomTabsHighlight.__proto__ || Object.getPrototypeOf(BootroomTabsHighlight)).call(this, element));

        _this6.lastLeft = 0;
        _this6.searchData = [];
        return _this6;
    }

    _createClass(BootroomTabsHighlight, [{
        key: 'setVars',
        value: function setVars() {
            this.tabs = (0, _jquery2.default)(this.$element.find('.individual-tab-title'));
            this.activeElement = (0, _jquery2.default)(this.$element.find('.individual-tab-title.active'));
            this.indicator = this.$element.find('.highlight');
            this.tabsWrap = this.$element.find('.tabs-bar');
            this.tabsContainer = this.$element.find('.tabs-holder');
            this.indicatorColor = this.activeElement.data('tabColor');
            this.anchor = (0, _jquery2.default)(this.$element.find('.bootroom-tabs-anchor'));
            this.tabsContent = (0, _jquery2.default)(this.$element.find('.bootroom-tabs-content'));
            this.activeContent = this.$element.find('.individual-tab-content.active');
            this.goToLink = '';
        }
    }, {
        key: 'init',
        value: function init() {
            this.tabs.map(function (i, tab) {
                if (!(0, _jquery2.default)(tab).hasClass("active")) {
                    (0, _jquery2.default)(tab).find('h3').width((0, _jquery2.default)(tab).find('h3').width() + (0, _jquery2.default)(tab).find('h3').width() / 15);
                } else {
                    (0, _jquery2.default)(tab).find('h3').width((0, _jquery2.default)(tab).find('h3').width());
                }
            });

            this.activeContent.fadeIn();
            this.indicator.css("background-color", this.indicatorColor);
            this.attachIndicator();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            window.addEventListener("resize", this.attachIndicator.bind(this));
            window.addEventListener("DOMContentLoaded", this.tabScroll());
            this.$element.find('.individual-tab-title').on('click', this.handleClickTab.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            this.init();
        }
    }, {
        key: 'handleClickTab',
        value: function handleClickTab(e) {
            this.activeElement = (0, _jquery2.default)(e.currentTarget);
            this.goToLink = '';

            if (!(0, _jquery2.default)(e.currentTarget).hasClass('disabled') && !(0, _jquery2.default)(e.currentTarget).hasClass('active')) {
                this.tabs.removeClass('active');
                if (this.tabsContent.length > 0) {
                    this.$element.find('.individual-tab-content').removeClass('active');
                    this.$element.find('.individual-tab-content').hide();
                    (0, _jquery2.default)(e.currentTarget).addClass('active');

                    (0, _jquery2.default)('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').addClass('active');
                    (0, _jquery2.default)('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]').fadeIn();

                    this.activeContent = (0, _jquery2.default)('.individual-tab-content[data-name="' + e.currentTarget.dataset.name + '"]');

                    if ((0, _jquery2.default)(window).scrollTop() > this.tabsContent.offset().top + 20) {
                        window.scrollTo({ top: this.anchor.offset().top - 40, behavior: 'smooth' });
                    }
                }

                if (this.activeElement.data('goTo') && this.activeElement.data('goTo').length > 0) {
                    this.goToLink = this.activeElement.data('goTo');
                }

                this.attachIndicator();

                this.tabScroll();
                e.preventDefault();
            }
        }
    }, {
        key: 'tabScroll',
        value: function tabScroll() {
            var activeElement = this.activeElement;
            this.tabsWrap.each(function () {
                var monthSelected = (0, _jquery2.default)(this).find(activeElement);
                (0, _jquery2.default)(this).animate({ scrollLeft: (0, _jquery2.default)(this).scrollLeft() + monthSelected.offset().left - ((0, _jquery2.default)(this).width() - 0) / 2 + monthSelected.width() / 2 }, 500);
            });
        }
    }, {
        key: 'attachIndicator',
        value: function attachIndicator() {
            var _this7 = this;

            var pos = this.activeElement.position();
            var moveRight = this.lastLeft > pos.left;
            this.lastLeft = pos.left;
            var right = this.tabsContainer.outerWidth() - pos.left - this.activeElement.outerWidth();

            if (!moveRight) {
                this.indicator.css('right', right);
                this.indicator.addClass('first-right');
                setTimeout(function () {
                    _this7.indicator.css('left', pos.left);
                    _this7.indicator.removeClass('first-right');
                    _this7.indicator.addClass('left');
                    _this7.indicator.css('background-color', _this7.activeElement.data('highlightColor'));
                    if (_this7.indicator.hasClass('right')) _this7.indicator.removeClass('right');
                    if (_this7.goToLink.length > 0) {
                        setTimeout(function () {
                            window.open(_this7.goToLink, "_self");
                        }, 500);
                    }
                }, 120);
            } else {
                this.indicator.css('left', pos.left);
                this.indicator.addClass('first-left');
                this.indicator.css('background-color', this.activeElement.data('tabColor'));

                setTimeout(function () {
                    _this7.indicator.addClass('right');
                    _this7.indicator.removeClass('first-left');
                    if (_this7.indicator.hasClass('left')) _this7.indicator.removeClass('left');
                    _this7.indicator.css('right', right);
                    if (_this7.goToLink.length > 0) {
                        setTimeout(function () {
                            window.open(_this7.goToLink, "_self");
                        }, 500);
                    }
                }, 120);
            };
        }
    }]);

    return BootroomTabsHighlight;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.EduUnsaveDataObserver = function (_Snappy$BaseComponent) {
    _inherits(EduUnsaveDataObserver, _Snappy$BaseComponent);

    _createClass(EduUnsaveDataObserver, null, [{
        key: 'tagName',
        get: function get() {
            return 'edu-unsaved-data-observer';
        }
    }]);

    function EduUnsaveDataObserver(element) {
        _classCallCheck(this, EduUnsaveDataObserver);

        return _possibleConstructorReturn(this, (EduUnsaveDataObserver.__proto__ || Object.getPrototypeOf(EduUnsaveDataObserver)).call(this, element));
    }

    _createClass(EduUnsaveDataObserver, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.unsavedData = null;
            this.unsavedDataWarnMessage = 'There are unsaved changes on this page. Are you sure you want to leave?';
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            (0, _jquery2.default)(window).on('unsaved:changed', this.onUnsavedChanged.bind(this));
        }
    }, {
        key: 'setOnBeforeUnload',
        value: function setOnBeforeUnload(nameSpace) {
            var _this2 = this;

            this.unsavedData = this.getUnsavedData(nameSpace);

            if (this.unsavedData) {
                var unsavedDataStatuses = [];

                Object.keys(this.unsavedData).forEach(function (key) {
                    unsavedDataStatuses.push(_this2.unsavedData[key]);
                });

                if (unsavedDataStatuses.some(function (status) {
                    return status === true;
                })) {
                    window.onbeforeunload = function () {
                        return _this2.unsavedDataWarnMessage;
                    };
                } else {
                    window.onbeforeunload = null;
                }
            }
        }
    }, {
        key: 'getUnsavedData',
        value: function getUnsavedData(nameSpace) {
            return JSON.parse(localStorage.getItem(nameSpace));
        }
    }, {
        key: 'onUnsavedChanged',
        value: function onUnsavedChanged(e, nameSpace, data) {
            this.unsavedData = this.getUnsavedData(nameSpace) || {};
            this.unsavedData['unsavedDataWarnMessage'] = this.unsavedDataWarnMessage;

            var mergedUnsavedData = _extends({}, this.unsavedData, data);

            localStorage.setItem(nameSpace, JSON.stringify(mergedUnsavedData));

            this.setOnBeforeUnload(nameSpace);
        }
    }]);

    return EduUnsaveDataObserver;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.GridPlaceholder = function (_Snappy$BaseComponent) {
    _inherits(GridPlaceholder, _Snappy$BaseComponent);

    _createClass(GridPlaceholder, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-grid-placeholder';
        }
    }]);

    function GridPlaceholder(element) {
        _classCallCheck(this, GridPlaceholder);

        return _possibleConstructorReturn(this, (GridPlaceholder.__proto__ || Object.getPrototypeOf(GridPlaceholder)).call(this, element));
    }

    _createClass(GridPlaceholder, [{
        key: 'setVars',
        value: function setVars() {
            this.$placeholder = this.$element;
        }
    }, {
        key: 'addEventListeners',
        value: function addEventListeners() {
            (0, _jquery2.default)(window).on('content:updated', this.initGridPlaceholder.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            this.setVars();
            this.addEventListeners();
            this.initGridPlaceholder();
        }
    }, {
        key: 'initGridPlaceholder',
        value: function initGridPlaceholder() {
            this.$target = (0, _jquery2.default)('[data-fa-placeholder-target]');
            if (_jquery2.default.trim((0, _jquery2.default)(this.$placeholder).html()).length) {
                this.$target.append(this.$placeholder);
            }
        }
    }]);

    return GridPlaceholder;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

__webpack_require__(815);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.IrTrigger = function (_Snappy$BaseComponent) {
    _inherits(IrTrigger, _Snappy$BaseComponent);

    _createClass(IrTrigger, null, [{
        key: 'tagName',
        get: function get() {
            return 'ir-trigger';
        }
    }]);

    function IrTrigger(element) {
        _classCallCheck(this, IrTrigger);

        return _possibleConstructorReturn(this, (IrTrigger.__proto__ || Object.getPrototypeOf(IrTrigger)).call(this, element));
    }

    _createClass(IrTrigger, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.type = this.$element.data('type') || 'signin';
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            if (!IrTrigger.$container) {
                return;
            }

            this.$element.on('click', this.clickHandle.bind(this));
        }
    }, {
        key: 'clickHandle',
        value: function clickHandle() {
            switch (this.type) {
                case 'signin':
                    IrTrigger.openSinginIr();
                    break;
                case 'registration':
                    IrTrigger.openRegistrationIr();
                    break;
                default:
                    console.log('wrong type');
            }
        }
    }], [{
        key: 'openSinginIr',
        value: function openSinginIr() {
            var url = IrTrigger.$container.attr("irUrl");
            IrTrigger.openIR(url);
        }
    }, {
        key: 'openRegistrationIr',
        value: function openRegistrationIr() {
            var url = IrTrigger.$container.attr("irRegUrl");
            IrTrigger.openIR(url);
        }
    }, {
        key: 'openIR',
        value: function openIR(url) {
            (0, _jquery2.default)("#IrSignInModal").on("show.bs.modal", function () {
                (0, _jquery2.default)("#IRFrame").attr("src", url);
                (0, _jquery2.default)("#IrSignInModal").css("padding", "0px");
            });

            (0, _jquery2.default)("#IrSignInModal").modal({
                show: true
            });
            (0, _jquery2.default)(".modal-backdrop.in").hide();
            (0, _jquery2.default)("#follow-register-modal-block").modal("hide");
        }
    }, {
        key: '$container',
        get: function get() {
            return (0, _jquery2.default)(".ir-frame-container");
        }
    }]);

    return IrTrigger;
}(_snappy2.default.BaseComponent);

(0, _jquery2.default)(window).on('IR:openSingIn', _snappy2.default.Component.IrTrigger.openSinginIr);

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.LoginPromptInitiator = function (_Snappy$BaseComponent) {
    _inherits(LoginPromptInitiator, _Snappy$BaseComponent);

    _createClass(LoginPromptInitiator, null, [{
        key: 'tagName',
        get: function get() {
            return 'login-prompt-initiator';
        }
    }]);

    function LoginPromptInitiator(element) {
        _classCallCheck(this, LoginPromptInitiator);

        return _possibleConstructorReturn(this, (LoginPromptInitiator.__proto__ || Object.getPrototypeOf(LoginPromptInitiator)).call(this, element));
    }

    _createClass(LoginPromptInitiator, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            this.prepareContent();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.trigger = this.$element.find('.js-login-prompt-initiator-trigger');
            this.baseUrl = this.$element.data('login-prompt-initiator-base');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('loginPrompt:open', this.onOpenEvent.bind(this));
            this.trigger.on('click', this.open.bind(this));
        }
    }, {
        key: 'onOpenEvent',
        value: function onOpenEvent() {
            this.open();
        }
    }, {
        key: 'open',
        value: function open() {
            this.$window.trigger('modal:openModal', {
                $view: this.$content,
                unclosable: true,
                unclosableBase: this.baseUrl
            });
        }
    }, {
        key: 'prepareContent',
        value: function prepareContent() {
            var templateSource = (0, _jquery2.default)('#prompt-login-template').html();
            var templateFiunc = _handlebars2.default.compile(templateSource);
            var htmlString = templateFiunc({});
            this.$content = (0, _jquery2.default)(htmlString);
        }
    }]);

    return LoginPromptInitiator;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 568:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

var _gsap = __webpack_require__(53);

var _underscore = __webpack_require__(16);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.PlaylistNav = function (_Snappy$BaseComponent) {
    _inherits(PlaylistNav, _Snappy$BaseComponent);

    _createClass(PlaylistNav, null, [{
        key: 'tagName',
        get: function get() {
            return 'playlist-nav';
        }
    }]);

    function PlaylistNav(element) {
        _classCallCheck(this, PlaylistNav);

        return _possibleConstructorReturn(this, (PlaylistNav.__proto__ || Object.getPrototypeOf(PlaylistNav)).call(this, element));
    }

    _createClass(PlaylistNav, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.onResize();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.isOpened = false;

            this.$document = (0, _jquery2.default)(document);
            this.$toggleBtn = this.$element.find('.js-playlist-toggle');
            this.$panel = this.$element.find('.js-playlist-panel');
            this.$nextContainer = this.$element.find('.js-playlist-next-container');

            this.settings = {
                transisionTime: 0.3

            };
        }
    }, {
        key: 'setDimensions',
        value: function setDimensions() {
            this.wHeight = this.$window.height();
            this.panelWidth = this.$panel.width();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));

            this.$document.on('scroll', (0, _underscore.throttle)(this.throttleScroll.bind(this), 200));

            this.$toggleBtn.on('click', this.toggle.bind(this));
        }
    }, {
        key: 'throttleScroll',
        value: function throttleScroll() {
            if (this.isOpened || _resize2.default.isWidest) {
                this.updateShifts();
            }
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (!this.isAnimating) {
                this.isAnimating = true;
                this.$element.addClass('is-animating');
                this.tween = new _gsap.TimelineLite({ onComplete: this.animationComplete.bind(this) });
                this[this.isOpened ? 'close' : 'open']();
            }
        }
    }, {
        key: 'close',
        value: function close() {
            this.isOpened = false;
            this.$body.removeClass('is-blocked-mobile');
            if (!_resize2.default.isTablet) {
                this.restoreScrollPos();
            }
            this.$toggleBtn.removeClass('is-active');
            this.$element.removeClass('is-opened');

            this.tween.to(this.$panel, this.settings.transisionTime, {
                x: this.panelWidth,
                clearProps: 'transform'
            }).to(this.$nextContainer, this.settings.transisionTime, {
                marginRight: 0,
                delay: -1 * this.settings.transisionTime
            });
            this.tween.play();
        }
    }, {
        key: 'open',
        value: function open() {
            this.isOpened = true;

            if (!_resize2.default.isTablet) {
                this.saveScrollPos();
            }
            this.$body.addClass('is-blocked-mobile');
            this.updateShifts();

            this.tween.to(this.$panel, this.settings.transisionTime, { x: 0 }).to(this.$nextContainer, this.settings.transisionTime, {
                marginRight: -1 * this.panelWidth,
                delay: -1 * this.settings.transisionTime
            });
            this.tween.play();
            this.$toggleBtn.addClass('is-active');
            this.$element.addClass('is-opened');

            (0, _jquery2.default)(window).trigger('gtm:send', ['Playlist Navigation', 'Open', document.location.href]);
        }
    }, {
        key: 'animationComplete',
        value: function animationComplete() {
            this.isAnimating = false;
            this.$element.removeClass('is-animating');
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.setDimensions();
            this.updateShifts();
        }
    }, {
        key: 'updateShifts',
        value: function updateShifts() {
            this.topOffset = this.$element[0].getBoundingClientRect().top;
            var h = this.wHeight - this.topOffset;
            this.$panel.css({ height: h + 10 });
        }
    }, {
        key: 'saveScrollPos',
        value: function saveScrollPos() {
            this.lastScrollPos = this.$document.scrollTop();
        }
    }, {
        key: 'restoreScrollPos',
        value: function restoreScrollPos() {
            this.$document.scrollTop(this.lastScrollPos);
        }
    }]);

    return PlaylistNav;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(107);
var objectAssign = __webpack_require__(104);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),

/***/ 570:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ResponsiveBackground = function (_Snappy$BaseComponent) {
    _inherits(ResponsiveBackground, _Snappy$BaseComponent);

    _createClass(ResponsiveBackground, null, [{
        key: 'tagName',
        get: function get() {
            return 'responsive-background';
        }
    }]);

    function ResponsiveBackground(element) {
        _classCallCheck(this, ResponsiveBackground);

        return _possibleConstructorReturn(this, (ResponsiveBackground.__proto__ || Object.getPrototypeOf(ResponsiveBackground)).call(this, element));
    }

    _createClass(ResponsiveBackground, [{
        key: 'setOptions',
        value: function setOptions() {
            this.Options = {
                images: this.$element.data('images')
            };
            this.images = this.Options.images.split(',');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            window.addEventListener('resize', this.loadImage.bind(this));
        }
    }, {
        key: 'loadImage',
        value: function loadImage() {
            if ((0, _jquery2.default)(window).width() <= 360) {
                this.$element.css("background-image", "url(" + this.images[0] + ")");
            } else if ((0, _jquery2.default)(window).width() <= 670 && (0, _jquery2.default)(window).width() > 361) {
                this.$element.css("background-image", "url(" + this.images[1] + ")");
            } else if ((0, _jquery2.default)(window).width() <= 1080 && (0, _jquery2.default)(window).width() > 669) {
                this.$element.css("background-image", "url(" + this.images[2] + ")");
            } else if ((0, _jquery2.default)(window).width() >= 1081) {
                this.$element.css("background-image", "url(" + this.images[3] + ")");
            }
        }
    }, {
        key: 'render',
        value: function render() {
            this.setOptions();
            this.loadImage();
            this.setEventListeners();
        }
    }]);

    return ResponsiveBackground;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _gsap = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.RevealEffect = function (_Snappy$BaseComponent) {
    _inherits(RevealEffect, _Snappy$BaseComponent);

    _createClass(RevealEffect, null, [{
        key: 'tagName',
        get: function get() {
            return 'fa-reveal-effect';
        }
    }]);

    function RevealEffect(element) {
        _classCallCheck(this, RevealEffect);

        var _this = _possibleConstructorReturn(this, (RevealEffect.__proto__ || Object.getPrototypeOf(RevealEffect)).call(this, element));

        _this.el = element;
        _this.options = {
            isContentHidden: true,
            revealSettings: {
                direction: 'rl',
                bgcolor: '#48C2C5',
                duration: 500,
                easing: 'Quint.easeInOut',
                coverArea: 0,
                onCover: function onCover(contentEl, revealerEl) {
                    contentEl.style.opacity = 1;
                },
                onStart: function onStart(contentEl, revealerEl) {
                    return false;
                },
                onComplete: function onComplete(contentEl, revealerEl) {
                    return false;
                }
            }
        };
        return _this;
    }

    _createClass(RevealEffect, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.layout();
        }
    }, {
        key: 'setVars',
        value: function setVars() {}
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {}
    }, {
        key: 'layout',
        value: function layout() {
            var _this2 = this;

            var position = getComputedStyle(this.el).position;
            if (position !== 'fixed' && position !== 'absolute' && position !== 'relative') {
                this.el.style.position = 'relative';
            }
            this.content = this.createDOMEl('div', 'block-revealer__content', this.el.innerHTML);
            if (this.options.isContentHidden) {
                this.content.style.opacity = 0;
            }
            this.revealer = this.createDOMEl('div', 'block-revealer__element');
            this.el.classList.add('block-revealer');
            this.el.innerHTML = '';
            this.el.appendChild(this.content);
            this.el.appendChild(this.revealer);

            setTimeout(function () {
                _this2.startEffect();
            }, 1000);
        }
    }, {
        key: 'getTransformSettings',
        value: function getTransformSettings(direction) {
            var val = void 0,
                origin = void 0,
                origin_2 = void 0;

            switch (direction) {
                case 'lr':
                    val = 'scale3d(0,1,1)';
                    origin = '0 50%';
                    origin_2 = '100% 50%';
                    break;
                case 'rl':
                    val = 'scale3d(0,1,1)';
                    origin = '100% 50%';
                    origin_2 = '0 50%';
                    break;
                case 'tb':
                    val = 'scale3d(1,0,1)';
                    origin = '50% 0';
                    origin_2 = '50% 100%';
                    break;
                case 'bt':
                    val = 'scale3d(1,0,1)';
                    origin = '50% 100%';
                    origin_2 = '50% 0';
                    break;
                default:
                    val = 'scale3d(0,1,1)';
                    origin = '0 50%';
                    origin_2 = '100% 50%';
                    break;
            }

            return {
                val: val,
                origin: { initial: origin, halfway: origin_2 }
            };
        }
    }, {
        key: 'reveal',
        value: function reveal() {
            var _tween$to;

            this.tween = new _gsap.TimelineLite();

            if (this.isAnimating) {
                return false;
            }
            this.isAnimating = true;

            var defaults = {
                duration: 500,
                easing: 'easeInOutQuint',
                delay: 0,
                bgcolor: '#f0f0f0',
                direction: 'lr',
                coverArea: 0
            };
            var revealSettings = _extends({}, defaults, this.options.revealSettings, this.$element.data());
            var direction = revealSettings.direction;
            var transformSettings = this.getTransformSettings(direction);

            this.revealer.style.WebkitTransform = this.revealer.style.transform = transformSettings.val;
            this.revealer.style.WebkitTransformOrigin = this.revealer.style.transformOrigin = transformSettings.origin.initial;

            this.revealer.style.backgroundColor = revealSettings.bgcolor;

            this.revealer.style.opacity = 1;

            var self = this,
                animationSettings_2 = {
                complete: function complete() {
                    self.isAnimating = false;
                    if (typeof revealSettings.onComplete === 'function') {
                        revealSettings.onComplete(self.content, self.revealer);
                    }
                }
            },
                animationSettings = {
                delay: revealSettings.delay,
                complete: function complete() {
                    var _tween2$fromTo2;

                    self.revealer.style.WebkitTransformOrigin = self.revealer.style.transformOrigin = transformSettings.origin.halfway;
                    if (typeof revealSettings.onCover === 'function') {
                        revealSettings.onCover(self.content, self.revealer);
                    }

                    this.tween2 = new _gsap.TimelineLite();

                    this.tween2.fromTo(animationSettings_2.targets, animationSettings_2.duration / 1000, _defineProperty({}, animationSettings.prop, 1), (_tween2$fromTo2 = {}, _defineProperty(_tween2$fromTo2, animationSettings.prop, coverArea / 100), _defineProperty(_tween2$fromTo2, 'delay', animationSettings.delay / 1000), _defineProperty(_tween2$fromTo2, 'ease', animationSettings_2.easing), _defineProperty(_tween2$fromTo2, 'onComplete', animationSettings_2.complete), _tween2$fromTo2));

                    this.tween2.play();
                }
            };

            animationSettings.targets = animationSettings_2.targets = this.revealer;
            animationSettings.duration = animationSettings_2.duration = revealSettings.duration;
            animationSettings.easing = animationSettings_2.easing = revealSettings.easing;

            var coverArea = revealSettings.coverArea;
            if (direction === 'lr' || direction === 'rl') {
                animationSettings.prop = 'scaleX';
            } else {
                animationSettings.prop = 'scaleY';
            }

            if (typeof revealSettings.onStart === 'function') {
                revealSettings.onStart(self.content, self.revealer);
            }

            this.tween.to(animationSettings.targets, animationSettings.duration / 1000, (_tween$to = {}, _defineProperty(_tween$to, animationSettings.prop, 1), _defineProperty(_tween$to, 'delay', animationSettings.delay / 1000), _defineProperty(_tween$to, 'ease', animationSettings.easing), _defineProperty(_tween$to, 'onComplete', animationSettings.complete), _tween$to));
            this.tween.play();

            //anime(animationSettings);
        }
    }, {
        key: 'createDOMEl',
        value: function createDOMEl(type, className, content) {
            var el = document.createElement(type);
            el.className = className || '';
            el.innerHTML = content || '';
            return el;
        }
    }, {
        key: 'startEffect',
        value: function startEffect() {
            var _this3 = this;

            if ('requestIdleCallback' in window) {
                requestIdleCallback(function () {
                    return _this3.reveal();
                }, { timeout: 1500 });
            } else {
                setTimeout(function () {
                    _this3.reveal();
                }, 100);
            }
        }
    }]);

    return RevealEffect;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

var _resizeObserverPolyfill = __webpack_require__(484);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ScrollProgress = function (_Snappy$BaseComponent) {
    _inherits(ScrollProgress, _Snappy$BaseComponent);

    _createClass(ScrollProgress, null, [{
        key: 'tagName',
        get: function get() {
            return 'scroll-progress';
        }
    }]);

    function ScrollProgress(element) {
        _classCallCheck(this, ScrollProgress);

        return _possibleConstructorReturn(this, (ScrollProgress.__proto__ || Object.getPrototypeOf(ScrollProgress)).call(this, element));
    }

    _createClass(ScrollProgress, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            this.setParameters();
            this.updateBar();
            this.initResizeObserver();
        }
    }, {
        key: 'initResizeObserver',
        value: function initResizeObserver() {
            var RO = typeof window.ResizeObserver === 'function' ? window.ResizeObserver : _resizeObserverPolyfill2.default;
            var resizeDebounced = (0, _underscore.debounce)(this.onResizeFinished.bind(this), 300);
            var ro = new RO(function (entries) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var entry = _step.value;

                        resizeDebounced();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });

            ro.observe(this.mainContentNode);
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.mainContentNode = document.querySelector('#main-content');
            this.$thumb = this.$element.find('.js-scroll-progress-thumb');
            this.$landingPageGrid = this.$document.find('.js-landing-page-grid');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var throttledScrollHandler = (0, _underscore.throttle)(this.scrollHandler.bind(this), 100);
            this.$window.on('scroll', throttledScrollHandler);
        }
    }, {
        key: 'updateBar',
        value: function updateBar() {
            var scrollValue = this.$window.scrollTop();
            var progress = (scrollValue / this.activeHeight).toFixed(2);
            this.$thumb.css('transform', 'scaleX(' + progress + ')');
        }
    }, {
        key: 'onResizeFinished',
        value: function onResizeFinished() {
            this.setParameters();
            this.updateBar();
        }
    }, {
        key: 'scrollHandler',
        value: function scrollHandler() {
            this.updateBar();
        }
    }, {
        key: 'setParameters',
        value: function setParameters() {
            this.documentHeight = this.$document.height();
            this.activeHeight = this.getActiveHeight();
        }
    }, {
        key: 'getActiveHeight',
        value: function getActiveHeight() {
            if (this.$landingPageGrid.length === 1) {
                var h = this.$landingPageGrid.outerHeight();
                var $twoColSublayout = this.$landingPageGrid.prev().filter('.js-two-column-sublayout');
                if ($twoColSublayout.length) {
                    h += $twoColSublayout.outerHeight();
                }
                return h;
            }
            return this.$window.height();
        }
    }]);

    return ScrollProgress;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 574:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

var _resizeObserverPolyfill = __webpack_require__(484);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.ScrollTracking = function (_Snappy$BaseComponent) {
    _inherits(ScrollTracking, _Snappy$BaseComponent);

    _createClass(ScrollTracking, null, [{
        key: 'tagName',
        get: function get() {
            return 'scroll-tracking';
        }
    }]);

    function ScrollTracking(element) {
        _classCallCheck(this, ScrollTracking);

        return _possibleConstructorReturn(this, (ScrollTracking.__proto__ || Object.getPrototypeOf(ScrollTracking)).call(this, element));
    }

    _createClass(ScrollTracking, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();

            this.setParameters();
            this.initResizeObserver();
        }
    }, {
        key: 'initResizeObserver',
        value: function initResizeObserver() {
            if (!this.mainContentNode) {
                return;
            }
            var RO = typeof window.ResizeObserver === 'function' ? window.ResizeObserver : _resizeObserverPolyfill2.default;
            var resizeDebounced = (0, _underscore.debounce)(this.onResizeFinished.bind(this), 1000);
            var ro = new RO(function (entries) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var entry = _step.value;

                        resizeDebounced();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });

            ro.observe(this.mainContentNode);
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.mainContentNode = document.querySelector('#main-content');
            this.maxProgress = 0;
            this.currentSection = this.$element.data('currentSection');
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {
            var throttledScrollHandler = (0, _underscore.throttle)(this.scrollHandler.bind(this), 700);
            this.$window.on('scroll', throttledScrollHandler);
        }
    }, {
        key: 'calculatePercentage',
        value: function calculatePercentage() {
            var scrollValue = this.$window.scrollTop();
            var progress = scrollValue / (this.documentHeight - this.windowHeight);
            var roundProgress = Math.floor(progress * 10) * 10;
            if (roundProgress > this.maxProgress) {
                this.maxProgress = roundProgress;
                (0, _jquery2.default)(window).trigger('gtm:send', [this.currentSection, 'Scroll', roundProgress + '%']);
            }
        }
    }, {
        key: 'onResizeFinished',
        value: function onResizeFinished() {
            this.setParameters();
            this.calculatePercentage();
        }
    }, {
        key: 'scrollHandler',
        value: function scrollHandler() {
            this.calculatePercentage();
        }
    }, {
        key: 'setParameters',
        value: function setParameters() {
            this.documentHeight = this.$document.height();
            this.windowHeight = this.$window.height();
        }
    }]);

    return ScrollTracking;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _underscore = __webpack_require__(16);

var _resize = __webpack_require__(12);

var _resize2 = _interopRequireDefault(_resize);

var _handlebars = __webpack_require__(10);

var _handlebars2 = _interopRequireDefault(_handlebars);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.SessionHero = function (_Snappy$BaseComponent) {
    _inherits(SessionHero, _Snappy$BaseComponent);

    _createClass(SessionHero, null, [{
        key: 'tagName',
        get: function get() {
            return 'session-hero';
        }
    }]);

    function SessionHero(element) {
        _classCallCheck(this, SessionHero);

        return _possibleConstructorReturn(this, (SessionHero.__proto__ || Object.getPrototypeOf(SessionHero)).call(this, element));
    }

    _createClass(SessionHero, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.setEventListeners();
            this.renderTimeline();
            this.onResize();
            this.detectActiveSection();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.$document = (0, _jquery2.default)(document);
            this.$timeline = this.$element.find('.js-timeline');
            this.$timelineList = this.$timeline.find('.js-timeline-list');

            this.$scrollContainer = this.$timeline.find('.js-scroll-container');
            this.$scrollModel = this.$element.find('.js-scroll-model');
            this.$arrowLeft = this.$timeline.find('.js-arrow-left');
            this.$arrowRight = this.$timeline.find('.js-arrow-right');
            this.$arrows = this.$arrowLeft.add(this.$arrowRight);
            this.$sectionHeaders = this.$document.find('.js-session-section');
            this.timelineJson = [];
            this.headerIdPrefix = 'session-header-';
            this.timelineScrollStep = this.getTimelineScrollStep();
        }
    }, {
        key: 'setEventListeners',
        value: function setEventListeners() {

            this.$arrowLeft.on('click', this.moveTimeline.bind(this, -1, this.timelineScrollStep));
            this.$arrowRight.on('click', this.moveTimeline.bind(this, 1, this.timelineScrollStep));
            this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));

            this.$document.on('scroll', (0, _underscore.throttle)(this.detectActiveSection.bind(this), 800));
            this.$scrollContainer.on('scroll', (0, _underscore.debounce)(this.onTimelineScrollFinished.bind(this), 200));
            this.headerNumber = 1;
        }
    }, {
        key: 'renderTimeline',
        value: function renderTimeline() {
            var templateSource = (0, _jquery2.default)('#session-timeline-template').html();
            var templateFunc = _handlebars2.default.compile(templateSource);
            this.prepareHeaders();
            var timelineHtml = templateFunc(this.timelineJson);
            this.$timelineList.append(timelineHtml);
            this.$timelineItems = this.$timelineList.find('.js-timeline-item');
        }
    }, {
        key: 'prepareHeaders',
        value: function prepareHeaders() {
            var _this2 = this;

            this.$sectionHeaders.each(function (i, item) {
                var $item = (0, _jquery2.default)(item);
                var $dummyAnchor = $item.find('.js-session-section-anchor');
                $dummyAnchor.attr('id', _this2.headerIdPrefix + i);
                var headerObj = {
                    isNumeric: $item.hasClass('is-numeric'),
                    title: $item.data('title'),
                    id: _this2.headerIdPrefix + i
                };

                if (headerObj.isNumeric) {
                    headerObj.number = _this2.headerNumber;
                    _this2.headerNumber++;
                    var numberContainer = $item.find('.js-session-number');
                    numberContainer.text(headerObj.number + '. ');
                }
                _this2.timelineJson.push(headerObj);
            });
        }
    }, {
        key: 'calculateHeadersOffset',
        value: function calculateHeadersOffset() {
            var _this3 = this;

            this.$sectionHeaders.each(function (i, item) {
                var $item = (0, _jquery2.default)(item);
                _this3.timelineJson[i].offsetTop = $item.offset().top;
            });
        }
    }, {
        key: 'detectActiveSection',
        value: function detectActiveSection() {

            var scrollPos = this.$window.scrollTop();
            var lastOverscrollItemIndex = -1;

            this.timelineJson.forEach(function (item, i) {
                if (item.offsetTop < scrollPos + 180) {
                    lastOverscrollItemIndex = i;
                }
            });

            var activeItemIndex = this.timelineJson.length - 1 === lastOverscrollItemIndex || this.timelineJson[lastOverscrollItemIndex + 1] && this.timelineJson[lastOverscrollItemIndex + 1].offsetTop > scrollPos + _resize2.default.height * 0.4 ? lastOverscrollItemIndex : lastOverscrollItemIndex + 1;

            if (activeItemIndex < 0) {
                activeItemIndex = 0;
            }
            if (this.activeItemIndex !== activeItemIndex) {
                this.activeItemIndex = activeItemIndex;
                this.$timelineItems.removeClass('is-active');
                this.$timelineItems.eq(activeItemIndex).addClass('is-active');
                this.scrollTimelineToView(activeItemIndex);
            }
        }
    }, {
        key: 'scrollTimelineToView',
        value: function scrollTimelineToView(activeItemIndex) {
            var padding = 25;
            var rect = this.$timelineItems.eq(activeItemIndex)[0].getBoundingClientRect();
            var leftSpace = rect.left;
            var rightSpace = _resize2.default.width - rect.right - padding;
            if (leftSpace < 0) {
                this.moveTimeline(-1, Math.abs(leftSpace) + padding);
            } else if (rightSpace < 0) {
                this.moveTimeline(1, Math.abs(rightSpace) + padding);
            }
        }
    }, {
        key: 'moveTimeline',
        value: function moveTimeline(direction, val) {
            var initialPos = this.$scrollContainer.scrollLeft();

            var newPos = initialPos + val * direction;
            this.$scrollContainer.animate({ scrollLeft: newPos }, {
                duration: 200
            });
        }
    }, {
        key: 'checkExtremePoints',
        value: function checkExtremePoints() {
            var scrollWidth = this.$scrollContainer[0].scrollWidth;
            var scrollLeft = this.$scrollContainer.scrollLeft();
            var width = this.$scrollContainer.width();

            if (scrollWidth > width) {
                this.$arrowLeft.removeAttr('disabled');
                this.$arrowRight.removeAttr('disabled');
            }

            if (scrollLeft === 0) {
                this.$arrowLeft.attr('disabled', 'disabled');
            }
            if (scrollLeft + width === scrollWidth) {
                this.$arrowRight.attr('disabled', 'disabled');
            }
        }
    }, {
        key: 'onTimelineScrollFinished',
        value: function onTimelineScrollFinished() {
            this.checkExtremePoints();
        }
    }, {
        key: 'updateDimensions',
        value: function updateDimensions() {
            this.timelineScrollStep = this.getTimelineScrollStep();
            if (_resize2.default.isDesktop) {
                var containerLeft = this.$scrollModel[0].getBoundingClientRect().left;
                this.$timelineList.css('padding-left', containerLeft + 'px');
            }
        }
    }, {
        key: 'getTimelineScrollStep',
        value: function getTimelineScrollStep() {
            return _resize2.default.isDesktop ? 360 : 180;
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.updateDimensions();
            this.checkExtremePoints();
            this.calculateHeadersOffset();
        }
    }]);

    return SessionHero;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 583:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

var _jquery = __webpack_require__(1);

var _jquery2 = _interopRequireDefault(_jquery);

var _tippy = __webpack_require__(870);

var _tippy2 = _interopRequireDefault(_tippy);

var _tippy3 = __webpack_require__(829);

var _tippy4 = _interopRequireDefault(_tippy3);

var _util = __webpack_require__(825);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_snappy2.default.Component.Tooltip = function (_Snappy$BaseComponent) {
    _inherits(Tooltip, _Snappy$BaseComponent);

    _createClass(Tooltip, null, [{
        key: 'tagName',
        get: function get() {
            return 'tooltip';
        }
    }]);

    function Tooltip(element) {
        _classCallCheck(this, Tooltip);

        var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, element));

        _this.element = element;
        return _this;
    }

    _createClass(Tooltip, [{
        key: 'render',
        value: function render() {
            this.setVars();
            this.initTooltip();
        }
    }, {
        key: 'setVars',
        value: function setVars() {
            this.customOptions = {};
            try {
                var optionsString = this.element.getAttribute('data-tooltip-options');
                if (optionsString) {
                    this.customOptions = JSON.parse(optionsString);
                }
            } catch (e) {
                console.log(e);
            }

            this.options = _extends({}, Tooltip.defaultOptions, this.customOptions);
            this.options.html = this.element.querySelector('[data-tooltip-content]');
        }
    }, {
        key: 'initTooltip',
        value: function initTooltip() {
            console.log(this.options);
            this.tooltip = (0, _tippy2.default)(this.element, this.options);
        }
    }], [{
        key: 'defaultOptions',
        get: function get() {
            return {
                delay: 100,
                arrow: true,
                arrowType: 'sharp',
                size: 'small',
                duration: 250,
                animation: 'shift-toward',
                maxWidth: '250px',
                placement: 'right',
                interactive: 'true'
            };
        }
    }]);

    return Tooltip;
}(_snappy2.default.BaseComponent);

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

/**
 * Object Fit Videos
 * Polyfill for object-fit and object-position CSS properties on video elements
 * Covers IE9, IE10, IE11, Edge, Safari <10
 *
 * Usage
 * In your CSS, add a special font-family tag for IE/Edge
 * video {
 *   object-fit: cover;
 *   font-family: 'object-fit: cover;';
 * }
 *
 * Before the closing body tag, or whenever the DOM is ready,
 * make the JavaScript call
 * objectFitVideos();
 *
 * All video elements with the special CSS property will be targeted
 *
 * @license  MIT (https://opensource.org/licenses/MIT)
 * @author   Todd Miller <todd.miller@tricomb2b.com>
 * @version  1.0.2
 * @changelog
 * 2016-08-19 - Adds object-position support.
 * 2016-08-19 - Add throttle function for more performant resize events
 * 2016-08-19 - Initial release with object-fit support, and
 *              object-position default 'center'
 * 2016-10-14 - No longer relies on window load event, instead requires a specific
 *              function call to initialize the videos for object fit and position.
 * 2016-11-28 - Support CommonJS environment, courtesy of @msorensson
 * 2016-12-05 - Refactors the throttling function to support IE
 * 2017-09-26 - Fix an issue with autplay not working on polyfilled videos
 *            - Adds the capability to specify elements to polyfill,
 *              instead of just checking every video element for the
 *              CSS property. Slight performance gain in most usecases,
 *              and a bigger gain in a few usecases.
 * 2017-10-24 - Add user agent check to enable polyfill for all Edge browsers.
 *              object-fit is supported on Edge >= 16, but currently just for images.
 */
var objectFitVideos = function (videos) {
  'use strict';

  var isEdge = navigator.userAgent.indexOf('Edge/') >= 0;

  var testImg                = new Image(),
      supportsObjectFit      = 'object-fit' in testImg.style && !isEdge,
      supportsObjectPosition = 'object-position' in testImg.style && !isEdge,
      propRegex              = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g;

  if (!supportsObjectFit || !supportsObjectPosition) {
    initialize(videos);
    throttle('resize', 'optimizedResize');
  }

  /**
   * Parse the style and look for the special font-family tag
   * @param  {object} $el The element to parse
   * @return {object}     The font-family properties we're interested in
   */
  function getStyle ($el) {
    var style  = getComputedStyle($el).fontFamily,
        parsed = null,
        props  = {};

      while ((parsed = propRegex.exec(style)) !== null) {
        props[parsed[1]] = parsed[2];
      }

      if (props['object-position'])
        return parsePosition(props);

      return props;
  }

  /**
   * Initialize all the relevant video elements and get them fitted
   */
  function initialize (videos) {
    var index = -1;

    if (!videos) {
      // if no videos given, query all video elements
      videos = document.querySelectorAll('video');
    } else if (!('length' in videos)) {
      // convert to an array for proper looping if an array or NodeList
      // was not given
      videos = [videos];
    }

    while (videos[++index]) {
      var style = getStyle(videos[index]);

      // only do work if the property is on the element
      if (style['object-fit'] || style['object-position']) {
        // set the default values
        style['object-fit'] = style['object-fit'] || 'fill';
        fitIt(videos[index], style);
      }
    }
  }

  /**
   * Object Fit
   * @param  {object} $el Element to fit
   * @return {object}     The element's relevant properties
   */
  function fitIt ($el, style) {
    // fill is the default behavior, no action is necessary
    if (style['object-fit'] === 'fill')
      return;

    // convenience style properties on the source element
    var setCss = $el.style,
        getCss = window.getComputedStyle($el);

    // create and insert a wrapper element
    var $wrap = document.createElement('object-fit');
    $wrap.appendChild($el.parentNode.replaceChild($wrap, $el));

    // style the wrapper element to mostly match the source element
    var wrapCss = {
      height:    '100%',
      width:     '100%',
      boxSizing: 'content-box',
      display:   'inline-block',
      overflow:  'hidden'
    };

    'backgroundColor backgroundImage borderColor borderStyle borderWidth bottom fontSize lineHeight left opacity margin position right top visibility'.replace(/\w+/g, function (key) {
      wrapCss[key] = getCss[key];
    });

    for (var key in wrapCss)
      $wrap.style[key] = wrapCss[key];

    // give the source element some saner styles
    setCss.border  = setCss.margin = setCss.padding = 0;
    setCss.display = 'block';
    setCss.opacity = 1;

    // set up the event handlers
    $el.addEventListener('loadedmetadata', doWork);
    window.addEventListener('optimizedResize', doWork);

    // we may have missed the loadedmetadata event, so if the video has loaded
    // enough data, just drop the event listener and execute
    if ($el.readyState >= 1) {
      $el.removeEventListener('loadedmetadata', doWork);
      doWork();
    }

    /**
     * Do the actual sizing. Math.
     * @methodOf fitIt
     */
    function doWork () {
      // the actual size and ratio of the video
      // we do this here, even though it doesn't change, because
      // at this point we can be sure the metadata has loaded
      var videoWidth  = $el.videoWidth,
          videoHeight = $el.videoHeight,
          videoRatio  = videoWidth / videoHeight;

      var wrapWidth  = $wrap.clientWidth,
          wrapHeight = $wrap.clientHeight,
          wrapRatio  = wrapWidth / wrapHeight;

      var newHeight = 0,
          newWidth  = 0;
      setCss.marginLeft = setCss.marginTop = 0;

      // basically we do the opposite action for contain and cover,
      // depending on whether the video aspect ratio is less than or
      // greater than the wrapper's aspect ratio
      if (videoRatio < wrapRatio ?
          style['object-fit'] === 'contain' : style['object-fit'] === 'cover') {
        newHeight = wrapHeight * videoRatio;
        newWidth  = wrapWidth / videoRatio;

        setCss.width  = Math.round(newHeight) + 'px';
        setCss.height = wrapHeight + 'px';

        if (style['object-position-x'] === 'left')
          setCss.marginLeft = 0;
        else if (style['object-position-x'] === 'right')
          setCss.marginLeft = Math.round(wrapWidth - newHeight) + 'px';
        else
          setCss.marginLeft = Math.round((wrapWidth - newHeight) / 2) + 'px';
      } else {
        newWidth = wrapWidth / videoRatio;

        setCss.width     = wrapWidth + 'px';
        setCss.height    = Math.round(newWidth) + 'px';

        if (style['object-position-y'] === 'top')
          setCss.marginTop = 0;
        else if (style['object-position-y'] === 'bottom')
          setCss.marginTop = Math.round(wrapHeight - newWidth) + 'px';
        else
          setCss.marginTop = Math.round((wrapHeight - newWidth) / 2) + 'px';
      }

      // play the video if autoplay is set
      if ($el.autoplay)
        $el.play();
    }
  }

  /**
   * Split the object-position property into x and y position properties
   * @param  {object} style Relevant element styles
   * @return {object}       The style object with the added x and y props
   */
  function parsePosition (style) {
    if (~style['object-position'].indexOf('left'))
      style['object-position-x'] = 'left';
    else if (~style['object-position'].indexOf('right'))
      style['object-position-x'] = 'right';
    else
      style['object-position-x'] = 'center';

    if (~style['object-position'].indexOf('top'))
      style['object-position-y'] = 'top';
    else if (~style['object-position'].indexOf('bottom'))
      style['object-position-y'] = 'bottom';
    else
      style['object-position-y'] = 'center';

    return style;
  }

  /**
   * Throttle an event with RequestAnimationFrame API for better performance
   * @param  {string} type The event to throttle
   * @param  {string} name Custom event name to listen for
   * @param  {object} obj  Optional object to attach the event to
   */
  function throttle (type, name, obj) {
    obj = obj || window;
    var running = false,
        evt     = null;

    // IE does not support the CustomEvent constructor
    // so if that fails do it the old way
    try {
      evt = new CustomEvent(name);
    } catch (e) {
      evt = document.createEvent('Event');
      evt.initEvent(name, true, true);
    }

    var func = function () {
      if (running) return;

      running = true;
      requestAnimationFrame(function () {
        obj.dispatchEvent(evt);
        running = false;
      });
    };

    obj.addEventListener(type, func);
  }
};

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined')
  module.exports = objectFitVideos;


/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _underscore = __webpack_require__(16);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
window.requestAnimFrame = function () {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function ( /* function */callback, /* DOMElement */element) {
        window.setTimeout(callback, 1000 / 60);
    };
}();

/**
 * nearby.js
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2018, Codrops
 * http://www.codrops.com
 */
/**
 * Distance between two points P1 (x1,y1) and P2 (x2,y2).
 */

var Nearby = function () {
    function Nearby(el, options) {
        _classCallCheck(this, Nearby);

        this.DOM = { el: el };
        this.options = options;
        this.init();
    }

    _createClass(Nearby, [{
        key: "distancePoints",
        value: function distancePoints(x1, y1, x2, y2) {
            // from http://www.quirksmode.org/js/events_properties.html#position
            return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
        }
    }, {
        key: "getMousePos",
        value: function getMousePos(e) {
            var posx = 0,
                posy = 0;
            if (!e) var e = window.event;
            if (e.pageX || e.pageY) {
                posx = e.pageX;
                posy = e.pageY;
            } else if (e.clientX || e.clientY) {
                posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
                posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
            }
            return { x: posx, y: posy };
        }
    }, {
        key: "init",
        value: function init() {
            var _this = this;

            this.mousemoveFn = function (ev) {
                return requestAnimFrame(function () {
                    var mousepos = _this.getMousePos(ev);
                    var docScrolls = { left: document.body.scrollLeft + document.documentElement.scrollLeft, top: document.body.scrollTop + document.documentElement.scrollTop };
                    var elRect = _this.DOM.el.getBoundingClientRect();
                    var elCoords = {
                        x1: elRect.left + docScrolls.left, x2: elRect.width + elRect.left + docScrolls.left,
                        y1: elRect.top + docScrolls.top, y2: elRect.height + elRect.top + docScrolls.top
                    };
                    var closestPoint = { x: mousepos.x, y: mousepos.y };

                    if (mousepos.x < elCoords.x1) {
                        closestPoint.x = elCoords.x1;
                    } else if (mousepos.x > elCoords.x2) {
                        closestPoint.x = elCoords.x2;
                    }
                    if (mousepos.y < elCoords.y1) {
                        closestPoint.y = elCoords.y1;
                    } else if (mousepos.y > elCoords.y2) {
                        closestPoint.y = elCoords.y2;
                    }
                    if (_this.options.onProgress) {
                        _this.options.onProgress(_this.distancePoints(mousepos.x, mousepos.y, closestPoint.x, closestPoint.y));
                    }
                });
            };

            window.addEventListener('mousemove', (0, _underscore.throttle)(this.mousemoveFn, 200));
        }
    }]);

    return Nearby;
}();

exports.default = Nearby;

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CommentsArranger = function () {
    function CommentsArranger() {
        _classCallCheck(this, CommentsArranger);
    }

    _createClass(CommentsArranger, null, [{
        key: "prepareData",
        value: function prepareData(data) {

            var result = CommentsArranger.renameProperties(data);
            result.count = CommentsArranger.calculateCount(result);

            result.isFirstLevel = true;
            return result;
        }
    }, {
        key: "getIdList",
        value: function getIdList(obj) {
            var arr = [];
            if (obj.items && obj.items.length) {
                obj.items.forEach(function (item) {
                    arr.push(item.id);
                    arr = arr.concat(CommentsArranger.getIdList(item));
                });
            }
            return arr;
        }
    }, {
        key: "renameProperties",
        value: function renameProperties(data) {
            data.items = data.comments || data.replies;
            if (data.items && data.items.length) {
                data.items.forEach(function (item) {
                    item = CommentsArranger.renameProperties(item);
                });
            }

            return data;
        }
    }, {
        key: "calculateCount",
        value: function calculateCount(data) {
            if (!data.items) {
                return 0;
            }
            var count = data.items.length;
            data.items.forEach(function (item) {
                item.count = CommentsArranger.calculateCount(item);
                count += item.count;
            });

            return count;
        }
    }, {
        key: "setDepth",
        value: function setDepth(arr, depth) {

            if (arr.length) {
                arr.forEach(function (item) {
                    item.depth = depth;
                    if (depth >= 2) {
                        item.isReplyBanned = true;
                    }
                    if (item.items && item.items.length) item.items = CommentsArranger.setDepth(item.items, depth + 1);
                });
            }

            return arr;
        }
    }, {
        key: "setLikes",
        value: function setLikes(data, likesArr) {
            var likes = likesArr.slice();
            if (data.items && data.items.length) {
                data.items.forEach(function (item) {
                    likes.forEach(function (like, i) {
                        if (like.contentId === item.id) {
                            item.likesCount = like.count;
                            item.isLiked = like.isLiked;
                            likesArr.splice(i, 1);
                        }
                    });
                    item = CommentsArranger.setLikes(item, likes);
                });
            }
            return data;
        }
    }]);

    return CommentsArranger;
}();

exports.default = CommentsArranger;

/***/ }),

/***/ 608:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _snappy = __webpack_require__(0);

var _snappy2 = _interopRequireDefault(_snappy);

__webpack_require__(598);

var _objectFitVideos = __webpack_require__(602);

var _objectFitVideos2 = _interopRequireDefault(_objectFitVideos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _objectFitVideos2.default)();

window.$ = window.jQuery = __webpack_require__(1);

__webpack_require__(519);
__webpack_require__(122);
__webpack_require__(521);
__webpack_require__(529);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(516);
__webpack_require__(531);
__webpack_require__(572);
__webpack_require__(507);
__webpack_require__(573);
__webpack_require__(575);
__webpack_require__(561);
__webpack_require__(568);
__webpack_require__(128);
__webpack_require__(502);
__webpack_require__(583);
__webpack_require__(129);
__webpack_require__(574);
__webpack_require__(566);
__webpack_require__(496);
__webpack_require__(501);
__webpack_require__(562);
__webpack_require__(513);
__webpack_require__(518);
__webpack_require__(494);
__webpack_require__(527);
__webpack_require__(123);
__webpack_require__(515);
__webpack_require__(570);
__webpack_require__(530);
__webpack_require__(526);
__webpack_require__(523);
__webpack_require__(528);
__webpack_require__(520);
__webpack_require__(514);
__webpack_require__(517);

_snappy2.default.init();

/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCookie = getCookie;
exports.setCookie = setCookie;
function getCookie(name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(cname, cvalue, minutes) {
    var d = new Date();
    d.setTime(d.getTime() + minutes * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoHelpers = function () {
    function VideoHelpers() {
        _classCallCheck(this, VideoHelpers);
    }

    _createClass(VideoHelpers, null, [{
        key: "getFomattedDuration",
        value: function getFomattedDuration(durationSeconds) {
            var minutes = Math.floor(durationSeconds / 60);
            var seconds = durationSeconds - minutes * 60;

            return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
        }
    }, {
        key: "parseYoutubeId",
        value: function parseYoutubeId(url) {
            var ID = '';
            url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
            if (url[2] !== undefined) {
                ID = url[2].split(/[^0-9a-z_\-]/i);
                ID = ID[0];
            }

            return ID;
        }
    }, {
        key: "parseVimeoId",
        value: function parseVimeoId(url) {
            var id = url.match(/\/\/[^\/]+\/([^\.]+)/)[1];
            if (typeof id === 'string') {
                id = id.split('/')[0];
            }
            return id;
        }
    }]);

    return VideoHelpers;
}();

exports.default = VideoHelpers;

/***/ }),

/***/ 815:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);


/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(819)(undefined);
// imports


// module
exports.push([module.i, ".tippy-touch{cursor:pointer!important}.tippy-notransition{transition:none!important}.tippy-popper{max-width:350px;-webkit-perspective:700px;perspective:700px;z-index:9999;outline:0;transition-timing-function:cubic-bezier(.165,.84,.44,1);pointer-events:none;line-height:1.4}.tippy-popper[data-html]{max-width:96%;max-width:calc(100% - 20px)}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-8px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:7px solid #333;border-right:7px solid transparent;border-left:7px solid transparent;bottom:-7px;margin:0 6px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 90%;transform-origin:0 90%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-50%,25%);transform:scale(6) translate(-50%,25%);opacity:1}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1) translate(-50%,25%);transform:scale(1) translate(-50%,25%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px) rotateX(0);transform:translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(90deg);transform:translateY(0) rotateX(90deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(0);transform:translateY(0) scale(0)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-8px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:7px solid #333;border-right:7px solid transparent;border-left:7px solid transparent;top:-7px;margin:0 6px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -90%;transform-origin:0 -90%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-50%,-125%);transform:scale(6) translate(-50%,-125%);opacity:1}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1) translate(-50%,-125%);transform:scale(1) translate(-50%,-125%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateY(10px) rotateX(0);transform:translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(-90deg);transform:translateY(0) rotateX(-90deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(0);transform:translateY(0) scale(0)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-16px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:7px solid #333;border-top:7px solid transparent;border-bottom:7px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:100% 0;transform-origin:100% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(40%,-50%);transform:scale(6) translate(40%,-50%);opacity:1}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1.5) translate(40%,-50%);transform:scale(1.5) translate(40%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px) rotateY(0);transform:translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(-90deg);transform:translateX(0) rotateY(-90deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(0);transform:translateX(0) scale(0)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-16px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:7px solid #333;border-top:7px solid transparent;border-bottom:7px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-100% 0;transform-origin:-100% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-140%,-50%);transform:scale(6) translate(-140%,-50%);opacity:1}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1.5) translate(-140%,-50%);transform:scale(1.5) translate(-140%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateX(10px) rotateY(0);transform:translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(90deg);transform:translateX(0) rotateY(90deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(0);transform:translateX(0) scale(0)}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:.9rem;padding:.3rem .6rem;text-align:center;will-change:transform;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#333}.tippy-tooltip[data-size=small]{padding:.2rem .4rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.4rem .8rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-animatefill] .tippy-content{transition:-webkit-clip-path cubic-bezier(.46,.1,.52,.98);transition:clip-path cubic-bezier(.46,.1,.52,.98);transition:clip-path cubic-bezier(.46,.1,.52,.98),-webkit-clip-path cubic-bezier(.46,.1,.52,.98)}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.53,2,.36,.85)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:24px;height:8px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;will-change:transform;background-color:#333;border-radius:50%;width:26%;left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:\"\";float:left;padding-top:100%}body:not(.tippy-touch) .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(100% 100% at 50% 50%);clip-path:ellipse(100% 100% at 50% 50%)}body:not(.tippy-touch) .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(5% 50% at 50% 50%);clip-path:ellipse(5% 50% at 50% 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=right] .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(135% 100% at 0 50%);clip-path:ellipse(135% 100% at 0 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=right] .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(40% 100% at 0 50%);clip-path:ellipse(40% 100% at 0 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=left] .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(135% 100% at 100% 50%);clip-path:ellipse(135% 100% at 100% 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=left] .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(40% 100% at 100% 50%);clip-path:ellipse(40% 100% at 100% 50%)}@media (max-width:360px){.tippy-popper{max-width:96%;max-width:calc(100% - 20px)}}", ""]);

// exports


/***/ }),

/***/ 819:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 823:
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ 824:
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(824);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(823);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),

/***/ 827:
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader 
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	}),
	getElement = (function(fn) {
		var memo = {};
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				memo[selector] = fn.call(this, selector);
			}
			return memo[selector]
		};
	})(function (styleTarget) {
		return document.querySelector(styleTarget)
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [],
	fixUrls = __webpack_require__(828);

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (typeof options.insertInto === "undefined") options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list, options);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list, options) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var styleTarget = getElement(options.insertInto)
	if (!styleTarget) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			styleTarget.insertBefore(styleElement, styleTarget.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			styleTarget.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			styleTarget.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		styleTarget.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	options.attrs.type = "text/css";

	attachTagAttrs(styleElement, options.attrs);
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	attachTagAttrs(linkElement, options.attrs);
	insertStyleElement(options, linkElement);
	return linkElement;
}

function attachTagAttrs(element, attrs) {
	Object.keys(attrs).forEach(function (key) {
		element.setAttribute(key, attrs[key]);
	});
}

function addStyle(obj, options) {
	var styleElement, update, remove, transformResult;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    transformResult = options.transform(obj.css);
	    
	    if (transformResult) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = transformResult;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css. 
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement, options);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/* If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
	and there is no publicPath defined then lets turn convertToAbsoluteUrls
	on by default.  Otherwise default to the convertToAbsoluteUrls option
	directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls){
		css = fixUrls(css);
	}

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 828:
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),

/***/ 829:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(818);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(827)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js!./tippy.css", function() {
			var newContent = require("!!../../css-loader/index.js!./tippy.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*!
* Tippy.js v2.6.0
* (c) 2017-2018 atomiks
* MIT
*/
(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.tippy = factory());
}(this, (function () { 'use strict';

var styles = ".tippy-touch{cursor:pointer!important}.tippy-notransition{transition:none!important}.tippy-popper{max-width:350px;-webkit-perspective:700px;perspective:700px;z-index:9999;outline:0;transition-timing-function:cubic-bezier(.165,.84,.44,1);pointer-events:none;line-height:1.4}.tippy-popper[data-html]{max-width:96%;max-width:calc(100% - 20px)}.tippy-popper[x-placement^=top] .tippy-backdrop{border-radius:40% 40% 0 0}.tippy-popper[x-placement^=top] .tippy-roundarrow{bottom:-8px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.tippy-popper[x-placement^=top] .tippy-arrow{border-top:7px solid #333;border-right:7px solid transparent;border-left:7px solid transparent;bottom:-7px;margin:0 6px;-webkit-transform-origin:50% 0;transform-origin:50% 0}.tippy-popper[x-placement^=top] .tippy-backdrop{-webkit-transform-origin:0 90%;transform-origin:0 90%}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-50%,25%);transform:scale(6) translate(-50%,25%);opacity:1}.tippy-popper[x-placement^=top] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1) translate(-50%,25%);transform:scale(1) translate(-50%,25%);opacity:0}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(-20px);transform:translateY(-20px)}.tippy-popper[x-placement^=top] [data-animation=perspective]{-webkit-transform-origin:bottom;transform-origin:bottom}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px) rotateX(0);transform:translateY(-10px) rotateX(0)}.tippy-popper[x-placement^=top] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(90deg);transform:translateY(0) rotateX(90deg)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px);transform:translateY(-10px)}.tippy-popper[x-placement^=top] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateY(-10px) scale(1);transform:translateY(-10px) scale(1)}.tippy-popper[x-placement^=top] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(0);transform:translateY(0) scale(0)}.tippy-popper[x-placement^=bottom] .tippy-backdrop{border-radius:0 0 30% 30%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow{top:-8px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(0);transform:rotate(0)}.tippy-popper[x-placement^=bottom] .tippy-arrow{border-bottom:7px solid #333;border-right:7px solid transparent;border-left:7px solid transparent;top:-7px;margin:0 6px;-webkit-transform-origin:50% 100%;transform-origin:50% 100%}.tippy-popper[x-placement^=bottom] .tippy-backdrop{-webkit-transform-origin:0 -90%;transform-origin:0 -90%}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-50%,-125%);transform:scale(6) translate(-50%,-125%);opacity:1}.tippy-popper[x-placement^=bottom] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1) translate(-50%,-125%);transform:scale(1) translate(-50%,-125%);opacity:0}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateY(20px);transform:translateY(20px)}.tippy-popper[x-placement^=bottom] [data-animation=perspective]{-webkit-transform-origin:top;transform-origin:top}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateY(10px) rotateX(0);transform:translateY(10px) rotateX(0)}.tippy-popper[x-placement^=bottom] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) rotateX(-90deg);transform:translateY(0) rotateX(-90deg)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateY(10px);transform:translateY(10px)}.tippy-popper[x-placement^=bottom] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateY(0);transform:translateY(0)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateY(10px) scale(1);transform:translateY(10px) scale(1)}.tippy-popper[x-placement^=bottom] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateY(0) scale(0);transform:translateY(0) scale(0)}.tippy-popper[x-placement^=left] .tippy-backdrop{border-radius:50% 0 0 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow{right:-16px;-webkit-transform-origin:33.33333333% 50%;transform-origin:33.33333333% 50%}.tippy-popper[x-placement^=left] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(90deg);transform:rotate(90deg)}.tippy-popper[x-placement^=left] .tippy-arrow{border-left:7px solid #333;border-top:7px solid transparent;border-bottom:7px solid transparent;right:-7px;margin:3px 0;-webkit-transform-origin:0 50%;transform-origin:0 50%}.tippy-popper[x-placement^=left] .tippy-backdrop{-webkit-transform-origin:100% 0;transform-origin:100% 0}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(40%,-50%);transform:scale(6) translate(40%,-50%);opacity:1}.tippy-popper[x-placement^=left] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1.5) translate(40%,-50%);transform:scale(1.5) translate(40%,-50%);opacity:0}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(-20px);transform:translateX(-20px)}.tippy-popper[x-placement^=left] [data-animation=perspective]{-webkit-transform-origin:right;transform-origin:right}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px) rotateY(0);transform:translateX(-10px) rotateY(0)}.tippy-popper[x-placement^=left] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(-90deg);transform:translateX(0) rotateY(-90deg)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px);transform:translateX(-10px)}.tippy-popper[x-placement^=left] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateX(-10px) scale(1);transform:translateX(-10px) scale(1)}.tippy-popper[x-placement^=left] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(0);transform:translateX(0) scale(0)}.tippy-popper[x-placement^=right] .tippy-backdrop{border-radius:0 50% 50% 0}.tippy-popper[x-placement^=right] .tippy-roundarrow{left:-16px;-webkit-transform-origin:66.66666666% 50%;transform-origin:66.66666666% 50%}.tippy-popper[x-placement^=right] .tippy-roundarrow svg{position:absolute;left:0;-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.tippy-popper[x-placement^=right] .tippy-arrow{border-right:7px solid #333;border-top:7px solid transparent;border-bottom:7px solid transparent;left:-7px;margin:3px 0;-webkit-transform-origin:100% 50%;transform-origin:100% 50%}.tippy-popper[x-placement^=right] .tippy-backdrop{-webkit-transform-origin:-100% 0;transform-origin:-100% 0}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=visible]{-webkit-transform:scale(6) translate(-140%,-50%);transform:scale(6) translate(-140%,-50%);opacity:1}.tippy-popper[x-placement^=right] .tippy-backdrop[data-state=hidden]{-webkit-transform:scale(1.5) translate(-140%,-50%);transform:scale(1.5) translate(-140%,-50%);opacity:0}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-toward][data-state=hidden]{opacity:0;-webkit-transform:translateX(20px);transform:translateX(20px)}.tippy-popper[x-placement^=right] [data-animation=perspective]{-webkit-transform-origin:left;transform-origin:left}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=visible]{opacity:1;-webkit-transform:translateX(10px) rotateY(0);transform:translateX(10px) rotateY(0)}.tippy-popper[x-placement^=right] [data-animation=perspective][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) rotateY(90deg);transform:translateX(0) rotateY(90deg)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=fade][data-state=hidden]{opacity:0;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=visible]{opacity:1;-webkit-transform:translateX(10px);transform:translateX(10px)}.tippy-popper[x-placement^=right] [data-animation=shift-away][data-state=hidden]{opacity:0;-webkit-transform:translateX(0);transform:translateX(0)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=visible]{opacity:1;-webkit-transform:translateX(10px) scale(1);transform:translateX(10px) scale(1)}.tippy-popper[x-placement^=right] [data-animation=scale][data-state=hidden]{opacity:0;-webkit-transform:translateX(0) scale(0);transform:translateX(0) scale(0)}.tippy-tooltip{position:relative;color:#fff;border-radius:4px;font-size:.9rem;padding:.3rem .6rem;text-align:center;will-change:transform;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;background-color:#333}.tippy-tooltip[data-size=small]{padding:.2rem .4rem;font-size:.75rem}.tippy-tooltip[data-size=large]{padding:.4rem .8rem;font-size:1rem}.tippy-tooltip[data-animatefill]{overflow:hidden;background-color:transparent}.tippy-tooltip[data-animatefill] .tippy-content{transition:-webkit-clip-path cubic-bezier(.46,.1,.52,.98);transition:clip-path cubic-bezier(.46,.1,.52,.98);transition:clip-path cubic-bezier(.46,.1,.52,.98),-webkit-clip-path cubic-bezier(.46,.1,.52,.98)}.tippy-tooltip[data-interactive],.tippy-tooltip[data-interactive] path{pointer-events:auto}.tippy-tooltip[data-inertia][data-state=visible]{transition-timing-function:cubic-bezier(.53,2,.36,.85)}.tippy-tooltip[data-inertia][data-state=hidden]{transition-timing-function:ease}.tippy-arrow,.tippy-roundarrow{position:absolute;width:0;height:0}.tippy-roundarrow{width:24px;height:8px;fill:#333;pointer-events:none}.tippy-backdrop{position:absolute;will-change:transform;background-color:#333;border-radius:50%;width:26%;left:50%;top:50%;z-index:-1;transition:all cubic-bezier(.46,.1,.52,.98);-webkit-backface-visibility:hidden;backface-visibility:hidden}.tippy-backdrop:after{content:\"\";float:left;padding-top:100%}body:not(.tippy-touch) .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(100% 100% at 50% 50%);clip-path:ellipse(100% 100% at 50% 50%)}body:not(.tippy-touch) .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(5% 50% at 50% 50%);clip-path:ellipse(5% 50% at 50% 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=right] .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(135% 100% at 0 50%);clip-path:ellipse(135% 100% at 0 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=right] .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(40% 100% at 0 50%);clip-path:ellipse(40% 100% at 0 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=left] .tippy-tooltip[data-animatefill][data-state=visible] .tippy-content{-webkit-clip-path:ellipse(135% 100% at 100% 50%);clip-path:ellipse(135% 100% at 100% 50%)}body:not(.tippy-touch) .tippy-popper[x-placement=left] .tippy-tooltip[data-animatefill][data-state=hidden] .tippy-content{-webkit-clip-path:ellipse(40% 100% at 100% 50%);clip-path:ellipse(40% 100% at 100% 50%)}@media (max-width:360px){.tippy-popper{max-width:96%;max-width:calc(100% - 20px)}}";

var version = "2.6.0";

var isBrowser = typeof window !== 'undefined';

var isIE = isBrowser && /MSIE |Trident\//.test(navigator.userAgent);

var browser = {};

if (isBrowser) {
  browser.supported = 'requestAnimationFrame' in window;
  browser.supportsTouch = 'ontouchstart' in window;
  browser.usingTouch = false;
  browser.dynamicInputDetection = true;
  browser.iOS = /iPhone|iPad|iPod/.test(navigator.platform) && !window.MSStream;
  browser.onUserInputChange = function () {};
}

/**
 * Selector constants used for grabbing elements
 */
var selectors = {
  POPPER: '.tippy-popper',
  TOOLTIP: '.tippy-tooltip',
  CONTENT: '.tippy-content',
  BACKDROP: '.tippy-backdrop',
  ARROW: '.tippy-arrow',
  ROUND_ARROW: '.tippy-roundarrow',
  REFERENCE: '[data-tippy]'
};

var defaults = {
  placement: 'top',
  livePlacement: true,
  trigger: 'mouseenter focus',
  animation: 'shift-away',
  html: false,
  animateFill: true,
  arrow: false,
  delay: [0, 20],
  duration: [350, 300],
  interactive: false,
  interactiveBorder: 2,
  theme: 'dark',
  size: 'regular',
  distance: 10,
  offset: 0,
  hideOnClick: true,
  multiple: false,
  followCursor: false,
  inertia: false,
  updateDuration: 350,
  sticky: false,
  appendTo: function appendTo() {
    return document.body;
  },
  zIndex: 9999,
  touchHold: false,
  performance: false,
  dynamicTitle: false,
  flip: true,
  flipBehavior: 'flip',
  arrowType: 'sharp',
  arrowTransform: '',
  maxWidth: '',
  target: null,
  allowTitleHTML: true,
  popperOptions: {},
  createPopperInstanceOnInit: false,
  onShow: function onShow() {},
  onShown: function onShown() {},
  onHide: function onHide() {},
  onHidden: function onHidden() {}
};

/**
 * The keys of the defaults object for reducing down into a new object
 * Used in `getIndividualOptions()`
 */
var defaultsKeys = browser.supported && Object.keys(defaults);

/**
 * Determines if a value is an object literal
 * @param {*} value
 * @return {Boolean}
 */
function isObjectLiteral(value) {
  return {}.toString.call(value) === '[object Object]';
}

/**
 * Ponyfill for Array.from
 * @param {*} value
 * @return {Array}
 */
function toArray(value) {
  return [].slice.call(value);
}

/**
 * Returns an array of elements based on the selector input
 * @param {String|Element|Element[]|NodeList|Object} selector
 * @return {Element[]}
 */
function getArrayOfElements(selector) {
  if (selector instanceof Element || isObjectLiteral(selector)) {
    return [selector];
  }

  if (selector instanceof NodeList) {
    return toArray(selector);
  }

  if (Array.isArray(selector)) {
    return selector;
  }

  try {
    return toArray(document.querySelectorAll(selector));
  } catch (_) {
    return [];
  }
}

/**
 * Polyfills needed props/methods for a virtual reference object
 * NOTE: in v3.0 this will be pure
 * @param {Object} reference
 */
function polyfillVirtualReferenceProps(reference) {
  reference.refObj = true;
  reference.attributes = reference.attributes || {};
  reference.setAttribute = function (key, val) {
    reference.attributes[key] = val;
  };
  reference.getAttribute = function (key) {
    return reference.attributes[key];
  };
  reference.removeAttribute = function (key) {
    delete reference.attributes[key];
  };
  reference.hasAttribute = function (key) {
    return key in reference.attributes;
  };
  reference.addEventListener = function () {};
  reference.removeEventListener = function () {};
  reference.classList = {
    classNames: {},
    add: function add(key) {
      return reference.classList.classNames[key] = true;
    },
    remove: function remove(key) {
      delete reference.classList.classNames[key];
      return true;
    },
    contains: function contains(key) {
      return key in reference.classList.classNames;
    }
  };
}

/**
 * Returns the supported prefixed property - only `webkit` is needed, `moz`, `ms` and `o` are obsolete
 * @param {String} property
 * @return {String} - browser supported prefixed property
 */
function prefix(property) {
  var prefixes = ['', 'webkit'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var _prefix = prefixes[i];
    var prefixedProp = _prefix ? _prefix + upperProp : property;
    if (typeof document.body.style[prefixedProp] !== 'undefined') {
      return prefixedProp;
    }
  }

  return null;
}

/**
 * Creates a div element
 * @return {Element}
 */
function div() {
  return document.createElement('div');
}

/**
 * Creates a popper element then returns it
 * @param {Number} id - the popper id
 * @param {String} title - the tooltip's `title` attribute
 * @param {Object} options - individual options
 * @return {Element} - the popper element
 */
function createPopperElement(id, title, options) {
  var popper = div();
  popper.setAttribute('class', 'tippy-popper');
  popper.setAttribute('role', 'tooltip');
  popper.setAttribute('id', 'tippy-' + id);
  popper.style.zIndex = options.zIndex;
  popper.style.maxWidth = options.maxWidth;

  var tooltip = div();
  tooltip.setAttribute('class', 'tippy-tooltip');
  tooltip.setAttribute('data-size', options.size);
  tooltip.setAttribute('data-animation', options.animation);
  tooltip.setAttribute('data-state', 'hidden');
  options.theme.split(' ').forEach(function (t) {
    tooltip.classList.add(t + '-theme');
  });

  var content = div();
  content.setAttribute('class', 'tippy-content');

  if (options.arrow) {
    var arrow = div();
    arrow.style[prefix('transform')] = options.arrowTransform;

    if (options.arrowType === 'round') {
      arrow.classList.add('tippy-roundarrow');
      arrow.innerHTML = '<svg viewBox="0 0 24 8" xmlns="http://www.w3.org/2000/svg"><path d="M3 8s2.021-.015 5.253-4.218C9.584 2.051 10.797 1.007 12 1c1.203-.007 2.416 1.035 3.761 2.782C19.012 8.005 21 8 21 8H3z"/></svg>';
    } else {
      arrow.classList.add('tippy-arrow');
    }

    tooltip.appendChild(arrow);
  }

  if (options.animateFill) {
    // Create animateFill circle element for animation
    tooltip.setAttribute('data-animatefill', '');
    var backdrop = div();
    backdrop.classList.add('tippy-backdrop');
    backdrop.setAttribute('data-state', 'hidden');
    tooltip.appendChild(backdrop);
  }

  if (options.inertia) {
    // Change transition timing function cubic bezier
    tooltip.setAttribute('data-inertia', '');
  }

  if (options.interactive) {
    tooltip.setAttribute('data-interactive', '');
  }

  var html = options.html;
  if (html) {
    var templateId = void 0;

    if (html instanceof Element) {
      content.appendChild(html);
      templateId = '#' + (html.id || 'tippy-html-template');
    } else {
      // trick linters: https://github.com/atomiks/tippyjs/issues/197
      content[true && 'innerHTML'] = document.querySelector(html)[true && 'innerHTML'];
      templateId = html;
    }

    popper.setAttribute('data-html', '');
    tooltip.setAttribute('data-template-id', templateId);

    if (options.interactive) {
      popper.setAttribute('tabindex', '-1');
    }
  } else {
    content[options.allowTitleHTML ? 'innerHTML' : 'textContent'] = title;
  }

  tooltip.appendChild(content);
  popper.appendChild(tooltip);

  return popper;
}

/**
 * Creates a trigger by adding the necessary event listeners to the reference element
 * @param {String} eventType - the custom event specified in the `trigger` setting
 * @param {Element} reference
 * @param {Object} handlers - the handlers for each event
 * @param {Object} options
 * @return {Array} - array of listener objects
 */
function createTrigger(eventType, reference, handlers, options) {
  var onTrigger = handlers.onTrigger,
      onMouseLeave = handlers.onMouseLeave,
      onBlur = handlers.onBlur,
      onDelegateShow = handlers.onDelegateShow,
      onDelegateHide = handlers.onDelegateHide;

  var listeners = [];

  if (eventType === 'manual') return listeners;

  var on = function on(eventType, handler) {
    reference.addEventListener(eventType, handler);
    listeners.push({ event: eventType, handler: handler });
  };

  if (!options.target) {
    on(eventType, onTrigger);

    if (browser.supportsTouch && options.touchHold) {
      on('touchstart', onTrigger);
      on('touchend', onMouseLeave);
    }
    if (eventType === 'mouseenter') {
      on('mouseleave', onMouseLeave);
    }
    if (eventType === 'focus') {
      on(isIE ? 'focusout' : 'blur', onBlur);
    }
  } else {
    if (browser.supportsTouch && options.touchHold) {
      on('touchstart', onDelegateShow);
      on('touchend', onDelegateHide);
    }
    if (eventType === 'mouseenter') {
      on('mouseover', onDelegateShow);
      on('mouseout', onDelegateHide);
    }
    if (eventType === 'focus') {
      on('focusin', onDelegateShow);
      on('focusout', onDelegateHide);
    }
    if (eventType === 'click') {
      on('click', onDelegateShow);
    }
  }

  return listeners;
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Returns an object of settings to override global settings
 * @param {Element} reference
 * @param {Object} instanceOptions
 * @return {Object} - individual options
 */
function getIndividualOptions(reference, instanceOptions) {
  var options = defaultsKeys.reduce(function (acc, key) {
    var val = reference.getAttribute('data-tippy-' + key.toLowerCase()) || instanceOptions[key];

    // Convert strings to booleans
    if (val === 'false') val = false;
    if (val === 'true') val = true;

    // Convert number strings to true numbers
    if (isFinite(val) && !isNaN(parseFloat(val))) {
      val = parseFloat(val);
    }

    // Convert array strings to actual arrays
    if (key !== 'target' && typeof val === 'string' && val.trim().charAt(0) === '[') {
      val = JSON.parse(val);
    }

    acc[key] = val;

    return acc;
  }, {});

  return _extends({}, instanceOptions, options);
}

/**
 * Evaluates/modifies the options object for appropriate behavior
 * @param {Element|Object} reference
 * @param {Object} options
 * @return {Object} modified/evaluated options
 */
function evaluateOptions(reference, options) {
  // animateFill is disabled if an arrow is true
  if (options.arrow) {
    options.animateFill = false;
  }

  if (options.appendTo && typeof options.appendTo === 'function') {
    options.appendTo = options.appendTo();
  }

  if (typeof options.html === 'function') {
    options.html = options.html(reference);
  }

  return options;
}

/**
 * Returns inner elements of the popper element
 * @param {Element} popper
 * @return {Object}
 */
function getInnerElements(popper) {
  var select = function select(s) {
    return popper.querySelector(s);
  };
  return {
    tooltip: select(selectors.TOOLTIP),
    backdrop: select(selectors.BACKDROP),
    content: select(selectors.CONTENT),
    arrow: select(selectors.ARROW) || select(selectors.ROUND_ARROW)
  };
}

/**
 * Removes the title from an element, setting `data-original-title`
 * appropriately
 * @param {Element} el
 */
function removeTitle(el) {
  var title = el.getAttribute('title');
  // Only set `data-original-title` attr if there is a title
  if (title) {
    el.setAttribute('data-original-title', title);
  }
  el.removeAttribute('title');
}

/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.4
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser$1 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser$1 && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE$1(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE$1(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE$1(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE$1(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck$1 = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass$1 = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty$1 = function defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$1({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE$1(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE$1(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE$1()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$1({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // Avoid blurry text by using full pixel integers.
  // For pixel-perfect positioning, top/bottom prefers rounded
  // values, while left/right prefers floored values.
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.round(popper.top),
    bottom: Math.round(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$1({}, attributes, data.attributes);
  data.styles = _extends$1({}, styles, data.styles);
  data.arrowStyles = _extends$1({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty$1(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty$1(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$1({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty$1({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty$1({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$1({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty$1({}, side, reference[side]),
      end: defineProperty$1({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$1({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck$1(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$1({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$1({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$1({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$1({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass$1(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */

    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */

Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/**
 * Triggers document reflow.
 * Use void because some minifiers or engines think simply accessing the property
 * is unnecessary.
 * @param {Element} popper
 */
function reflow(popper) {
  void popper.offsetHeight;
}

/**
 * Wrapper util for popper position updating.
 * Updates the popper's position and invokes the callback on update.
 * Hackish workaround until Popper 2.0's update() becomes sync.
 * @param {Popper} popperInstance
 * @param {Function} callback: to run once popper's position was updated
 * @param {Boolean} updateAlreadyCalled: was scheduleUpdate() already called?
 */
function updatePopperPosition(popperInstance, callback, updateAlreadyCalled) {
  var popper = popperInstance.popper,
      options = popperInstance.options;

  var onCreate = options.onCreate;
  var onUpdate = options.onUpdate;

  options.onCreate = options.onUpdate = function () {
    reflow(popper), callback && callback(), onUpdate();
    options.onCreate = onCreate;
    options.onUpdate = onUpdate;
  };

  if (!updateAlreadyCalled) {
    popperInstance.scheduleUpdate();
  }
}

/**
 * Returns the core placement ('top', 'bottom', 'left', 'right') of a popper
 * @param {Element} popper
 * @return {String}
 */
function getPopperPlacement(popper) {
  return popper.getAttribute('x-placement').replace(/-.+/, '');
}

/**
 * Determines if the mouse's cursor is outside the interactive border
 * @param {MouseEvent} event
 * @param {Element} popper
 * @param {Object} options
 * @return {Boolean}
 */
function cursorIsOutsideInteractiveBorder(event, popper, options) {
  if (!popper.getAttribute('x-placement')) return true;

  var x = event.clientX,
      y = event.clientY;
  var interactiveBorder = options.interactiveBorder,
      distance = options.distance;


  var rect = popper.getBoundingClientRect();
  var placement = getPopperPlacement(popper);
  var borderWithDistance = interactiveBorder + distance;

  var exceeds = {
    top: rect.top - y > interactiveBorder,
    bottom: y - rect.bottom > interactiveBorder,
    left: rect.left - x > interactiveBorder,
    right: x - rect.right > interactiveBorder
  };

  switch (placement) {
    case 'top':
      exceeds.top = rect.top - y > borderWithDistance;
      break;
    case 'bottom':
      exceeds.bottom = y - rect.bottom > borderWithDistance;
      break;
    case 'left':
      exceeds.left = rect.left - x > borderWithDistance;
      break;
    case 'right':
      exceeds.right = x - rect.right > borderWithDistance;
      break;
  }

  return exceeds.top || exceeds.bottom || exceeds.left || exceeds.right;
}

/**
 * Transforms the `arrowTransform` numbers based on the placement axis
 * @param {String} type 'scale' or 'translate'
 * @param {Number[]} numbers
 * @param {Boolean} isVertical
 * @param {Boolean} isReverse
 * @return {String}
 */
function transformNumbersBasedOnPlacementAxis(type, numbers, isVertical, isReverse) {
  if (!numbers.length) return '';

  var transforms = {
    scale: function () {
      if (numbers.length === 1) {
        return '' + numbers[0];
      } else {
        return isVertical ? numbers[0] + ', ' + numbers[1] : numbers[1] + ', ' + numbers[0];
      }
    }(),
    translate: function () {
      if (numbers.length === 1) {
        return isReverse ? -numbers[0] + 'px' : numbers[0] + 'px';
      } else {
        if (isVertical) {
          return isReverse ? numbers[0] + 'px, ' + -numbers[1] + 'px' : numbers[0] + 'px, ' + numbers[1] + 'px';
        } else {
          return isReverse ? -numbers[1] + 'px, ' + numbers[0] + 'px' : numbers[1] + 'px, ' + numbers[0] + 'px';
        }
      }
    }()
  };

  return transforms[type];
}

/**
 * Transforms the `arrowTransform` x or y axis based on the placement axis
 * @param {String} axis 'X', 'Y', ''
 * @param {Boolean} isVertical
 * @return {String}
 */
function transformAxis(axis, isVertical) {
  if (!axis) return '';
  var map = {
    X: 'Y',
    Y: 'X'
  };
  return isVertical ? axis : map[axis];
}

/**
 * Computes and applies the necessary arrow transform
 * @param {Element} popper
 * @param {Element} arrow
 * @param {String} arrowTransform
 */
function computeArrowTransform(popper, arrow, arrowTransform) {
  var placement = getPopperPlacement(popper);
  var isVertical = placement === 'top' || placement === 'bottom';
  var isReverse = placement === 'right' || placement === 'bottom';

  var getAxis = function getAxis(re) {
    var match = arrowTransform.match(re);
    return match ? match[1] : '';
  };

  var getNumbers = function getNumbers(re) {
    var match = arrowTransform.match(re);
    return match ? match[1].split(',').map(parseFloat) : [];
  };

  var re = {
    translate: /translateX?Y?\(([^)]+)\)/,
    scale: /scaleX?Y?\(([^)]+)\)/
  };

  var matches = {
    translate: {
      axis: getAxis(/translate([XY])/),
      numbers: getNumbers(re.translate)
    },
    scale: {
      axis: getAxis(/scale([XY])/),
      numbers: getNumbers(re.scale)
    }
  };

  var computedTransform = arrowTransform.replace(re.translate, 'translate' + transformAxis(matches.translate.axis, isVertical) + '(' + transformNumbersBasedOnPlacementAxis('translate', matches.translate.numbers, isVertical, isReverse) + ')').replace(re.scale, 'scale' + transformAxis(matches.scale.axis, isVertical) + '(' + transformNumbersBasedOnPlacementAxis('scale', matches.scale.numbers, isVertical, isReverse) + ')');

  arrow.style[prefix('transform')] = computedTransform;
}

/**
 * Returns the distance taking into account the default distance due to
 * the transform: translate setting in CSS
 * @param {Number} distance
 * @return {String}
 */
function getOffsetDistanceInPx(distance) {
  return -(distance - defaults.distance) + 'px';
}

var matches = {};

if (isBrowser) {
  var e = Element.prototype;
  matches = e.matches || e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector || function (s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s);
    var i = matches.length;
    while (--i >= 0 && matches.item(i) !== this) {} // eslint-disable-line no-empty
    return i > -1;
  };
}

var matches$1 = matches;

/**
 * Ponyfill to get the closest parent element
 * @param {Element} element - child of parent to be returned
 * @param {String} parentSelector - selector to match the parent if found
 * @return {Element}
 */
function closest(element, parentSelector) {
  var fn = Element.prototype.closest || function (selector) {
    var el = this;
    while (el) {
      if (matches$1.call(el, selector)) {
        return el;
      }
      el = el.parentElement;
    }
  };

  return fn.call(element, parentSelector);
}

/**
 * Returns the value taking into account the value being either a number or array
 * @param {Number|Array} value
 * @param {Number} index
 * @return {Number}
 */
function getValue(value, index) {
  return Array.isArray(value) ? value[index] : value;
}

/**
 * Sets the visibility state of an element for transition to begin
 * @param {Element[]} els - array of elements
 * @param {String} type - 'visible' or 'hidden'
 */
function setVisibilityState(els, type) {
  els.forEach(function (el) {
    if (!el) return;
    el.setAttribute('data-state', type);
  });
}

/**
 * Sets the transition property to each element
 * @param {Element[]} els - Array of elements
 * @param {String} value
 */
function applyTransitionDuration(els, value) {
  els.filter(Boolean).forEach(function (el) {
    el.style[prefix('transitionDuration')] = value + 'ms';
  });
}

/**
 * Focuses an element while preventing a scroll jump if it's not entirely within the viewport
 * @param {Element} el
 */
function focus(el) {
  var x = window.scrollX || window.pageXOffset;
  var y = window.scrollY || window.pageYOffset;
  el.focus();
  scroll(x, y);
}

var key = {};
var store = function store(data) {
  return function (k) {
    return k === key && data;
  };
};

var Tippy = function () {
  function Tippy(config) {
    classCallCheck(this, Tippy);

    for (var _key in config) {
      this[_key] = config[_key];
    }

    this.state = {
      destroyed: false,
      visible: false,
      enabled: true
    };

    this._ = store({
      mutationObservers: []
    });
  }

  /**
   * Enables the tooltip to allow it to show or hide
   * @memberof Tippy
   * @public
   */


  createClass(Tippy, [{
    key: 'enable',
    value: function enable() {
      this.state.enabled = true;
    }

    /**
     * Disables the tooltip from showing or hiding, but does not destroy it
     * @memberof Tippy
     * @public
     */

  }, {
    key: 'disable',
    value: function disable() {
      this.state.enabled = false;
    }

    /**
     * Shows the tooltip
     * @param {Number} duration in milliseconds
     * @memberof Tippy
     * @public
     */

  }, {
    key: 'show',
    value: function show(duration) {
      var _this = this;

      if (this.state.destroyed || !this.state.enabled) return;

      var popper = this.popper,
          reference = this.reference,
          options = this.options;

      var _getInnerElements = getInnerElements(popper),
          tooltip = _getInnerElements.tooltip,
          backdrop = _getInnerElements.backdrop,
          content = _getInnerElements.content;

      // If the `dynamicTitle` option is true, the instance is allowed
      // to be created with an empty title. Make sure that the tooltip
      // content is not empty before showing it


      if (options.dynamicTitle && !reference.getAttribute('data-original-title')) {
        return;
      }

      // Do not show tooltip if reference contains 'disabled' attribute. FF fix for #221
      if (reference.hasAttribute('disabled')) return;

      // Destroy tooltip if the reference element is no longer on the DOM
      if (!reference.refObj && !document.documentElement.contains(reference)) {
        this.destroy();
        return;
      }

      options.onShow.call(popper, this);

      duration = getValue(duration !== undefined ? duration : options.duration, 0);

      // Prevent a transition when popper changes position
      applyTransitionDuration([popper, tooltip, backdrop], 0);

      popper.style.visibility = 'visible';
      this.state.visible = true;

      _mount.call(this, function () {
        if (!_this.state.visible) return;

        if (!_hasFollowCursorBehavior.call(_this)) {
          // FIX: Arrow will sometimes not be positioned correctly. Force another update.
          _this.popperInstance.scheduleUpdate();
        }

        // Set initial position near the cursor
        if (_hasFollowCursorBehavior.call(_this)) {
          _this.popperInstance.disableEventListeners();
          var delay = getValue(options.delay, 0);
          var lastTriggerEvent = _this._(key).lastTriggerEvent;
          if (lastTriggerEvent) {
            _this._(key).followCursorListener(delay && _this._(key).lastMouseMoveEvent ? _this._(key).lastMouseMoveEvent : lastTriggerEvent);
          }
        }

        // Re-apply transition durations
        applyTransitionDuration([tooltip, backdrop, backdrop ? content : null], duration);

        if (backdrop) {
          getComputedStyle(backdrop)[prefix('transform')];
        }

        if (options.interactive) {
          reference.classList.add('tippy-active');
        }

        if (options.sticky) {
          _makeSticky.call(_this);
        }

        setVisibilityState([tooltip, backdrop], 'visible');

        _onTransitionEnd.call(_this, duration, function () {
          if (!options.updateDuration) {
            tooltip.classList.add('tippy-notransition');
          }

          if (options.interactive) {
            focus(popper);
          }

          reference.setAttribute('aria-describedby', 'tippy-' + _this.id);

          options.onShown.call(popper, _this);
        });
      });
    }

    /**
     * Hides the tooltip
     * @param {Number} duration in milliseconds
     * @memberof Tippy
     * @public
     */

  }, {
    key: 'hide',
    value: function hide(duration) {
      var _this2 = this;

      if (this.state.destroyed || !this.state.enabled) return;

      var popper = this.popper,
          reference = this.reference,
          options = this.options;

      var _getInnerElements2 = getInnerElements(popper),
          tooltip = _getInnerElements2.tooltip,
          backdrop = _getInnerElements2.backdrop,
          content = _getInnerElements2.content;

      options.onHide.call(popper, this);

      duration = getValue(duration !== undefined ? duration : options.duration, 1);

      if (!options.updateDuration) {
        tooltip.classList.remove('tippy-notransition');
      }

      if (options.interactive) {
        reference.classList.remove('tippy-active');
      }

      popper.style.visibility = 'hidden';
      this.state.visible = false;

      applyTransitionDuration([tooltip, backdrop, backdrop ? content : null], duration);

      setVisibilityState([tooltip, backdrop], 'hidden');

      if (options.interactive && options.trigger.indexOf('click') > -1) {
        focus(reference);
      }

      _onTransitionEnd.call(this, duration, function () {
        if (_this2.state.visible || !options.appendTo.contains(popper)) return;

        if (!_this2._(key).isPreparingToShow) {
          document.removeEventListener('mousemove', _this2._(key).followCursorListener);
          _this2._(key).lastMouseMoveEvent = null;
        }

        if (_this2.popperInstance) {
          _this2.popperInstance.disableEventListeners();
        }

        reference.removeAttribute('aria-describedby');

        options.appendTo.removeChild(popper);

        options.onHidden.call(popper, _this2);
      });
    }

    /**
     * Destroys the tooltip instance
     * @param {Boolean} destroyTargetInstances - relevant only when destroying delegates
     * @memberof Tippy
     * @public
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      var _this3 = this;

      var destroyTargetInstances = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.state.destroyed) return;

      // Ensure the popper is hidden
      if (this.state.visible) {
        this.hide(0);
      }

      this.listeners.forEach(function (listener) {
        _this3.reference.removeEventListener(listener.event, listener.handler);
      });

      // Restore title
      if (this.title) {
        this.reference.setAttribute('title', this.title);
      }

      delete this.reference._tippy;

      var attributes = ['data-original-title', 'data-tippy', 'data-tippy-delegate'];
      attributes.forEach(function (attr) {
        _this3.reference.removeAttribute(attr);
      });

      if (this.options.target && destroyTargetInstances) {
        toArray(this.reference.querySelectorAll(this.options.target)).forEach(function (child) {
          return child._tippy && child._tippy.destroy();
        });
      }

      if (this.popperInstance) {
        this.popperInstance.destroy();
      }

      this._(key).mutationObservers.forEach(function (observer) {
        observer.disconnect();
      });

      this.state.destroyed = true;
    }
  }]);
  return Tippy;
}();

/**
 * ------------------------------------------------------------------------
 * Private methods
 * ------------------------------------------------------------------------
 * Standalone functions to be called with the instance's `this` context to make
 * them truly private and not accessible on the prototype
 */

/**
 * Determines if the tooltip instance has followCursor behavior
 * @return {Boolean}
 * @memberof Tippy
 * @private
 */
function _hasFollowCursorBehavior() {
  var lastTriggerEvent = this._(key).lastTriggerEvent;
  return this.options.followCursor && !browser.usingTouch && lastTriggerEvent && lastTriggerEvent.type !== 'focus';
}

/**
 * Creates the Tippy instance for the child target of the delegate container
 * @param {Event} event
 * @memberof Tippy
 * @private
 */
function _createDelegateChildTippy(event) {
  var targetEl = closest(event.target, this.options.target);
  if (targetEl && !targetEl._tippy) {
    var title = targetEl.getAttribute('title') || this.title;
    if (title) {
      targetEl.setAttribute('title', title);
      tippy(targetEl, _extends({}, this.options, { target: null }));
      _enter.call(targetEl._tippy, event);
    }
  }
}

/**
 * Method used by event listeners to invoke the show method, taking into account delays and
 * the `wait` option
 * @param {Event} event
 * @memberof Tippy
 * @private
 */
function _enter(event) {
  var _this4 = this;

  var options = this.options;


  _clearDelayTimeouts.call(this);

  if (this.state.visible) return;

  // Is a delegate, create Tippy instance for the child target
  if (options.target) {
    _createDelegateChildTippy.call(this, event);
    return;
  }

  this._(key).isPreparingToShow = true;

  if (options.wait) {
    options.wait.call(this.popper, this.show.bind(this), event);
    return;
  }

  // If the tooltip has a delay, we need to be listening to the mousemove as soon as the trigger
  // event is fired so that it's in the correct position upon mount.
  if (_hasFollowCursorBehavior.call(this)) {
    if (!this._(key).followCursorListener) {
      _setFollowCursorListener.call(this);
    }

    var _getInnerElements3 = getInnerElements(this.popper),
        arrow = _getInnerElements3.arrow;

    if (arrow) arrow.style.margin = '0';
    document.addEventListener('mousemove', this._(key).followCursorListener);
  }

  var delay = getValue(options.delay, 0);

  if (delay) {
    this._(key).showTimeout = setTimeout(function () {
      _this4.show();
    }, delay);
  } else {
    this.show();
  }
}

/**
 * Method used by event listeners to invoke the hide method, taking into account delays
 * @memberof Tippy
 * @private
 */
function _leave() {
  var _this5 = this;

  _clearDelayTimeouts.call(this);

  if (!this.state.visible) return;

  this._(key).isPreparingToShow = false;

  var delay = getValue(this.options.delay, 1);

  if (delay) {
    this._(key).hideTimeout = setTimeout(function () {
      if (_this5.state.visible) {
        _this5.hide();
      }
    }, delay);
  } else {
    this.hide();
  }
}

/**
 * Returns relevant listeners for the instance
 * @return {Object} of listeners
 * @memberof Tippy
 * @private
 */
function _getEventListeners() {
  var _this6 = this;

  var onTrigger = function onTrigger(event) {
    if (!_this6.state.enabled) return;

    var shouldStopEvent = browser.supportsTouch && browser.usingTouch && ['mouseenter', 'mouseover', 'focus'].indexOf(event.type) > -1;

    if (shouldStopEvent && _this6.options.touchHold) return;

    _this6._(key).lastTriggerEvent = event;

    // Toggle show/hide when clicking click-triggered tooltips
    if (event.type === 'click' && _this6.options.hideOnClick !== 'persistent' && _this6.state.visible) {
      _leave.call(_this6);
    } else {
      _enter.call(_this6, event);
    }
  };

  var onMouseLeave = function onMouseLeave(event) {
    if (['mouseleave', 'mouseout'].indexOf(event.type) > -1 && browser.supportsTouch && browser.usingTouch && _this6.options.touchHold) return;

    if (_this6.options.interactive) {
      var hide = _leave.bind(_this6);

      var onMouseMove = function onMouseMove(event) {
        var referenceCursorIsOver = closest(event.target, selectors.REFERENCE);
        var cursorIsOverPopper = closest(event.target, selectors.POPPER) === _this6.popper;
        var cursorIsOverReference = referenceCursorIsOver === _this6.reference;

        if (cursorIsOverPopper || cursorIsOverReference) return;

        if (cursorIsOutsideInteractiveBorder(event, _this6.popper, _this6.options)) {
          document.body.removeEventListener('mouseleave', hide);
          document.removeEventListener('mousemove', onMouseMove);

          _leave.call(_this6, onMouseMove);
        }
      };

      document.body.addEventListener('mouseleave', hide);
      document.addEventListener('mousemove', onMouseMove);
      return;
    }

    _leave.call(_this6);
  };

  var onBlur = function onBlur(event) {
    if (event.target !== _this6.reference || browser.usingTouch) return;

    if (_this6.options.interactive) {
      if (!event.relatedTarget) return;
      if (closest(event.relatedTarget, selectors.POPPER)) return;
    }

    _leave.call(_this6);
  };

  var onDelegateShow = function onDelegateShow(event) {
    if (closest(event.target, _this6.options.target)) {
      _enter.call(_this6, event);
    }
  };

  var onDelegateHide = function onDelegateHide(event) {
    if (closest(event.target, _this6.options.target)) {
      _leave.call(_this6);
    }
  };

  return {
    onTrigger: onTrigger,
    onMouseLeave: onMouseLeave,
    onBlur: onBlur,
    onDelegateShow: onDelegateShow,
    onDelegateHide: onDelegateHide
  };
}

/**
 * Creates and returns a new popper instance
 * @return {Popper}
 * @memberof Tippy
 * @private
 */
function _createPopperInstance() {
  var _this7 = this;

  var popper = this.popper,
      reference = this.reference,
      options = this.options;

  var _getInnerElements4 = getInnerElements(popper),
      tooltip = _getInnerElements4.tooltip;

  var popperOptions = options.popperOptions;

  var arrowSelector = options.arrowType === 'round' ? selectors.ROUND_ARROW : selectors.ARROW;
  var arrow = tooltip.querySelector(arrowSelector);

  var config = _extends({
    placement: options.placement
  }, popperOptions || {}, {
    modifiers: _extends({}, popperOptions ? popperOptions.modifiers : {}, {
      arrow: _extends({
        element: arrowSelector
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.arrow : {}),
      flip: _extends({
        enabled: options.flip,
        padding: options.distance + 5 /* 5px from viewport boundary */
        , behavior: options.flipBehavior
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.flip : {}),
      offset: _extends({
        offset: options.offset
      }, popperOptions && popperOptions.modifiers ? popperOptions.modifiers.offset : {})
    }),
    onCreate: function onCreate() {
      tooltip.style[getPopperPlacement(popper)] = getOffsetDistanceInPx(options.distance);

      if (arrow && options.arrowTransform) {
        computeArrowTransform(popper, arrow, options.arrowTransform);
      }
    },
    onUpdate: function onUpdate() {
      var styles = tooltip.style;
      styles.top = '';
      styles.bottom = '';
      styles.left = '';
      styles.right = '';
      styles[getPopperPlacement(popper)] = getOffsetDistanceInPx(options.distance);

      if (arrow && options.arrowTransform) {
        computeArrowTransform(popper, arrow, options.arrowTransform);
      }
    }
  });

  _addMutationObserver.call(this, {
    target: popper,
    callback: function callback() {
      _this7.popperInstance.update();
    },
    options: {
      childList: true,
      subtree: true,
      characterData: true
    }
  });

  return new Popper(reference, popper, config);
}

/**
 * Appends the popper element to the DOM, updating or creating the popper instance
 * @param {Function} callback
 * @memberof Tippy
 * @private
 */
function _mount(callback) {
  var options = this.options;


  if (!this.popperInstance) {
    this.popperInstance = _createPopperInstance.call(this);
    if (!options.livePlacement) {
      this.popperInstance.disableEventListeners();
    }
  } else {
    this.popperInstance.scheduleUpdate();
    if (options.livePlacement && !_hasFollowCursorBehavior.call(this)) {
      this.popperInstance.enableEventListeners();
    }
  }

  // If the instance previously had followCursor behavior, it will be positioned incorrectly
  // if triggered by `focus` afterwards - update the reference back to the real DOM element
  if (!_hasFollowCursorBehavior.call(this)) {
    var _getInnerElements5 = getInnerElements(this.popper),
        arrow = _getInnerElements5.arrow;

    if (arrow) arrow.style.margin = '';
    this.popperInstance.reference = this.reference;
  }

  updatePopperPosition(this.popperInstance, callback, true);

  if (!options.appendTo.contains(this.popper)) {
    options.appendTo.appendChild(this.popper);
  }
}

/**
 * Clears the show and hide delay timeouts
 * @memberof Tippy
 * @private
 */
function _clearDelayTimeouts() {
  var _ref = this._(key),
      showTimeout = _ref.showTimeout,
      hideTimeout = _ref.hideTimeout;

  clearTimeout(showTimeout);
  clearTimeout(hideTimeout);
}

/**
 * Sets the mousemove event listener function for `followCursor` option
 * @memberof Tippy
 * @private
 */
function _setFollowCursorListener() {
  var _this8 = this;

  this._(key).followCursorListener = function (event) {
    var _$lastMouseMoveEvent = _this8._(key).lastMouseMoveEvent = event,
        clientX = _$lastMouseMoveEvent.clientX,
        clientY = _$lastMouseMoveEvent.clientY;

    if (!_this8.popperInstance) return;

    _this8.popperInstance.reference = {
      getBoundingClientRect: function getBoundingClientRect() {
        return {
          width: 0,
          height: 0,
          top: clientY,
          left: clientX,
          right: clientX,
          bottom: clientY
        };
      },
      clientWidth: 0,
      clientHeight: 0
    };

    _this8.popperInstance.scheduleUpdate();
  };
}

/**
 * Updates the popper's position on each animation frame
 * @memberof Tippy
 * @private
 */
function _makeSticky() {
  var _this9 = this;

  var applyTransitionDuration$$1 = function applyTransitionDuration$$1() {
    _this9.popper.style[prefix('transitionDuration')] = _this9.options.updateDuration + 'ms';
  };

  var removeTransitionDuration = function removeTransitionDuration() {
    _this9.popper.style[prefix('transitionDuration')] = '';
  };

  var updatePosition = function updatePosition() {
    if (_this9.popperInstance) {
      _this9.popperInstance.update();
    }

    applyTransitionDuration$$1();

    if (_this9.state.visible) {
      requestAnimationFrame(updatePosition);
    } else {
      removeTransitionDuration();
    }
  };

  updatePosition();
}

/**
 * Adds a mutation observer to an element and stores it in the instance
 * @param {Object}
 * @memberof Tippy
 * @private
 */
function _addMutationObserver(_ref2) {
  var target = _ref2.target,
      callback = _ref2.callback,
      options = _ref2.options;

  if (!window.MutationObserver) return;

  var observer = new MutationObserver(callback);
  observer.observe(target, options);

  this._(key).mutationObservers.push(observer);
}

/**
 * Fires the callback functions once the CSS transition ends for `show` and `hide` methods
 * @param {Number} duration
 * @param {Function} callback - callback function to fire once transition completes
 * @memberof Tippy
 * @private
 */
function _onTransitionEnd(duration, callback) {
  // Make callback synchronous if duration is 0
  if (!duration) {
    return callback();
  }

  var _getInnerElements6 = getInnerElements(this.popper),
      tooltip = _getInnerElements6.tooltip;

  var toggleListeners = function toggleListeners(action, listener) {
    if (!listener) return;
    tooltip[action + 'EventListener']('transition' in document.body.style ? 'transitionend' : 'webkitTransitionEnd', listener);
  };

  var listener = function listener(e) {
    if (e.target === tooltip) {
      toggleListeners('remove', listener);
      callback();
    }
  };

  toggleListeners('remove', this._(key).transitionendListener);
  toggleListeners('add', listener);

  this._(key).transitionendListener = listener;
}

var idCounter = 1;

/**
 * Creates tooltips for each reference element
 * @param {Element[]} els
 * @param {Object} config
 * @return {Tippy[]} Array of Tippy instances
 */
function createTooltips(els, config) {
  return els.reduce(function (acc, reference) {
    var id = idCounter;

    var options = evaluateOptions(reference, config.performance ? config : getIndividualOptions(reference, config));

    var title = reference.getAttribute('title');

    // Don't create an instance when:
    // * the `title` attribute is falsy (null or empty string), and
    // * it's not a delegate for tooltips, and
    // * there is no html template specified, and
    // * `dynamicTitle` option is false
    if (!title && !options.target && !options.html && !options.dynamicTitle) {
      return acc;
    }

    // Delegates should be highlighted as different
    reference.setAttribute(options.target ? 'data-tippy-delegate' : 'data-tippy', '');

    removeTitle(reference);

    var popper = createPopperElement(id, title, options);

    var tippy = new Tippy({
      id: id,
      reference: reference,
      popper: popper,
      options: options,
      title: title,
      popperInstance: null
    });

    if (options.createPopperInstanceOnInit) {
      tippy.popperInstance = _createPopperInstance.call(tippy);
      tippy.popperInstance.disableEventListeners();
    }

    var listeners = _getEventListeners.call(tippy);
    tippy.listeners = options.trigger.trim().split(' ').reduce(function (acc, eventType) {
      return acc.concat(createTrigger(eventType, reference, listeners, options));
    }, []);

    // Update tooltip content whenever the title attribute on the reference changes
    if (options.dynamicTitle) {
      _addMutationObserver.call(tippy, {
        target: reference,
        callback: function callback() {
          var _getInnerElements = getInnerElements(popper),
              content = _getInnerElements.content;

          var title = reference.getAttribute('title');
          if (title) {
            content[options.allowTitleHTML ? 'innerHTML' : 'textContent'] = tippy.title = title;
            removeTitle(reference);
          }
        },

        options: {
          attributes: true
        }
      });
    }

    // Shortcuts
    reference._tippy = tippy;
    popper._tippy = tippy;
    popper._reference = reference;

    acc.push(tippy);

    idCounter++;

    return acc;
  }, []);
}

/**
 * Hides all poppers
 * @param {Tippy} excludeTippy - tippy to exclude if needed
 */
function hideAllPoppers(excludeTippy) {
  var poppers = toArray(document.querySelectorAll(selectors.POPPER));

  poppers.forEach(function (popper) {
    var tippy = popper._tippy;
    if (!tippy) return;

    var options = tippy.options;


    if ((options.hideOnClick === true || options.trigger.indexOf('focus') > -1) && (!excludeTippy || popper !== excludeTippy.popper)) {
      tippy.hide();
    }
  });
}

/**
 * Adds the needed event listeners
 */
function bindEventListeners(useCapture) {
  var onDocumentTouch = function onDocumentTouch() {
    if (browser.usingTouch) return;

    browser.usingTouch = true;

    if (browser.iOS) {
      document.body.classList.add('tippy-touch');
    }

    if (browser.dynamicInputDetection && window.performance) {
      document.addEventListener('mousemove', onDocumentMouseMove);
    }

    browser.onUserInputChange('touch');
  };

  var onDocumentMouseMove = function () {
    var time = void 0;

    return function () {
      var now = performance.now();

      // Chrome 60+ is 1 mousemove per animation frame, use 20ms time difference
      if (now - time < 20) {
        browser.usingTouch = false;
        document.removeEventListener('mousemove', onDocumentMouseMove);
        if (!browser.iOS) {
          document.body.classList.remove('tippy-touch');
        }
        browser.onUserInputChange('mouse');
      }

      time = now;
    };
  }();

  var onDocumentClick = function onDocumentClick(event) {
    // Simulated events dispatched on the document
    if (!(event.target instanceof Element)) {
      return hideAllPoppers();
    }

    var reference = closest(event.target, selectors.REFERENCE);
    var popper = closest(event.target, selectors.POPPER);

    if (popper && popper._tippy && popper._tippy.options.interactive) {
      return;
    }

    if (reference && reference._tippy) {
      var options = reference._tippy.options;

      var isClickTrigger = options.trigger.indexOf('click') > -1;
      var isMultiple = options.multiple;

      // Hide all poppers except the one belonging to the element that was clicked
      if (!isMultiple && browser.usingTouch || !isMultiple && isClickTrigger) {
        return hideAllPoppers(reference._tippy);
      }

      if (options.hideOnClick !== true || isClickTrigger) {
        return;
      }
    }

    hideAllPoppers();
  };

  var onWindowBlur = function onWindowBlur() {
    var _document = document,
        el = _document.activeElement;

    if (el && el.blur && matches$1.call(el, selectors.REFERENCE)) {
      el.blur();
    }
  };

  var onWindowResize = function onWindowResize() {
    toArray(document.querySelectorAll(selectors.POPPER)).forEach(function (popper) {
      var tippyInstance = popper._tippy;
      if (tippyInstance && !tippyInstance.options.livePlacement) {
        tippyInstance.popperInstance.scheduleUpdate();
      }
    });
  };

  document.addEventListener('click', onDocumentClick, useCapture);
  document.addEventListener('touchstart', onDocumentTouch);
  window.addEventListener('blur', onWindowBlur);
  window.addEventListener('resize', onWindowResize);

  if (!browser.supportsTouch && (navigator.maxTouchPoints || navigator.msMaxTouchPoints)) {
    document.addEventListener('pointerdown', onDocumentTouch);
  }
}

var eventListenersBound = false;
var useCapture = false;

/**
 * Exported module
 * @param {String|Element|Element[]|NodeList|Object} selector
 * @param {Object} options
 * @param {Boolean} one - create one tooltip
 * @return {Object}
 */
function tippy(selector, options, one) {
  if (browser.supported && !eventListenersBound) {
    bindEventListeners(useCapture);
    eventListenersBound = true;
  }

  if (isObjectLiteral(selector)) {
    polyfillVirtualReferenceProps(selector);
  }

  options = _extends({}, defaults, options);

  var references = getArrayOfElements(selector);
  var firstReference = references[0];

  return {
    selector: selector,
    options: options,
    tooltips: browser.supported ? createTooltips(one && firstReference ? [firstReference] : references, options) : [],
    destroyAll: function destroyAll() {
      this.tooltips.forEach(function (tooltip) {
        return tooltip.destroy();
      });
      this.tooltips = [];
    }
  };
}

tippy.version = version;
tippy.browser = browser;
tippy.defaults = defaults;
tippy.one = function (selector, options) {
  return tippy(selector, options, true).tooltips[0];
};
tippy.disableAnimations = function () {
  defaults.updateDuration = defaults.duration = 0;
  defaults.animateFill = false;
};
tippy.useCapture = function () {
  useCapture = true;
};

/**
 * Injects CSS styles to document head
 * @param {String} css
 */
function injectCSS() {
  var css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (isBrowser && browser.supported) {
    var head = document.head || document.querySelector('head');
    var style = document.createElement('style');
    style.type = 'text/css';
    head.insertBefore(style, head.firstChild);

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }
}

injectCSS(styles);

return tippy;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ })

},[608]);


// WEBPACK FOOTER //
// eduhub.js